/**
 * Moteur de designs Idéocadeaux.
 * Un design = une liste de champs + une fonction de dessin sur <canvas>.
 * Le MÊME code sert à l'aperçu sur la fiche produit et au fichier d'impression HD envoyé à Gelato,
 * donc ce que le client voit est exactement ce qui est imprimé.
 */
(function () {
  // Anciens Safari (iOS ≤ 15, ex. iPhone 8 non mis à jour) : roundRect absent → l'aperçu planterait.
  const C2D = window.CanvasRenderingContext2D && CanvasRenderingContext2D.prototype;
  if (C2D && !C2D.roundRect) {
    C2D.roundRect = function (x, y, w, h, r) {
      r = Math.max(0, Math.min(Array.isArray(r) ? r[0] || 0 : r || 0, Math.abs(w) / 2, Math.abs(h) / 2));
      this.moveTo(x + r, y);
      this.arcTo(x + w, y, x + w, y + h, r);
      this.arcTo(x + w, y + h, x, y + h, r);
      this.arcTo(x, y + h, x, y, r);
      this.arcTo(x, y, x + w, y, r);
      this.closePath();
    };
  }
  if (!Array.prototype.at) {
    Array.prototype.at = function (i) { i = Math.trunc(i) || 0; if (i < 0) i += this.length; return this[i]; };
  }

  // Couleurs des designs. Sur un textile foncé (noir, marine), drawFace bascule sur la palette claire LIGHT le temps
  // du dessin (même mise en page, encre claire ; Gelato imprime une sous-couche blanche sous l'encre).
  let INK = '#2c1a15';
  let ACCENT = '#c74d38';
  let MUTED = '#7a6158';
  const PAPER = '#fbf6ef';
  let GOLD = '#b8893a';
  let KIDS = ['#c74d38', '#3f8f8a', '#b8893a', '#4a6fa5', '#8a5a9b'];
  let PINE = '#2f6b4f';
  const DEFAULT_PALETTE = { INK, ACCENT, MUTED, GOLD, KIDS, PINE };
  const LIGHT_PALETTE = { INK: '#f7f1e8', ACCENT: '#f08a6c', MUTED: '#d8cabd', GOLD: '#e6bd6a',
    KIDS: ['#f08a6c', '#6fcfc6', '#e6bd6a', '#8fb3ea', '#c79ad8'], PINE: '#6fc49a' };
  function setPalette(p) {
    ({ INK, ACCENT, MUTED, GOLD, KIDS, PINE } = p);
  }

  /** Petite étoile scintillante à 4 branches. */
  function sparkle(ctx, x, y, r, color) {
    ctx.save();
    ctx.fillStyle = color;
    ctx.beginPath();
    for (let i = 0; i < 8; i++) {
      const a = (Math.PI / 4) * i - Math.PI / 2;
      const rr = i % 2 === 0 ? r : r * 0.28;
      ctx.lineTo(x + Math.cos(a) * rr, y + Math.sin(a) * rr);
    }
    ctx.closePath();
    ctx.fill();
    ctx.restore();
  }

  /** Empreinte de patte (coussinet + 4 doigts). */
  function paw(ctx, x, y, s, color, angle) {
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(angle || 0);
    ctx.fillStyle = color;
    ctx.beginPath();
    ctx.ellipse(0, s * 0.35, s * 0.42, s * 0.34, 0, 0, Math.PI * 2);
    ctx.fill();
    [[-0.42, -0.12], [-0.15, -0.42], [0.15, -0.42], [0.42, -0.12]].forEach(([dx, dy]) => {
      ctx.beginPath();
      ctx.ellipse(dx * s, dy * s, s * 0.15, s * 0.19, 0, 0, Math.PI * 2);
      ctx.fill();
    });
    ctx.restore();
  }

  /** Liste de prénoms saisie par le client (séparés par virgules, « · » ou « & »). */
  function nameList(text, max) {
    return String(text || '').split(/\s*[,·&]\s*/).filter(Boolean).slice(0, max);
  }

  /** Découpe un texte en lignes qui tiennent dans maxWidth (police déjà réglée sur ctx). */
  function wrapLines(ctx, text, maxWidth) {
    const lines = [];
    let line = '';
    String(text).split(/\s+/).filter(Boolean).forEach((word) => {
      const test = line ? `${line} ${word}` : word;
      if (line && ctx.measureText(test).width > maxWidth) {
        lines.push(line);
        line = word;
      } else line = test;
    });
    if (line) lines.push(line);
    return lines;
  }

  /** Étoile à 5 branches. */
  function star(ctx, x, y, r, color) {
    ctx.save();
    ctx.fillStyle = color;
    ctx.beginPath();
    for (let i = 0; i < 10; i++) {
      const a = (Math.PI / 5) * i - Math.PI / 2;
      const rr = i % 2 === 0 ? r : r * 0.45;
      ctx.lineTo(x + Math.cos(a) * rr, y + Math.sin(a) * rr);
    }
    ctx.closePath();
    ctx.fill();
    ctx.restore();
  }

  /** Flocon de neige à 6 branches. */
  function snowflake(ctx, x, y, r, color) {
    ctx.save();
    ctx.translate(x, y);
    ctx.strokeStyle = color;
    ctx.lineWidth = Math.max(1, r * 0.12);
    ctx.lineCap = 'round';
    for (let i = 0; i < 6; i++) {
      ctx.rotate(Math.PI / 3);
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(0, -r);
      ctx.moveTo(0, -r * 0.55);
      ctx.lineTo(-r * 0.25, -r * 0.8);
      ctx.moveTo(0, -r * 0.55);
      ctx.lineTo(r * 0.25, -r * 0.8);
      ctx.stroke();
    }
    ctx.restore();
  }

  /** Feuille (ellipse effilée) orientée selon angle. */
  function leaf(ctx, x, y, len, angle, color) {
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(angle);
    ctx.fillStyle = color;
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.quadraticCurveTo(len * 0.5, -len * 0.3, len, 0);
    ctx.quadraticCurveTo(len * 0.5, len * 0.3, 0, 0);
    ctx.fill();
    ctx.restore();
  }

  /** Cœur plein centré en (x, y), de largeur ≈ 2r. */
  function heart(ctx, x, y, r, color) {
    ctx.save();
    ctx.fillStyle = color;
    ctx.beginPath();
    ctx.moveTo(x, y + r * 0.95);
    ctx.bezierCurveTo(x - r * 1.5, y + r * 0.1, x - r * 0.9, y - r * 1.05, x, y - r * 0.45);
    ctx.bezierCurveTo(x + r * 0.9, y - r * 1.05, x + r * 1.5, y + r * 0.1, x, y + r * 0.95);
    ctx.fill();
    ctx.restore();
  }

  /** Texte courbé sur un cercle : en haut (lecture de gauche à droite) ou en bas. */
  function arcText(ctx, text, cx, cy, r, top, size, font, color) {
    ctx.save();
    ctx.font = font(size);
    ctx.fillStyle = color;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    const chars = [...text];
    const gap = size * 0.12;
    const widths = chars.map((c) => ctx.measureText(c).width + gap);
    const total = widths.reduce((a, b) => a + b, 0) / r;
    let a = top ? -Math.PI / 2 - total / 2 : Math.PI / 2 + total / 2;
    chars.forEach((c, i) => {
      const da = widths[i] / r;
      const mid = top ? a + da / 2 : a - da / 2;
      ctx.save();
      ctx.translate(cx + Math.cos(mid) * r, cy + Math.sin(mid) * r);
      ctx.rotate(top ? mid + Math.PI / 2 : mid - Math.PI / 2);
      ctx.fillText(c, 0, 0);
      ctx.restore();
      a = top ? a + da : a - da;
    });
    ctx.restore();
  }

  /** Maille de tricot (un « V ») pour les motifs de pull de Noël. */
  function stitch(ctx, x, y, c, color) {
    ctx.fillStyle = color;
    [-1, 1].forEach((s) => {
      ctx.beginPath();
      ctx.ellipse(x + s * c * 0.2, y, c * 0.24, c * 0.44, s * 0.5, 0, Math.PI * 2);
      ctx.fill();
    });
  }

  /** Collage : grille de photos (cols × rows) aux coins arrondis, titre et sous-titre en dessous. */
  function drawCollage(ctx, w, h, v, cols, rows) {
    const imgs = v._images || [];
    const gap = w * 0.025, gridH = h * 0.76;
    const cw = (w - gap * (cols - 1)) / cols, ch = (gridH - gap * (rows - 1)) / rows;
    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < cols; c++) {
        const i = r * cols + c, x = c * (cw + gap), y = r * (ch + gap);
        ctx.save();
        ctx.beginPath();
        ctx.roundRect(x, y, cw, ch, Math.min(cw, ch) * 0.04);
        ctx.clip();
        drawPhoto(ctx, imgs[i] || null, x, y, cw, ch);
        ctx.restore();
      }
    }
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';
    fitText(ctx, v.titre, w / 2, h * 0.9, w * 0.94, h * 0.1, (z) => `${z}px 'Pinyon Script'`, ACCENT);
    if (v.sous_titre) caps(ctx, v.sous_titre, w / 2, h * 0.975, w * 0.7, h * 0.028, MUTED, 600);
  }

  /** Filet horizontal avec un cœur au centre. */
  function heartRule(ctx, cx, y, w, h) {
    ctx.save();
    ctx.strokeStyle = ACCENT;
    ctx.globalAlpha = 0.6;
    ctx.lineWidth = Math.max(2, h * 0.005);
    ctx.beginPath();
    ctx.moveTo(cx - w * 0.17, y);
    ctx.lineTo(cx - w * 0.04, y);
    ctx.moveTo(cx + w * 0.04, y);
    ctx.lineTo(cx + w * 0.17, y);
    ctx.stroke();
    ctx.globalAlpha = 1;
    ctx.fillStyle = ACCENT;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.font = `${h * 0.06}px 'Geist'`;
    ctx.fillText('♥', cx, y + h * 0.004);
    ctx.restore();
  }

  /** Texte en capitales espacées (petites mentions). */
  function caps(ctx, text, x, y, maxWidth, size, color, weight) {
    ctx.save();
    ctx.letterSpacing = `${size * 0.18}px`;
    fitText(ctx, String(text).toUpperCase(), x, y, maxWidth, size, (z) => `${weight || 500} ${z}px 'Geist'`, color);
    ctx.restore();
  }

  /** Photo « cover » dans un rectangle, ou un fond avec « Votre photo ici ». */
  /** Tableau photo : photo sur toute la largeur, bandeau crème en bas ; renvoie [haut du bandeau, hauteur du bandeau]. */
  function photoBand(ctx, w, h, v) {
    const bh = Math.min(h * 0.2, w * 0.2);
    ctx.fillStyle = PAPER;
    ctx.fillRect(0, 0, w, h);
    drawPhoto(ctx, v._image, 0, 0, w, h - bh);
    return [h - bh, bh];
  }

  /** Texte du bandeau d'un tableau photo : ligne principale + ligne en capitales (facultative). */
  function bandText(ctx, w, y0, bh, main, sub, font, color) {
    const two = !!(sub && String(sub).trim());
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';
    fitText(ctx, main, w / 2, y0 + bh * (two ? 0.56 : 0.68), w * 0.86, bh * (two ? 0.44 : 0.52), font, color);
    if (two) caps(ctx, sub, w / 2, y0 + bh * 0.85, w * 0.8, bh * 0.125, MUTED, 600);
  }

  /** Mosaïque de 6 photos en grille (orientation suivie), bandeau de titre facultatif ; renvoie la hauteur du bandeau. */
  function mosaic(ctx, w, h, v) {
    const land = w > h;
    const cols = land ? 3 : 2, rows = land ? 2 : 3;
    const band = v.titre && String(v.titre).trim() ? Math.min(h * 0.16, w * 0.16) : 0;
    const gap = Math.min(w, h) * 0.012;
    ctx.fillStyle = PAPER;
    ctx.fillRect(0, 0, w, h);
    const gh = h - band - (band ? gap : 0);
    const cw = (w - gap * (cols - 1)) / cols, ch = (gh - gap * (rows - 1)) / rows;
    const imgs = v._images || [];
    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < cols; c++) drawPhoto(ctx, imgs[r * cols + c] || null, c * (cw + gap), r * (ch + gap), cw, ch);
    }
    return band;
  }

  function drawPhoto(ctx, img, x, y, w, h) {
    if (img) {
      const k = Math.max(w / img.width, h / img.height);
      const dw = img.width * k, dh = img.height * k;
      ctx.save();
      ctx.beginPath();
      ctx.rect(x, y, w, h);
      ctx.clip();
      ctx.drawImage(img, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
      ctx.restore();
    } else {
      ctx.fillStyle = '#efe6da';
      ctx.fillRect(x, y, w, h);
      ctx.fillStyle = MUTED;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.font = `500 ${h * 0.09}px 'Geist'`;
      ctx.fillText('Votre photo ici', x + w / 2, y + h / 2);
    }
  }

  /* Formats d'impression (300 dpi). Le mug est une bande qui fait le tour : le design est
     imprimé sur les deux faces (gauchers et droitiers voient le design). */
  const MM = 300 / 25.4; // pixels par millimètre à 300 dpi
  const px = (mm) => Math.round(mm * MM);
  const pxd = (mm, dpi) => Math.round((mm * dpi) / 25.4);

  /* Fichiers d'impression, d'après les spécifications Gelato.
     width/height : taille totale du fichier ; face : zone visible du produit (hors fond perdu / retour
     sur châssis) ; faces : nombre de faces imprimées ; centers : position du centre de chaque face
     (en fraction de la largeur) pour le mug. */
  const FORMATS = {
    // Broderie (Gelato, 01/10/2026) : PNG 300 dpi transparent, brodé tel quel dans la zone (brouillons, data/emb_probe.py) ;
    // casquette et bonnet : devant (« front-embroidery ») ; sweat, capuche, polo : cœur de poitrine (« chest-left-embroidery »).
    // emb : le fichier est ramené aux fils Gelato (threadify) ; mm : taille réelle (texte ≥ 6,4 mm, traits ≥ 1,3 mm).
    'brode-casquette': { width: px(100), height: px(50), face: { x: 0, y: 0, w: px(100), h: px(50) }, faces: 1, background: null, margin: [0.03, 0.06], emb: true, mm: [100, 50] },
    'brode-bonnet': { width: px(90), height: px(40), face: { x: 0, y: 0, w: px(90), h: px(40) }, faces: 1, background: null, margin: [0.03, 0.06], emb: true, mm: [90, 40] },
    'brode-poitrine': { width: px(90), height: px(45), face: { x: 0, y: 0, w: px(90), h: px(45) }, faces: 1, background: null, margin: [0.03, 0.06], emb: true, mm: [90, 45] },
    'brode-polo': { width: px(80), height: px(40), face: { x: 0, y: 0, w: px(80), h: px(40) }, faces: 1, background: null, margin: [0.03, 0.06], emb: true, mm: [80, 40] },
    // Mug 11 oz : zone imprimable 200 × 96 mm, centrée à l'opposé de l'anse. Tour du mug ≈ 251 mm :
    // une face à 90° de l'anse est à 251/4 - (251 - 200)/2 = 37,3 mm du bord du fichier (18,6 %).
    mug: { width: px(200), height: px(96), faces: 2, centers: [0.186, 0.814], faceWidth: 0.36, background: null, margin: [0.06, 0.08] },
    // Grand mug 15 oz (440 ml, Ø 87 mm, 117 mm de haut) : fichier 240 × 117 mm (tour ≈ 273 mm, 33 mm libres sous l'anse) ;
    // faces à 90° de l'anse : 273/4 - 33/2 = 51,8 mm du bord (21,6 %). Validé par commande brouillon (designs/mugwrap.py).
    // Gourde inox 17 oz (Ø 70 mm) : fichier au ratio 0,783 (102 × 130 mm, imprimé quasi à l'échelle 1, sur ≈ 160° du tour ;
    // mire en commande brouillon, rayon mesuré 36,1 mm). Design 3:4 de 62 mm de large au centre (≈ 100°, lisible de face),
    // marges hautes et basses larges (l'aperçu Gelato rogne ≈ 5 mm en haut et en bas).
    gourde: { width: px(102), height: px(130), face: { x: px(20), y: px(23.7), w: px(62), h: px(82.6) }, faces: 1, centers: [0.5],
      faceWidth: 0.608, background: null, margin: [0.02, 0.02] },
    // Coque de téléphone fine / renforcée (Gelato, impression enveloppante face + tranches) : fichier 100 × 170 mm, que Gelato
    // centre sur la face avant de tout modèle (la face couvre ≈ 70 × 140 mm du fichier ; mires sur iPhone 12 mini, 15,
    // 16 Pro Max, Galaxy S23 Ultra). Design 3:4 au centre, sous le bloc photo.
    // iPhone : design de 62 à 140 mm (sous le bloc photo, 57 mm sur l'iPhone 16 Pro Max) ; Samsung : de 66 à 141 mm (la colonne
    // d'objectifs des Galaxy descend jusqu'à ≈ 63 mm). Validé par brouillons (16 Pro Max, S23 Ultra).
    coque: { width: px(100), height: px(170), face: { x: px(20.75), y: px(62), w: px(58.5), h: px(78) }, faces: 1, background: null, margin: [0.02, 0.02] },
    'coque-samsung': { width: px(100), height: px(170), face: { x: px(21.9), y: px(66), w: px(56.25), h: px(75) }, faces: 1, background: null, margin: [0.02, 0.02] },
    mug15: { width: px(240), height: px(117), faces: 2, centers: [0.216, 0.784], faceWidth: 0.366, background: null, margin: [0.06, 0.08] },
    // Affiche 30 × 40 : 4 mm de fond perdu par côté
    poster: { width: px(308), height: px(408), face: { x: px(4), y: px(4), w: px(300), h: px(400) }, faces: 1, background: PAPER, margin: [0.06, 0.08] },
    // Affiches grand format 45 × 60 et 60 × 80 : 4 mm de fond perdu par côté (mesuré par commande brouillon)
    poster45: { width: px(458), height: px(608), face: { x: px(4), y: px(4), w: px(450), h: px(600) }, faces: 1, background: PAPER, margin: [0.06, 0.08] },
    poster60: { width: px(608), height: px(808), face: { x: px(4), y: px(4), w: px(600), h: px(800) }, faces: 1, background: PAPER, margin: [0.06, 0.08] },
    // Toile 30 × 40 châssis fin 2 cm : 34 mm de retour + 15 mm de fond perdu par côté
    canvas: { width: px(398), height: px(498), face: { x: px(49), y: px(49), w: px(300), h: px(400) }, faces: 1, background: PAPER, margin: [0.07, 0.08] },
    // Toiles 45 × 60 et 60 × 80 (même châssis fin) : mêmes 49 mm par côté (mire en commande brouillon, 27/09/2026)
    canvas45: { width: px(548), height: px(698), face: { x: px(49), y: px(49), w: px(450), h: px(600) }, faces: 1, background: PAPER, margin: [0.07, 0.08] },
    canvas60: { width: px(698), height: px(898), face: { x: px(49), y: px(49), w: px(600), h: px(800) }, faces: 1, background: PAPER, margin: [0.07, 0.08] },
    // Tote bag 38 × 42 cm : zone d'impression carrée (≈ 25 × 25 cm, mesurée par commande brouillon ; Gelato
    // recadre au centre tout fichier non carré). Fond transparent : le coton naturel reste visible autour du design,
    // qui garde les proportions d'une face de mug (3:4), centré dans le carré.
    tote: { width: px(254), height: px(254), face: { x: px(31.75), y: 0, w: px(190.5), h: px(254) }, faces: 1, background: null, margin: [0.04, 0.04] },
    // Textile : Gelato ajuste le fichier à la zone d'impression (mesuré par commande brouillon) → fichiers 3:4 transparents.
    // T-shirt adulte : zone poitrine, fichier 30 × 40 cm ; body bébé : fichier 15 × 20 cm.
    tshirt: { width: px(300), height: px(400), face: { x: 0, y: 0, w: px(300), h: px(400) }, faces: 1, background: null, margin: [0.02, 0.02] },
    body: { width: px(150), height: px(200), face: { x: 0, y: 0, w: px(150), h: px(200) }, faces: 1, background: null, margin: [0.02, 0.02] },
    // Sweat col rond (Gildan 18000) : tout le fichier 30 × 40 cm est imprimé (mire en commande brouillon).
    sweat: { width: px(300), height: px(400), face: { x: 0, y: 0, w: px(300), h: px(400) }, faces: 1, background: null, margin: [0.02, 0.02] },
    // Sweat à capuche (Gildan 18500) : Gelato ne garde qu'un carré de 30 × 30 cm au-dessus de la poche (il RECADRE un
    // fichier 3:4 : haut et bas perdus). Fichier carré, design 3:4 entier au centre, côtés transparents.
    hoodie: { width: px(300), height: px(300), face: { x: px(37.5), y: 0, w: px(225), h: px(300) }, faces: 1, background: null, margin: [0.02, 0.02] },
    // T-shirt enfant (Gildan 5000B) : Gelato ne garde que 300 × 360 mm d'un fichier 3:4 (mire : 20 → 380 mm) → fichier
    // 300 × 360 mm, design 3:4 entier au centre. Le sweat à capuche enfant (18500B) reprend le carré « hoodie ».
    'tshirt-kids': { width: px(300), height: px(360), face: { x: px(15), y: 0, w: px(270), h: px(360) }, faces: 1, background: null, margin: [0.02, 0.02] },
    // Carte pliée A6 (lot de 10 avec enveloppes) : PDF de 2 pages 216 × 154 mm, 3 mm de fond perdu, pli vertical au centre.
    // Page 1 = extérieur (moitié gauche : verso ; moitié droite : recto), page 2 = intérieur. Mesuré par commande brouillon.
    card: { width: px(216), height: px(154), bleed: px(3), safeTop: px(3 + 6), safeSide: px(3 + 6), background: PAPER, pages: 2 },
    // Cartes pliées A5 (lot de 10) : PDF 2 pages 302 × 216 mm, 3 mm de fond perdu (validé par commande brouillon),
    // même mise en page que l'A6 (mêmes proportions)
    'card-a5': { width: px(302), height: px(216), bleed: px(3), safeTop: px(3 + 6), safeSide: px(3 + 6), background: PAPER, pages: 2 },
    // Calendrier mural A4 portrait : 218 × 305 mm (4 mm de fond perdu), 14 pages, reliure en haut
    calendar: { width: px(218), height: px(305), bleed: px(4), safeTop: px(4 + 12), safeSide: px(4 + 5), background: PAPER, pages: 14 },
    // Calendrier mural A3 portrait : 305 × 428 mm (4 mm de fond perdu, validé par commande brouillon), même mise en page
    // que l'A4 (mêmes proportions) ; 280 dpi pour rester sous la limite des canvas de Safari (16 Mpx)
    'calendar-a3': { width: pxd(305, 280), height: pxd(428, 280), bleed: pxd(4, 280), safeTop: pxd(16, 280), safeSide: pxd(9, 280),
      background: PAPER, pages: 14, dpi: 280 },
  };
  // Tableaux en paysage (références Gelato « _hor ») : mêmes fichiers tournés d'un quart de tour
  ['poster', 'poster45', 'poster60', 'canvas', 'canvas45', 'canvas60'].forEach((key) => {
    const f = FORMATS[key];
    FORMATS[`${key}-h`] = { ...f, width: f.height, height: f.width, face: { x: f.face.y, y: f.face.x, w: f.face.h, h: f.face.w },
      margin: [f.margin[1], f.margin[0]] };
  });

  /** Écrit un texte centré en réduisant la taille jusqu'à ce qu'il tienne dans maxWidth. */
  function fitText(ctx, text, x, y, maxWidth, size, font, color) {
    let s = size;
    ctx.font = font(s);
    while (s > 6 && ctx.measureText(text).width > maxWidth) {
      s *= 0.95;
      ctx.font = font(s);
    }
    ctx.fillStyle = color;
    ctx.fillText(text, x, y);
    return s;
  }


  const MOIS = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

  /** Date de Pâques (algorithme de Meeus/Jones/Butcher). */
  function easter(y) {
    const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(y, month - 1, day));
  }

  /** Jours fériés en France métropolitaine : { 'M-D': 'nom' }. */
  function holidays(y) {
    const out = { '1-1': "Jour de l'an", '5-1': 'Fête du Travail', '5-8': 'Victoire 1945', '7-14': 'Fête nationale',
      '8-15': 'Assomption', '11-1': 'Toussaint', '11-11': 'Armistice', '12-25': 'Noël' };
    const e = easter(y);
    [[1, 'Lundi de Pâques'], [39, 'Ascension'], [50, 'Lundi de Pentecôte']].forEach(([n, name]) => {
      const d = new Date(e.getTime() + n * 86400000);
      out[`${d.getUTCMonth() + 1}-${d.getUTCDate()}`] = name;
    });
    return out;
  }

  /** Anniversaires saisis par le client : « Léa 12/03, Tom 4/7 » → { '3-12': ['Léa'], '7-4': ['Tom'] }. */
  function birthdays(text) {
    const out = {};
    String(text || '').split(/[,;\n]+/).forEach((part) => {
      const m = part.trim().match(/^(.*?)\s*(\d{1,2})\s*[/.-]\s*(\d{1,2})$/);
      if (!m || !m[1]) return;
      const key = `${parseInt(m[3], 10)}-${parseInt(m[2], 10)}`;
      (out[key] = out[key] || []).push(m[1].trim());
    });
    return out;
  }

  /**
   * Grille d'un mois (lundi en premier) entre gy (ligne des jours) et bottom : fériés en couleur,
   * anniversaires (cœur + prénom), légende en bas. opts : { lines, bd, compact }.
   */
  function drawMonthGrid(ctx, x0, x1, gy, bottom, year, m, H, opts) {
    const cw = x1 - x0, colW = cw / 7;
    ctx.textAlign = 'center';
    ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'].forEach((d, i) =>
      caps(ctx, d, x0 + colW * (i + 0.5), gy, colW * 0.9, H * 0.014, i > 4 ? ACCENT : MUTED, 600)
    );
    const first = (new Date(Date.UTC(year, m, 1)).getUTCDay() + 6) % 7; // 0 = lundi
    const days = new Date(Date.UTC(year, m + 1, 0)).getUTCDate();
    const rows = Math.ceil((first + days) / 7);
    const hol = holidays(year);
    const bd = opts.bd || {};
    const legend = bottom - H * 0.03;
    const gridTop = gy + H * 0.012;
    const rowH = (legend - H * 0.028 - gridTop) / rows;
    if (opts.lines !== false) {
      ctx.strokeStyle = '#e8ded2';
      ctx.lineWidth = Math.max(2, cw * 0.0007);
      for (let r = 0; r <= rows; r++) {
        ctx.beginPath();
        ctx.moveTo(x0, gridTop + r * rowH);
        ctx.lineTo(x1, gridTop + r * rowH);
        ctx.stroke();
      }
    }
    const found = [];
    for (let d = 1; d <= days; d++) {
      const idx = first + d - 1, col = idx % 7, row = Math.floor(idx / 7);
      const name = hol[`${m + 1}-${d}`];
      const who = bd[`${m + 1}-${d}`];
      const center = opts.lines === false;
      const cx = center ? x0 + colW * (col + 0.5) : x0 + colW * col + colW * 0.12;
      const cy = gridTop + row * rowH + rowH * (who ? 0.36 : 0.42);
      ctx.textAlign = center ? 'center' : 'left';
      ctx.fillStyle = name || col > 4 ? ACCENT : INK;
      ctx.font = `${name ? 600 : 400} ${rowH * (center ? 0.3 : 0.34)}px 'Geist'`;
      ctx.fillText(String(d), cx, cy);
      if (who) {
        heart(ctx, x0 + colW * (col + 0.82), gridTop + row * rowH + rowH * 0.22, rowH * 0.1, ACCENT);
        ctx.textAlign = 'left';
        fitText(ctx, who.join(', '), x0 + colW * col + colW * 0.1, gridTop + row * rowH + rowH * 0.82, colW * 0.88, rowH * 0.33, (z) => `${z}px 'Caveat'`, ACCENT);
      }
      if (name) found.push(`${d} ${name}`);
    }
    if (found.length) {
      ctx.textAlign = 'left';
      fitText(ctx, found.join('  ·  '), x0, legend, cw, H * 0.015, (z) => `${z}px 'Geist'`, MUTED);
    }
  }

  /**
   * Une page de calendrier sur le fichier complet (W × H, fond perdu compris).
   * style : 'classique' | 'plein' (photo à bord perdu) | 'minimal' (photo encadrée, grille aérée) | 'anniversaires'.
   */
  function drawCalendarPage(ctx, W, H, v, page, safe, style) {
    style = style || 'classique';
    const year = parseInt(v.annee, 10) || 2027;
    const imgs = v._images || [];
    const img = (i) => (imgs.length ? imgs[i % imgs.length] : null);
    const x0 = safe.side, x1 = W - safe.side, cw = x1 - x0;
    const top = safe.top, bottom = H - (safe.bottom || safe.side), ih = bottom - top;
    const bd = style === 'anniversaires' ? birthdays(v.anniversaires) : null;
    ctx.save();
    ctx.textBaseline = 'alphabetic';
    if (page === 13) {
      // page de fin : discrète
      ctx.textAlign = 'center';
      fitText(ctx, 'Idéocadeaux', W / 2, bottom - ih * 0.05, cw * 0.4, ih * 0.025, (z) => `italic ${z}px 'Instrument Serif'`, MUTED);
    } else if (style === 'plein') {
      if (page === 0) {
        // couverture : photo sur toute la page, titre sur un voile sombre en bas
        drawPhoto(ctx, img(0), 0, 0, W, H);
        const g = ctx.createLinearGradient(0, H * 0.55, 0, H);
        g.addColorStop(0, 'rgba(20,12,10,0)');
        g.addColorStop(1, 'rgba(20,12,10,.6)');
        ctx.fillStyle = g;
        ctx.fillRect(0, H * 0.55, W, H * 0.45);
        ctx.textAlign = 'center';
        fitText(ctx, v.titre, W / 2, bottom - ih * 0.09, cw * 0.9, ih * 0.1, (z) => `${z}px 'Pinyon Script'`, '#ffffff');
        caps(ctx, String(year), W / 2, bottom - ih * 0.03, cw * 0.4, ih * 0.03, '#ffffff', 700);
      } else {
        // mois : photo à bord perdu sur le haut de la page (sous la reliure), nom du mois centré, grille
        const ph = H * 0.56;
        drawPhoto(ctx, img(page), 0, 0, W, ph);
        const hy = ph + ih * 0.075;
        ctx.textAlign = 'center';
        fitText(ctx, `${MOIS[page - 1]} ${year}`, W / 2, hy, cw * 0.9, ih * 0.05, (z) => `600 ${z}px 'Geist'`, INK);
        drawMonthGrid(ctx, x0, x1, hy + ih * 0.045, bottom, year, page - 1, ih, { lines: false });
      }
    } else if (style === 'minimal') {
      if (page === 0) {
        // couverture : photo carrée encadrée de blanc, titre en capitales espacées
        const s = Math.min(cw * 0.86, ih * 0.62), px = W / 2 - s / 2, py = top + ih * 0.06;
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(px - s * 0.04, py - s * 0.04, s * 1.08, s * 1.08);
        drawPhoto(ctx, img(0), px, py, s, s);
        ctx.textAlign = 'center';
        caps(ctx, v.titre, W / 2, py + s + ih * 0.12, cw * 0.9, ih * 0.035, INK, 700);
        fitText(ctx, String(year), W / 2, py + s + ih * 0.22, cw * 0.5, ih * 0.08, (z) => `${z}px 'Instrument Serif'`, ACCENT);
      } else {
        const s = Math.min(cw * 0.78, ih * 0.44), px = W / 2 - s * 0.66, py = top + ih * 0.03;
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(px - s * 0.035, py - s * 0.035, s * 1.32 + s * 0.07, s + s * 0.07);
        drawPhoto(ctx, img(page), px, py, s * 1.32, s);
        const hy = py + s + ih * 0.11;
        ctx.textAlign = 'left';
        fitText(ctx, String(page).padStart(2, '0'), x0, hy, cw * 0.3, ih * 0.09, (z) => `${z}px 'Instrument Serif'`, ACCENT);
        caps(ctx, MOIS[page - 1], x0 + cw * 0.26, hy - ih * 0.01, cw * 0.5, ih * 0.026, INK, 700);
        ctx.textAlign = 'right';
        caps(ctx, String(year), x1, hy - ih * 0.01, cw * 0.2, ih * 0.02, MUTED, 600);
        drawMonthGrid(ctx, x0, x1, hy + ih * 0.05, bottom, year, page - 1, ih, { lines: false });
      }
    } else if (page === 0) {
      // classique / anniversaires — couverture : grande photo, titre et année
      const ph = ih * 0.72;
      drawPhoto(ctx, img(0), x0, top, cw, ph);
      const fy = top + ph + (ih - ph) * 0.62;
      ctx.textAlign = 'left';
      fitText(ctx, v.titre, x0, fy, cw * 0.62, ih * 0.12, (z) => `${z}px 'Pinyon Script'`, ACCENT);
      ctx.textAlign = 'right';
      fitText(ctx, String(year), x1, fy + ih * 0.02, cw * 0.4, ih * 0.16, (z) => `${z}px 'Instrument Serif'`, INK);
      ctx.textAlign = 'left';
      caps(ctx, style === 'anniversaires' ? 'Les anniversaires de la famille' : 'Nos plus beaux moments', x0, fy + ih * 0.07, cw * 0.55, ih * 0.018, MUTED, 600);
    } else {
      const ph = ih * 0.5;
      drawPhoto(ctx, img(page), x0, top, cw, ph);
      const hy = top + ph + ih * 0.085;
      ctx.textAlign = 'left';
      fitText(ctx, MOIS[page - 1], x0, hy, cw * 0.7, ih * 0.07, (z) => `italic ${z}px 'Instrument Serif'`, ACCENT);
      ctx.textAlign = 'right';
      caps(ctx, String(year), x1, hy, cw * 0.3, ih * 0.022, MUTED, 600);
      drawMonthGrid(ctx, x0, x1, hy + ih * 0.05, bottom, year, page - 1, ih, { bd });
    }
    ctx.restore();
  }

  const DESIGNS = {
    /* « Mamie d'amour », « Papy d'amour », « Maman d'amour »… */
    'titre-prenoms': {
      art: ['couronne'],
      fields: [
        { key: 'titre', label: 'Titre', max: 14, default: 'Mamie' },
        { key: 'sous_titre', label: 'Sous-titre', max: 20, default: "d'amour" },
        { key: 'prenoms', label: 'Prénoms', max: 40, default: 'Léa · Tom · Jules', hint: 'Séparez les prénoms par « · » ou « & »', hero: true },
      ],
      draw(ctx, w, h, v) {
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        const cx = w / 2;
        const cy = h / 2;
        // couronne aquarelle carrée, centrée ; les textes tiennent dans son centre
        const S = Math.min(w, h) * 0.98;
        drawArt(ctx, artImage('couronne'), cx - S / 2, cy - S / 2, S, S);
        const inner = S * 0.5;
        // titre script ; si ses jambages (p, y, g…) descendent, le reste du design est décalé vers le bas
        const titleFont = (z) => `${z}px 'Pinyon Script'`;
        let ts = S * 0.25;
        ctx.font = titleFont(ts);
        while (ts > 6 && (ctx.measureText(v.titre).width > inner || ctx.measureText(v.titre).actualBoundingBoxDescent > S * 0.07)) {
          ts *= 0.95;
          ctx.font = titleFont(ts);
        }
        const descent = Math.max(ctx.measureText(v.titre).actualBoundingBoxDescent, S * 0.02);
        const y1 = cy - S * 0.05;
        const y2 = y1 + descent + S * 0.08;
        ctx.fillStyle = ACCENT;
        ctx.fillText(v.titre, cx, y1);
        fitText(ctx, v.sous_titre, cx, y2, inner * 0.9, S * 0.085, (z) => `italic ${z}px 'Instrument Serif'`, INK);
        // filet avec cœur
        const yl = y2 + S * 0.05;
        ctx.strokeStyle = ACCENT;
        ctx.globalAlpha = 0.6;
        ctx.lineWidth = Math.max(2, S * 0.004);
        ctx.beginPath();
        ctx.moveTo(cx - S * 0.1, yl);
        ctx.lineTo(cx - S * 0.025, yl);
        ctx.moveTo(cx + S * 0.025, yl);
        ctx.lineTo(cx + S * 0.1, yl);
        ctx.stroke();
        ctx.globalAlpha = 1;
        ctx.fillStyle = ACCENT;
        ctx.font = `${S * 0.04}px 'Geist'`;
        ctx.fillText('♥', cx, yl + S * 0.014);
        fitText(ctx, v.prenoms.toUpperCase(), cx, yl + S * 0.08, inner * 0.78, S * 0.046, (z) => `500 ${z}px 'Geist'`, INK);
      },
    },

    /* « Super papa depuis 2019 » */
    super: {
      fields: [
        { key: 'badge', label: 'Accroche', max: 22, default: "Le seul, l'unique" },
        { key: 'titre', label: 'Titre (2 mots)', max: 18, default: 'Super papa' },
        { key: 'annee', label: 'Ligne en italique', max: 22, default: 'depuis 2019' },
        { key: 'prenoms', label: 'Prénoms', max: 30, default: 'Emma & Hugo', hero: true },
      ],
      draw(ctx, w, h, v) {
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        const cx = w / 2;
        // pastille
        const badge = v.badge.toUpperCase();
        ctx.font = `600 ${h * 0.05}px 'Geist'`;
        const bw = Math.min(w * 0.8, ctx.measureText(badge).width + h * 0.12);
        ctx.strokeStyle = ACCENT;
        ctx.lineWidth = Math.max(2, h * 0.006);
        const bh = h * 0.1;
        ctx.beginPath();
        ctx.roundRect(cx - bw / 2, h * 0.1, bw, bh, bh / 2);
        ctx.stroke();
        fitText(ctx, badge, cx, h * 0.1 + bh / 2 + h * 0.003, bw - h * 0.08, h * 0.05, (s) => `600 ${s}px 'Geist'`, ACCENT);
        // titre sur deux lignes
        const words = v.titre.toUpperCase().split(/\s+/);
        const lines = words.length > 1 ? [words[0], words.slice(1).join(' ')] : [words[0]];
        const size = h * (lines.length > 1 ? 0.25 : 0.3);
        lines.forEach((line, i) =>
          fitText(ctx, line, cx, h * (lines.length > 1 ? 0.36 + i * 0.22 : 0.45), w * 0.85, size, (s) => `600 ${s}px 'Geist'`, INK)
        );
        fitText(ctx, v.annee, cx, h * 0.79, w * 0.8, h * 0.13, (s) => `italic ${s}px 'Instrument Serif'`, ACCENT);
        fitText(ctx, v.prenoms, cx, h * 0.91, w * 0.8, h * 0.09, (s) => `${s}px 'Caveat'`, MUTED);
      },
    },

    /* Photo du client (+ texte facultatif) : mug photo, affiche photo… */
    photo: {
      fields: [
        { key: 'photo', label: 'Votre photo', type: 'image', default: '' },
        { key: 'texte', label: 'Texte sous la photo (facultatif)', max: 30, default: '', optional: true, hero: true },
      ],
      draw(ctx, w, h, v) {
        const hasText = !!(v.texte && v.texte.trim());
        const ph = hasText ? h * 0.8 : h; // hauteur réservée à la photo
        const img = v._image; // HTMLImageElement / ImageBitmap chargé par la fiche produit
        const r = Math.min(w, ph) * 0.06;
        ctx.save();
        ctx.beginPath();
        ctx.roundRect(0, 0, w, ph, r);
        ctx.clip();
        if (img) {
          // « cover » : la photo remplit la zone, recadrée au centre
          const s = Math.max(w / img.width, ph / img.height);
          const dw = img.width * s, dh = img.height * s;
          ctx.drawImage(img, (w - dw) / 2, (ph - dh) / 2, dw, dh);
        } else {
          ctx.fillStyle = '#efe6da';
          ctx.fillRect(0, 0, w, ph);
          ctx.fillStyle = MUTED;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.font = `500 ${ph * 0.08}px 'Geist'`;
          ctx.fillText('Votre photo ici', w / 2, ph / 2);
        }
        ctx.restore();
        if (hasText) {
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          fitText(ctx, v.texte, w / 2, ph + (h - ph) * 0.55, w * 0.95, (h - ph) * 0.7, (s) => `${s}px 'Pinyon Script'`, ACCENT);
        }
      },
    },

    /* « Léa & Tom, depuis 2019 », « Mariés le… » */
    duo: {
      fields: [
        { key: 'prenom1', label: 'Premier prénom', max: 14, default: 'Léa', hero: true },
        { key: 'prenom2', label: 'Second prénom', max: 14, default: 'Tom' },
        { key: 'ligne', label: 'Ligne du bas', max: 28, default: 'depuis 2019' },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        const script = (z) => `${z}px 'Pinyon Script'`;
        fitText(ctx, v.prenom1, cx, h * 0.3, w * 0.92, h * 0.26, script, ACCENT);
        fitText(ctx, '&', cx, h * 0.47, w * 0.3, h * 0.16, (z) => `italic ${z}px 'Instrument Serif'`, INK);
        fitText(ctx, v.prenom2, cx, h * 0.7, w * 0.92, h * 0.26, script, ACCENT);
        heartRule(ctx, cx, h * 0.8, w, h);
        caps(ctx, v.ligne, cx, h * 0.93, w * 0.86, h * 0.062, INK);
      },
    },

    /* Photo façon polaroid + légende manuscrite */
    polaroid: {
      fields: [
        { key: 'photo', label: 'Votre photo', type: 'image', default: '' },
        { key: 'legende', label: 'Légende', max: 24, default: 'Nos plus beaux souvenirs', hero: true },
      ],
      draw(ctx, w, h, v) {
        const side = Math.min(w * 0.78, h * 0.94);
        const cardW = side * 0.86, cardH = side;
        ctx.save();
        ctx.translate(w / 2, h / 2);
        ctx.rotate(-0.045);
        ctx.shadowColor = 'rgba(44,26,21,0.22)';
        ctx.shadowBlur = side * 0.05;
        ctx.shadowOffsetY = side * 0.015;
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(-cardW / 2, -cardH / 2, cardW, cardH);
        ctx.shadowColor = 'transparent';
        ctx.strokeStyle = '#e8e0d6';
        ctx.lineWidth = Math.max(1.5, side * 0.004);
        ctx.strokeRect(-cardW / 2, -cardH / 2, cardW, cardH);
        const pad = cardW * 0.07;
        const ph = cardW - 2 * pad;
        drawPhoto(ctx, v._image, -cardW / 2 + pad, -cardH / 2 + pad, ph, ph);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        const capH = cardH - ph - pad;
        fitText(ctx, v.legende, 0, -cardH / 2 + pad + ph + capH / 2, cardW * 0.9, capH * 0.55, (z) => `${z}px 'Caveat'`, INK);
        ctx.restore();
      },
    },

    /* « Le meilleur chien du monde » + nom, traces de pattes */
    animal: {
      fields: [
        { key: 'nom', label: "Nom de l'animal", max: 14, default: 'Rocky', hero: true },
        { key: 'ligne', label: 'Phrase', max: 30, default: 'Le meilleur chien du monde' },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        [[0.14, 0.16, -0.5], [0.3, 0.07, -0.2], [0.72, 0.08, 0.25], [0.87, 0.18, 0.5]].forEach(([x, y, a]) =>
          paw(ctx, w * x, h * y, h * 0.07, 'rgba(199,77,56,0.55)', a)
        );
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.nom, cx, h * 0.6, w * 0.9, h * 0.34, (z) => `italic ${z}px 'Instrument Serif'`, ACCENT);
        caps(ctx, v.ligne, cx, h * 0.78, w * 0.9, h * 0.06, INK, 600);
        paw(ctx, cx, h * 0.9, h * 0.06, INK, 0);
      },
    },

    /* « Merci pour cette belle année » : professeur, ATSEM, nounou */
    merci: {
      fields: [
        { key: 'titre', label: 'Titre', max: 12, default: 'Merci' },
        { key: 'sous_titre', label: 'Sous-titre', max: 30, default: 'pour cette belle année' },
        { key: 'nom', label: 'Nom', max: 24, default: 'Madame Martin', hero: true },
        { key: 'classe', label: 'Classe et année', max: 26, default: 'CE1 · 2025-2026' },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.titre, cx, h * 0.36, w * 0.9, h * 0.34, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        fitText(ctx, v.sous_titre, cx, h * 0.53, w * 0.88, h * 0.1, (z) => `italic ${z}px 'Instrument Serif'`, INK);
        sparkle(ctx, cx - w * 0.12, h * 0.63, h * 0.022, GOLD);
        sparkle(ctx, cx, h * 0.63, h * 0.03, GOLD);
        sparkle(ctx, cx + w * 0.12, h * 0.63, h * 0.022, GOLD);
        caps(ctx, v.nom, cx, h * 0.76, w * 0.88, h * 0.07, INK, 600);
        fitText(ctx, v.classe, cx, h * 0.9, w * 0.8, h * 0.08, (z) => `${z}px 'Caveat'`, MUTED);
      },
    },

    /* Citation humoristique : « Pas de réunion avant mon café », « Le roi du barbecue » */
    citation: {
      fields: [
        { key: 'haut', label: 'Première ligne', max: 22, default: 'Pas de réunion' },
        { key: 'bas', label: 'Deuxième ligne', max: 22, default: 'avant mon café' },
        { key: 'prenom', label: 'Prénom', max: 18, default: 'Julien', hero: true },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        sparkle(ctx, cx, h * 0.1, h * 0.035, GOLD);
        fitText(ctx, v.haut.toUpperCase(), cx, h * 0.38, w * 0.92, h * 0.17, (z) => `600 ${z}px 'Geist'`, INK);
        fitText(ctx, v.bas, cx, h * 0.62, w * 0.92, h * 0.2, (z) => `italic ${z}px 'Instrument Serif'`, ACCENT);
        ctx.save();
        ctx.strokeStyle = MUTED;
        ctx.globalAlpha = 0.5;
        ctx.lineWidth = Math.max(2, h * 0.004);
        ctx.beginPath();
        ctx.moveTo(cx - w * 0.08, h * 0.73);
        ctx.lineTo(cx + w * 0.08, h * 0.73);
        ctx.stroke();
        ctx.restore();
        fitText(ctx, v.prenom, cx, h * 0.88, w * 0.8, h * 0.12, (z) => `${z}px 'Caveat'`, MUTED);
      },
    },

    /* Anniversaire : grand chiffre + prénom */
    anniversaire: {
      fields: [
        { key: 'age', label: 'Âge', max: 3, default: '40' },
        { key: 'prenom', label: 'Prénom', max: 16, default: 'Julien', hero: true },
        { key: 'date', label: 'Date (facultatif)', max: 20, default: '12 mars 2026', optional: true },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        caps(ctx, 'Joyeux anniversaire', cx, h * 0.12, w * 0.9, h * 0.055, INK, 600);
        // « 40 » + « ans » centrés ensemble
        let size = h * 0.5;
        const ageFont = (z) => `${z}px 'Instrument Serif'`;
        const ansFont = (z) => `italic ${z * 0.3}px 'Instrument Serif'`;
        const widthAt = (z) => {
          ctx.font = ageFont(z);
          const a = ctx.measureText(v.age).width;
          ctx.font = ansFont(z);
          return a + z * 0.04 + ctx.measureText('ans').width;
        };
        while (size > 6 && widthAt(size) > w * 0.85) size *= 0.95;
        const total = widthAt(size);
        ctx.font = ageFont(size);
        const ageW = ctx.measureText(v.age).width;
        const x0 = cx - total / 2;
        ctx.textAlign = 'left';
        ctx.fillStyle = ACCENT;
        ctx.fillText(v.age, x0, h * 0.58);
        ctx.font = ansFont(size);
        ctx.fillStyle = INK;
        ctx.fillText('ans', x0 + ageW + size * 0.04, h * 0.58);
        ctx.textAlign = 'center';
        sparkle(ctx, x0 - h * 0.06, h * 0.26, h * 0.035, GOLD);
        sparkle(ctx, x0 + total + h * 0.04, h * 0.22, h * 0.025, GOLD);
        fitText(ctx, v.prenom, cx, h * 0.8, w * 0.9, h * 0.17, (z) => `${z}px 'Pinyon Script'`, INK);
        if (v.date) fitText(ctx, v.date, cx, h * 0.94, w * 0.8, h * 0.065, (z) => `${z}px 'Caveat'`, MUTED);
      },
    },

    /* Noël : guirlande aquarelle (sapin, houx, étoiles dorées), « Joyeux Noël » + prénom */
    noel: {
      art: ['rameau'],
      fields: [
        { key: 'titre', label: 'Titre', max: 18, default: 'Joyeux Noël' },
        { key: 'prenom', label: 'Prénom', max: 16, default: 'Léa', hero: true },
        { key: 'annee', label: 'Année', max: 10, default: '2026' },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        const r = drawArt(ctx, artImage('rameau'), w * 0.02, h * 0.03, w * 0.96, h * 0.22);
        const top = r ? r.y + r.h : h * 0.2;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.titre, cx, top + h * 0.13, w * 0.86, h * 0.12, (z) => `italic ${z}px 'Instrument Serif'`, INK);
        fitText(ctx, v.prenom, cx, h * 0.68, w * 0.86, h * 0.3, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        caps(ctx, v.annee, cx, h * 0.87, w * 0.5, h * 0.06, GOLD, 600);
        [[0.14, 0.87], [0.86, 0.87]].forEach(([x, y]) => sparkle(ctx, w * x, h * y - h * 0.02, h * 0.02, GOLD));
      },
    },

    /* Enfant : prénom multicolore façon écriture d'enfant */
    enfant: {
      fields: [
        { key: 'prenom', label: 'Prénom', max: 12, default: 'Jules', hero: true },
        { key: 'ligne', label: 'Petite phrase (facultatif)', max: 24, default: 'mon mug à moi', optional: true },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        let size = h * 0.4;
        ctx.font = `${size}px 'Caveat'`;
        while (size > 6 && ctx.measureText(v.prenom).width > w * 0.9) {
          size *= 0.95;
          ctx.font = `${size}px 'Caveat'`;
        }
        let x = cx - ctx.measureText(v.prenom).width / 2;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'alphabetic';
        [...v.prenom].forEach((ch, i) => {
          const lw = ctx.measureText(ch).width;
          ctx.save();
          ctx.translate(x + lw / 2, h * 0.58);
          ctx.rotate((i % 2 === 0 ? -1 : 1) * 0.06);
          ctx.fillStyle = KIDS[i % KIDS.length];
          ctx.fillText(ch, -lw / 2, 0);
          ctx.restore();
          x += lw;
        });
        [[0.12, 0.16, 0.035, KIDS[1]], [0.86, 0.14, 0.03, KIDS[2]], [0.9, 0.7, 0.025, KIDS[3]], [0.1, 0.72, 0.03, KIDS[4]]].forEach(
          ([sx, sy, r, c]) => sparkle(ctx, w * sx, h * sy, h * r, c)
        );
        if (v.ligne) {
          ctx.textAlign = 'center';
          fitText(ctx, v.ligne, cx, h * 0.84, w * 0.85, h * 0.1, (z) => `${z}px 'Caveat'`, MUTED);
        }
      },
    },

    /* Affiche prénom pour chambre d'enfant */
    'affiche-prenom': {
      fields: [
        { key: 'prenom', label: 'Prénom', max: 12, default: 'Gabriel', hero: true },
        { key: 'ligne', label: 'Petite phrase', max: 30, default: 'né le 3 janvier 2026' },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        let size = w * 0.3;
        ctx.font = `${size}px 'Caveat'`;
        while (size > 6 && ctx.measureText(v.prenom).width > w * 0.9) {
          size *= 0.95;
          ctx.font = `${size}px 'Caveat'`;
        }
        let x = cx - ctx.measureText(v.prenom).width / 2;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'alphabetic';
        [...v.prenom].forEach((ch, i) => {
          const lw = ctx.measureText(ch).width;
          ctx.save();
          ctx.translate(x + lw / 2, h * 0.52);
          ctx.rotate((i % 2 === 0 ? -1 : 1) * 0.05);
          ctx.fillStyle = KIDS[i % KIDS.length];
          ctx.fillText(ch, -lw / 2, 0);
          ctx.restore();
          x += lw;
        });
        [[0.15, 0.22, 0.035, KIDS[1]], [0.82, 0.18, 0.03, KIDS[2]], [0.88, 0.62, 0.025, KIDS[3]], [0.12, 0.66, 0.03, KIDS[4]], [0.5, 0.14, 0.02, KIDS[0]]].forEach(
          ([sx, sy, r, c]) => sparkle(ctx, w * sx, h * sy, w * r, c)
        );
        ctx.textAlign = 'center';
        fitText(ctx, v.ligne, cx, h * 0.7, w * 0.8, w * 0.065, (z) => `italic ${z}px 'Instrument Serif'`, MUTED);
      },
    },

    /* Affiche de mariage : prénoms, « se sont dit oui », date et lieu, arche */
    'affiche-mariage': {
      fields: [
        { key: 'prenom1', label: 'Premier prénom', max: 14, default: 'Clara', hero: true },
        { key: 'prenom2', label: 'Second prénom', max: 14, default: 'Hugo' },
        { key: 'phrase', label: 'Phrase', max: 26, default: 'se sont dit oui' },
        { key: 'date', label: 'Date', max: 22, default: '14 juin 2026' },
        { key: 'lieu', label: 'Lieu', max: 26, default: 'Saint-Émilion' },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        // arche fine
        ctx.save();
        ctx.strokeStyle = GOLD;
        ctx.lineWidth = w * 0.004;
        ctx.beginPath();
        ctx.moveTo(cx - w * 0.36, h * 0.8);
        ctx.lineTo(cx - w * 0.36, h * 0.36);
        ctx.arc(cx, h * 0.36, w * 0.36, Math.PI, 0);
        ctx.lineTo(cx + w * 0.36, h * 0.8);
        ctx.stroke();
        ctx.restore();
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        const script = (z) => `${z}px 'Pinyon Script'`;
        fitText(ctx, v.prenom1, cx, h * 0.32, w * 0.62, w * 0.16, script, ACCENT);
        fitText(ctx, '&', cx, h * 0.42, w * 0.2, w * 0.09, (z) => `italic ${z}px 'Instrument Serif'`, INK);
        fitText(ctx, v.prenom2, cx, h * 0.54, w * 0.62, w * 0.16, script, ACCENT);
        fitText(ctx, v.phrase, cx, h * 0.63, w * 0.6, w * 0.055, (z) => `italic ${z}px 'Instrument Serif'`, INK);
        sparkle(ctx, cx, h * 0.68, w * 0.02, GOLD);
        caps(ctx, v.date, cx, h * 0.74, w * 0.6, w * 0.035, INK, 600);
        fitText(ctx, v.lieu, cx, h * 0.9, w * 0.7, w * 0.05, (z) => `${z}px 'Caveat'`, MUTED);
      },
    },

    /* « Notre histoire » : frise des dates clés d'un couple */
    'affiche-histoire': {
      fields: [
        { key: 'prenoms', label: 'Vos prénoms', max: 24, default: 'Léa & Tom', hero: true },
        { key: 'e1', label: 'Moment 1', max: 26, default: 'Notre rencontre' },
        { key: 'd1', label: 'Date 1', max: 16, default: '12.06.2016' },
        { key: 'e2', label: 'Moment 2', max: 26, default: 'Notre premier chez-nous' },
        { key: 'd2', label: 'Date 2', max: 16, default: '01.09.2018' },
        { key: 'e3', label: 'Moment 3', max: 26, default: 'Notre mariage' },
        { key: 'd3', label: 'Date 3', max: 16, default: '14.06.2022' },
        { key: 'e4', label: 'Moment 4 (facultatif)', max: 26, default: "L'arrivée de Jules", optional: true },
        { key: 'd4', label: 'Date 4 (facultatif)', max: 16, default: '03.01.2025', optional: true },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        caps(ctx, 'Notre histoire', cx, h * 0.08, w * 0.6, w * 0.032, MUTED, 600);
        fitText(ctx, v.prenoms, cx, h * 0.2, w * 0.9, w * 0.13, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        const steps = [[v.e1, v.d1], [v.e2, v.d2], [v.e3, v.d3], [v.e4, v.d4]].filter(([e, d]) => e && d);
        const top = h * 0.3, bottom = h * 0.9;
        const gap = (bottom - top) / steps.length;
        ctx.save();
        ctx.strokeStyle = '#e0d6ca';
        ctx.lineWidth = w * 0.004;
        ctx.beginPath();
        ctx.moveTo(cx, top + gap * 0.2);
        ctx.lineTo(cx, top + gap * (steps.length - 0.4));
        ctx.stroke();
        ctx.restore();
        steps.forEach(([e, d], i) => {
          const y = top + gap * (i + 0.3);
          ctx.fillStyle = ACCENT;
          ctx.beginPath();
          ctx.arc(cx, y, w * 0.012, 0, Math.PI * 2);
          ctx.fill();
          caps(ctx, d, cx, y + w * 0.06, w * 0.5, w * 0.03, MUTED, 600);
          fitText(ctx, e, cx, y + w * 0.13, w * 0.86, w * 0.06, (z) => `italic ${z}px 'Instrument Serif'`, INK);
        });
      },
    },

    /* Affiche de famille : nom, tous les prénoms, année */
    'affiche-famille': {
      fields: [
        { key: 'nom', label: 'Nom de famille', max: 18, default: 'Martin', hero: true },
        { key: 'prenoms', label: 'Prénoms (séparés par des virgules)', max: 80, default: 'Paul, Anne, Léa, Tom, Biscuit' },
        { key: 'depuis', label: 'Ligne du bas', max: 24, default: 'depuis 2009' },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        caps(ctx, 'La famille', cx, h * 0.12, w * 0.6, w * 0.04, MUTED, 600);
        fitText(ctx, v.nom, cx, h * 0.28, w * 0.9, w * 0.2, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        heartRule(ctx, cx, h * 0.34, w, w);
        const names = v.prenoms.split(/\s*[,·&]\s*/).filter(Boolean).slice(0, 8);
        const top = h * 0.42, gap = Math.min(h * 0.075, (h * 0.4) / Math.max(names.length, 1));
        names.forEach((n, i) => fitText(ctx, n, cx, top + gap * (i + 0.6), w * 0.8, Math.min(w * 0.075, gap * 0.8), (z) => `italic ${z}px 'Instrument Serif'`, INK));
        caps(ctx, v.depuis, cx, h * 0.92, w * 0.6, w * 0.032, GOLD, 600);
      },
    },

    /* Grands-parents : « Mamie » + les prénoms des petits-enfants en cœur */
    'affiche-grands-parents': {
      fields: [
        { key: 'titre', label: 'Titre', max: 14, default: 'Mamie', hero: true },
        { key: 'phrase', label: 'Phrase', max: 30, default: 'tes petits-enfants t’aiment' },
        { key: 'prenoms', label: 'Prénoms (séparés par des virgules)', max: 70, default: 'Léa, Tom, Jules, Chloé' },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        const ts = fitText(ctx, v.titre, cx, h * 0.24, w * 0.9, w * 0.26, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        // la phrase descend sous les jambages du titre (« Papy », « Mamy »…)
        ctx.font = `${ts}px 'Pinyon Script'`;
        const desc = ctx.measureText(v.titre).actualBoundingBoxDescent;
        fitText(ctx, v.phrase, cx, Math.max(h * 0.33, h * 0.24 + desc + w * 0.06), w * 0.8, w * 0.055, (z) => `italic ${z}px 'Instrument Serif'`, INK);
        // grand cœur formé par un contour, prénoms à l'intérieur
        const hy = h * 0.6, r = w * 0.3;
        ctx.save();
        ctx.strokeStyle = '#e8b9a6';
        ctx.lineWidth = w * 0.006;
        ctx.beginPath();
        ctx.moveTo(cx, hy + r * 0.95);
        ctx.bezierCurveTo(cx - r * 1.5, hy + r * 0.1, cx - r * 0.9, hy - r * 1.05, cx, hy - r * 0.45);
        ctx.bezierCurveTo(cx + r * 0.9, hy - r * 1.05, cx + r * 1.5, hy + r * 0.1, cx, hy + r * 0.95);
        ctx.stroke();
        ctx.restore();
        const names = v.prenoms.split(/\s*[,·&]\s*/).filter(Boolean).slice(0, 6);
        const gap = Math.min(w * 0.085, (r * 1.2) / Math.max(names.length, 1));
        const start = hy - (gap * (names.length - 1)) / 2 + gap * 0.3;
        names.forEach((n, i) => caps(ctx, n, cx, start + gap * i, r * 1.1, Math.min(w * 0.042, gap * 0.55), INK, 600));
      },
    },

    /* Photo pleine page + titre */
    'affiche-photo': {
      fields: [
        { key: 'photo', label: 'Votre photo', type: 'image', default: '' },
        { key: 'titre', label: 'Titre', max: 24, default: 'Nos plus beaux souvenirs', hero: true },
        { key: 'sous_titre', label: 'Sous-titre (facultatif)', max: 30, default: 'Été 2026', optional: true },
      ],
      draw(ctx, w, h, v) {
        drawPhoto(ctx, v._image, 0, 0, w, h * 0.76);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.titre, w / 2, h * 0.88, w * 0.92, w * 0.1, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        if (v.sous_titre) caps(ctx, v.sous_titre, w / 2, h * 0.96, w * 0.7, w * 0.03, MUTED, 600);
      },
    },

    /* « Les règles de la maison » */
    'affiche-regles': {
      fields: [
        { key: 'titre', label: 'Titre', max: 26, default: 'Les règles de la maison', hero: true },
        { key: 'r1', label: 'Règle 1', max: 30, default: 'On rit beaucoup' },
        { key: 'r2', label: 'Règle 2', max: 30, default: 'On se dit merci' },
        { key: 'r3', label: 'Règle 3', max: 30, default: 'On partage le chocolat' },
        { key: 'r4', label: 'Règle 4', max: 30, default: 'On se fait des câlins' },
        { key: 'r5', label: 'Règle 5', max: 30, default: 'Et on s’aime fort' },
        { key: 'signature', label: 'Signature', max: 24, default: 'Famille Martin' },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.titre, cx, h * 0.14, w * 0.9, w * 0.1, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        heartRule(ctx, cx, h * 0.2, w, w);
        const rules = [v.r1, v.r2, v.r3, v.r4, v.r5].filter(Boolean);
        const top = h * 0.3, gap = (h * 0.52) / rules.length;
        rules.forEach((r, i) => {
          const y = top + gap * (i + 0.5);
          caps(ctx, r, cx, y, w * 0.86, w * 0.045, i % 2 === 0 ? INK : ACCENT, 600);
          if (i < rules.length - 1) sparkle(ctx, cx, y + gap * 0.5, w * 0.012, GOLD);
        });
        fitText(ctx, v.signature, cx, h * 0.93, w * 0.7, w * 0.06, (z) => `${z}px 'Caveat'`, MUTED);
      },
    },

    /* ---------- Famille « grands-parents » ---------- */

    /* « Mamie poule et ses poussins » : une poule et un poussin par petit-enfant */
    'mamie-poule': {
      fields: [
        { key: 'titre', label: 'Titre', max: 16, default: 'Mamie poule', hero: true },
        { key: 'phrase', label: 'Phrase', max: 26, default: 'et ses petits poussins' },
        { key: 'prenoms', label: 'Prénoms des poussins (5 max.)', max: 60, default: 'Léa, Tom, Jules', hint: 'Séparez les prénoms par des virgules' },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.titre, cx, h * 0.15, w * 0.92, h * 0.14, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        fitText(ctx, v.phrase, cx, h * 0.27, w * 0.86, h * 0.065, (z) => `italic ${z}px 'Instrument Serif'`, INK);
        // la poule
        const s = Math.min(h * 0.14, w * 0.18), px0 = cx - s * 0.15, py = h * 0.52;
        ctx.save();
        [[-1.05, -0.45, -2.3], [-1.12, -0.2, -2.7], [-1.05, 0.05, -3.1]].forEach(([dx, dy, a], i) =>
          leaf(ctx, px0 + dx * s + s * 0.3, py + dy * s, s * 0.75, a, i === 1 ? '#c9a57a' : '#d9b98f')
        );
        ctx.strokeStyle = GOLD;
        ctx.lineWidth = s * 0.07;
        ctx.lineCap = 'round';
        [-0.25, 0.2].forEach((dx) => {
          ctx.beginPath();
          ctx.moveTo(px0 + dx * s, py + s * 0.7);
          ctx.lineTo(px0 + dx * s, py + s * 1.02);
          ctx.lineTo(px0 + dx * s + s * 0.14, py + s * 1.05);
          ctx.stroke();
        });
        ctx.fillStyle = '#ecd8bd';
        ctx.beginPath();
        ctx.ellipse(px0, py, s, s * 0.78, 0, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = '#d9b98f';
        ctx.beginPath();
        ctx.ellipse(px0 - s * 0.1, py + s * 0.05, s * 0.52, s * 0.3, -0.25, 0, Math.PI * 2);
        ctx.fill();
        const hx = px0 + s * 0.78, hy = py - s * 0.68;
        ctx.fillStyle = ACCENT;
        [[-0.2, -0.38], [0, -0.46], [0.2, -0.38]].forEach(([dx, dy]) => {
          ctx.beginPath();
          ctx.arc(hx + dx * s, hy + dy * s, s * 0.13, 0, Math.PI * 2);
          ctx.fill();
        });
        ctx.fillStyle = '#ecd8bd';
        ctx.beginPath();
        ctx.arc(hx, hy, s * 0.42, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = GOLD;
        ctx.beginPath();
        ctx.moveTo(hx + s * 0.38, hy - s * 0.1);
        ctx.lineTo(hx + s * 0.62, hy + s * 0.02);
        ctx.lineTo(hx + s * 0.38, hy + s * 0.12);
        ctx.fill();
        ctx.fillStyle = ACCENT;
        ctx.beginPath();
        ctx.ellipse(hx + s * 0.34, hy + s * 0.24, s * 0.07, s * 0.12, 0, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = INK;
        ctx.beginPath();
        ctx.arc(hx + s * 0.14, hy - s * 0.07, s * 0.065, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
        // les poussins
        const names = nameList(v.prenoms, 5);
        const n = Math.max(names.length, 1), span = w * 0.92 / n;
        const c = Math.min(h * 0.05, span * 0.26), cy = h * 0.765;
        names.forEach((name, i) => {
          const x = w * 0.04 + span * (i + 0.5);
          ctx.save();
          ctx.strokeStyle = GOLD;
          ctx.lineWidth = c * 0.12;
          ctx.lineCap = 'round';
          [-0.3, 0.3].forEach((dx) => {
            ctx.beginPath();
            ctx.moveTo(x + dx * c, cy + c * 0.9);
            ctx.lineTo(x + dx * c, cy + c * 1.2);
            ctx.stroke();
          });
          ctx.fillStyle = '#f2c14e';
          ctx.beginPath();
          ctx.arc(x, cy, c, 0, Math.PI * 2);
          ctx.arc(x + c * 0.35, cy - c * 1.05, c * 0.62, 0, Math.PI * 2);
          ctx.fill();
          ctx.fillStyle = '#e0a93a';
          ctx.beginPath();
          ctx.ellipse(x - c * 0.2, cy + c * 0.05, c * 0.5, c * 0.3, -0.3, 0, Math.PI * 2);
          ctx.fill();
          ctx.fillStyle = '#e07b39';
          ctx.beginPath();
          ctx.moveTo(x + c * 0.9, cy - c * 1.15);
          ctx.lineTo(x + c * 1.25, cy - c * 1.02);
          ctx.lineTo(x + c * 0.9, cy - c * 0.9);
          ctx.fill();
          ctx.fillStyle = INK;
          ctx.beginPath();
          ctx.arc(x + c * 0.55, cy - c * 1.12, c * 0.1, 0, Math.PI * 2);
          ctx.fill();
          ctx.restore();
          ctx.textAlign = 'center';
          fitText(ctx, name, x, h * 0.93, span * 0.95, h * 0.075, (z) => `${z}px 'Caveat'`, INK);
        });
      },
    },

    /* Arbre de famille aquarelle : un cœur par prénom dans la couronne de l'arbre, les grands-parents au pied */
    arbre: {
      art: ['arbre', 'coeur-rouge', 'coeur-rose', 'coeur-sauge', 'coeur-or'],
      fields: [
        { key: 'titre', label: 'Au pied de l’arbre', max: 22, default: 'Mamie & Papy', hero: true },
        { key: 'prenoms', label: 'Prénoms dans l’arbre (10 max.)', max: 90, default: 'Léa, Tom, Jules, Chloé, Emma, Hugo', hint: 'Séparez les prénoms par des virgules' },
        { key: 'ligne', label: 'Ligne du bas', max: 30, default: 'et toute leur famille' },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        const names = nameList(v.prenoms, 10);
        const n = names.length;
        // places dans la couronne de l'arbre (fractions de l'illustration : couronne x 0,12-0,88, y 0-0,55)
        const POS = { a: [0.5, 0.1], b: [0.5, 0.29], p: [[[0.36, 0.4], [0.64, 0.4]], [[0.3, 0.18], [0.7, 0.18]], [[0.15, 0.33], [0.85, 0.33]], [[0.24, 0.51], [0.76, 0.51]]] };
        const pts = [];
        // impair : un cœur au sommet ; 10 : sommet + centre en plus des 4 paires
        if (n === 1) pts.push(POS.b);
        else if (n % 2 === 1 || n === 10) pts.push(POS.a);
        POS.p.slice(0, Math.min(4, Math.floor(n / 2))).forEach((pair) => pts.push(...pair));
        if (n === 10) pts.push(POS.b);
        const r = drawArt(ctx, artImage('arbre'), w * 0.03, h * 0.01, w * 0.94, h * 0.76, 'bottom')
          || { x: w * 0.1, y: h * 0.01, w: w * 0.8, h: h * 0.76 };
        const hearts = ['coeur-rouge', 'coeur-sauge', 'coeur-or', 'coeur-rose'];
        const rh = Math.min(r.w * 0.105, h * 0.075) * (n > 6 ? 0.86 : 1);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        pts.forEach(([fx, fy], i) => {
          const x = r.x + r.w * fx, y = r.y + r.h * fy;
          const img = artImage(hearts[i % hearts.length]);
          if (img) drawArt(ctx, img, x - rh * 1.1, y - rh * 1.05, rh * 2.2, rh * 2.1);
          else heart(ctx, x, y, rh, ACCENT);
          ctx.save();
          ctx.letterSpacing = `${rh * 0.03}px`;
          fitText(ctx, names[i].toUpperCase(), x, y - rh * 0.12, rh * 1.45, rh * 0.34, (z) => `600 ${z}px 'Geist'`, INK);
          ctx.restore();
        });
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.titre, cx, h * 0.875, w * 0.9, h * 0.11, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        if (v.ligne) caps(ctx, v.ligne, cx, h * 0.955, w * 0.8, h * 0.032, MUTED, 600);
      },
    },

    /* Définition de dictionnaire : « Mamie [ma.mi] nom féminin : … » */
    definition: {
      fields: [
        { key: 'mot', label: 'Mot', max: 14, default: 'Mamie', hero: true },
        { key: 'phonetique', label: 'Prononciation', max: 16, default: '[ma.mi]' },
        { key: 'nature', label: 'Nature', max: 20, default: 'nom féminin' },
        { key: 'definition', label: 'Définition', max: 130, default: 'Personne formidable qui gâte ses petits-enfants, a toujours une histoire à raconter et un câlin d’avance.' },
        { key: 'signature', label: 'Signature', max: 40, default: 'Léa, Tom & Jules' },
      ],
      draw(ctx, w, h, v) {
        const x0 = w * 0.07, mw = w * 0.86;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.mot, x0, h * 0.25, mw, h * 0.17, (z) => `${z}px 'Instrument Serif'`, INK);
        fitText(ctx, `${v.phonetique}  ·  ${v.nature}`, x0, h * 0.34, mw, h * 0.055, (z) => `italic ${z}px 'Instrument Serif'`, MUTED);
        ctx.save();
        ctx.strokeStyle = ACCENT;
        ctx.lineWidth = Math.max(2, h * 0.006);
        ctx.beginPath();
        ctx.moveTo(x0, h * 0.39);
        ctx.lineTo(x0 + w * 0.18, h * 0.39);
        ctx.stroke();
        ctx.restore();
        // définition sur 5 lignes au plus
        let size = h * 0.062, lines;
        do {
          ctx.font = `${size}px 'Instrument Serif'`;
          lines = wrapLines(ctx, `1. ${v.definition}`, mw);
          size *= 0.95;
        } while (lines.length > 5 && size > 6);
        const lh = size * 1.35;
        ctx.fillStyle = INK;
        lines.forEach((l, i) => {
          if (i === 0) {
            ctx.fillStyle = ACCENT;
            ctx.fillText('1.', x0, h * 0.48);
            const off = ctx.measureText('1. ').width;
            ctx.fillStyle = INK;
            ctx.fillText(l.slice(3), x0 + off, h * 0.48);
          } else ctx.fillText(l, x0, h * 0.48 + lh * i);
        });
        if (v.signature) fitText(ctx, `Signé : ${v.signature}`, x0, h * 0.92, mw, h * 0.075, (z) => `${z}px 'Caveat'`, ACCENT);
      },
    },

    /* « Chez Mamie, on a le droit de… » : maison + liste cochée */
    'chez-mamie': {
      fields: [
        { key: 'titre', label: 'Titre', max: 18, default: 'Chez Mamie', hero: true },
        { key: 'phrase', label: 'Phrase', max: 26, default: 'on a le droit de…' },
        { key: 'r1', label: 'Ligne 1', max: 28, default: 'Manger des bonbons' },
        { key: 'r2', label: 'Ligne 2', max: 28, default: 'Se coucher tard' },
        { key: 'r3', label: 'Ligne 3', max: 28, default: 'Faire des câlins à volonté' },
        { key: 'r4', label: 'Ligne 4 (facultatif)', max: 28, default: 'Ne pas finir sa soupe', optional: true },
        { key: 'r5', label: 'Ligne 5 (facultatif)', max: 28, default: 'Être très, très gâté', optional: true },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        // maison : toit, cheminée, murs ouverts
        const hw = w * 0.4, roofTop = h * 0.05, roofBase = h * 0.17, base = h * 0.36;
        ctx.save();
        ctx.strokeStyle = ACCENT;
        ctx.lineWidth = Math.max(2, h * 0.007);
        ctx.lineJoin = 'round';
        ctx.lineCap = 'round';
        ctx.beginPath();
        ctx.moveTo(cx + hw * 0.55, roofTop + (roofBase - roofTop) * 0.45);
        ctx.lineTo(cx + hw * 0.55, roofTop);
        ctx.lineTo(cx + hw * 0.72, roofTop);
        ctx.lineTo(cx + hw * 0.72, roofTop + (roofBase - roofTop) * 0.66);
        ctx.moveTo(cx - hw * 1.08, roofBase + h * 0.01);
        ctx.lineTo(cx, roofTop - h * 0.01);
        ctx.lineTo(cx + hw * 1.08, roofBase + h * 0.01);
        ctx.moveTo(cx - hw * 0.92, roofBase);
        ctx.lineTo(cx - hw * 0.92, base);
        ctx.lineTo(cx + hw * 0.92, base);
        ctx.lineTo(cx + hw * 0.92, roofBase);
        ctx.stroke();
        ctx.restore();
        heart(ctx, cx, roofTop + h * 0.065, h * 0.022, ACCENT);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.titre, cx, h * 0.31, hw * 1.7, h * 0.12, (z) => `${z}px 'Pinyon Script'`, INK);
        fitText(ctx, v.phrase, cx, h * 0.45, w * 0.86, h * 0.065, (z) => `italic ${z}px 'Instrument Serif'`, ACCENT);
        const rows = [v.r1, v.r2, v.r3, v.r4, v.r5].filter(Boolean);
        const gap = Math.min(h * 0.085, (h * 0.42) / rows.length), size = Math.min(h * 0.06, gap * 0.72);
        const font = (z) => `${z}px 'Caveat'`;
        ctx.font = font(size);
        const box = size * 0.62;
        const textW = Math.min(w * 0.74, Math.max(...rows.map((r) => ctx.measureText(r).width)));
        const x0 = cx - (textW + box * 1.6) / 2;
        rows.forEach((r, i) => {
          const y = h * 0.54 + gap * (i + 0.6);
          ctx.save();
          ctx.strokeStyle = GOLD;
          ctx.lineWidth = Math.max(2, size * 0.1);
          ctx.lineCap = 'round';
          ctx.beginPath();
          ctx.moveTo(x0, y - box * 0.45);
          ctx.lineTo(x0 + box * 0.35, y - box * 0.1);
          ctx.lineTo(x0 + box, y - box * 0.95);
          ctx.stroke();
          ctx.restore();
          ctx.textAlign = 'left';
          fitText(ctx, r, x0 + box * 1.6, y, w * 0.74, size, font, INK);
        });
      },
    },

    /* Couronne aquarelle de feuillage et de baies (nœud en bas), titre au centre, prénoms dessous */
    couronne: {
      art: ['couronne-baies'],
      fields: [
        { key: 'titre', label: 'Titre', max: 16, default: 'Mamie', hero: true },
        { key: 'ligne', label: 'Ligne sous le titre', max: 22, default: 'depuis 2015' },
        { key: 'prenoms', label: 'Prénoms', max: 40, default: 'Léa · Tom · Jules', hint: 'Séparez les prénoms par « · » ou « & »' },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        const S = Math.min(w * 0.98, h * 0.8);
        const r = drawArt(ctx, artImage('couronne-baies'), cx - S / 2, h * 0.02, S, S) || { x: cx - S / 2, y: h * 0.02, w: S, h: S };
        // vide central mesuré sur l'illustration : x 0,19-0,79, y 0,15-0,77 (le nœud remonte en bas)
        const ix = r.x + r.w * 0.49, iy = r.y + r.h * 0.45, iw = r.w * 0.5;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.titre, ix, iy + r.h * 0.04, iw, r.h * 0.2, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        if (v.ligne) fitText(ctx, v.ligne, ix, iy + r.h * 0.15, iw * 0.85, r.h * 0.065, (z) => `italic ${z}px 'Instrument Serif'`, INK);
        if (v.prenoms) caps(ctx, v.prenoms, cx, Math.min(h * 0.94, r.y + r.h + h * 0.08), w * 0.9, h * 0.045, INK, 600);
      },
    },

    /* Tampon « Certifiée Super Mamie » */
    tampon: {
      fields: [
        { key: 'haut', label: 'Texte du haut', max: 16, default: 'Certifiée' },
        { key: 'titre', label: 'Titre (2 mots)', max: 16, default: 'Super Mamie', hero: true },
        { key: 'bas', label: 'Texte du bas', max: 18, default: 'depuis 2015' },
        { key: 'signature', label: 'Signé par', max: 30, default: 'Léa & Tom' },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2, cy = h * 0.42, R = Math.min(w * 0.46, h * 0.36);
        ctx.save();
        ctx.strokeStyle = ACCENT;
        ctx.lineWidth = R * 0.035;
        ctx.beginPath();
        ctx.arc(cx, cy, R, 0, Math.PI * 2);
        ctx.stroke();
        ctx.lineWidth = R * 0.014;
        ctx.beginPath();
        ctx.arc(cx, cy, R * 0.74, 0, Math.PI * 2);
        ctx.stroke();
        ctx.restore();
        const ring = (z) => `700 ${z}px 'Geist'`;
        arcText(ctx, v.haut.toUpperCase(), cx, cy, R * 0.87, true, R * 0.13, ring, ACCENT);
        arcText(ctx, v.bas.toUpperCase(), cx, cy, R * 0.87, false, R * 0.13, ring, ACCENT);
        star(ctx, cx - R * 0.87, cy, R * 0.05, GOLD);
        star(ctx, cx + R * 0.87, cy, R * 0.05, GOLD);
        const words = v.titre.trim().split(/\s+/);
        const l1 = words.length > 1 ? words.slice(0, Math.ceil(words.length / 2)).join(' ') : words[0];
        const l2 = words.length > 1 ? words.slice(Math.ceil(words.length / 2)).join(' ') : '';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        if (l2) {
          fitText(ctx, l1.toUpperCase(), cx, cy - R * 0.02, R * 1.3, R * 0.3, (z) => `700 ${z}px 'Geist'`, INK);
          fitText(ctx, l2, cx, cy + R * 0.36, R * 1.35, R * 0.38, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        } else fitText(ctx, l1.toUpperCase(), cx, cy + R * 0.1, R * 1.3, R * 0.3, (z) => `700 ${z}px 'Geist'`, INK);
        if (v.signature) fitText(ctx, `Signé : ${v.signature}`, cx, h * 0.92, w * 0.9, h * 0.075, (z) => `${z}px 'Caveat'`, MUTED);
      },
    },

    /* ---------- Famille « Noël » ---------- */

    /* Pull de Noël : bandes jacquard (rennes, sapins, flocons) en haut et en bas de toute la zone, prénom au centre */
    'noel-pull': {
      art: ['jacquard-haut', 'jacquard-bas'],
      fields: [
        { key: 'titre', label: 'Titre', max: 18, default: 'Joyeux Noël' },
        { key: 'prenom', label: 'Prénom', max: 14, default: 'Léa', hero: true },
        { key: 'annee', label: 'Année', max: 10, default: '2026' },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        // bandes pleine largeur ; hauteur limitée pour laisser le centre au texte (formats larges : mug, carré)
        const band = (name, y, align) => {
          const img = artImage(name);
          if (!img) return h * 0.2;
          const bh = Math.min((w * img.height) / img.width, h * 0.24);
          const bw = (bh * img.width) / img.height;
          ctx.drawImage(img, cx - bw / 2, align === 'top' ? y : y - bh, bw, bh);
          return bh;
        };
        const top = band('jacquard-haut', 0, 'top');
        const bottom = h - band('jacquard-bas', h, 'bottom');
        const span = bottom - top;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.titre, cx, top + span * 0.27, w * 0.86, span * 0.17, (z) => `italic ${z}px 'Instrument Serif'`, INK);
        fitText(ctx, v.prenom, cx, top + span * 0.7, w * 0.9, span * 0.42, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        caps(ctx, v.annee, cx, top + span * 0.9, w * 0.5, span * 0.08, GOLD, 700);
      },
    },

    /* Boule de Noël aquarelle, prénom écrit en blanc sur la boule : « Mon premier Noël » */
    'noel-boule': {
      art: ['boule'],
      fields: [
        { key: 'titre', label: 'Titre', max: 22, default: 'Mon premier Noël' },
        { key: 'prenom', label: 'Prénom', max: 12, default: 'Léo', hero: true },
        { key: 'annee', label: 'Année', max: 10, default: '2026' },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        // sphère dans l'illustration : centre à 67 % de la hauteur, rayon 46,8 % de la largeur (mesuré sur ideo-art-boule)
        const r = drawArt(ctx, artImage('boule'), w * 0.05, h * 0.015, w * 0.9, h * 0.68);
        let sx = cx, sy = h * 0.47, R = Math.min(w * 0.36, h * 0.22);
        if (r) {
          sx = r.x + r.w * 0.5;
          sy = r.y + r.h * 0.6715;
          R = r.w * 0.468;
        } else {
          ctx.fillStyle = ACCENT;
          ctx.beginPath();
          ctx.arc(sx, sy, R, 0, Math.PI * 2);
          ctx.fill();
        }
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        ctx.save();
        ctx.shadowColor = 'rgba(90, 20, 20, 0.45)';
        ctx.shadowBlur = R * 0.04;
        ctx.shadowOffsetY = R * 0.012;
        fitText(ctx, v.prenom, sx, sy + R * 0.24, R * 1.55, R * 0.95, (z) => `${z}px 'Pinyon Script'`, '#ffffff');
        ctx.restore();
        const base = r ? r.y + r.h : sy + R;
        fitText(ctx, v.titre, cx, base + h * 0.095, w * 0.92, h * 0.08, (z) => `italic ${z}px 'Instrument Serif'`, INK);
        caps(ctx, v.annee, cx, base + h * 0.18, w * 0.5, h * 0.042, GOLD, 700);
      },
    },

    /* Sapin de famille : les prénoms sur les étages du sapin */
    'noel-sapin': {
      art: ['sapin'],
      fields: [
        { key: 'titre', label: 'Titre', max: 20, default: 'Joyeux Noël' },
        { key: 'famille', label: 'Famille et année', max: 28, default: 'Famille Martin · 2026', hero: true },
        { key: 'prenoms', label: 'Prénoms dans le sapin (6 max.)', max: 60, default: 'Paul, Anne, Léa, Tom', hint: 'Séparez les prénoms par des virgules' },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        const r = drawArt(ctx, artImage('sapin'), w * 0.06, h * 0.02, w * 0.88, h * 0.74, 'bottom')
          || { x: w * 0.2, y: h * 0.02, w: w * 0.6, h: h * 0.74 };
        // prénoms sur des étiquettes crème accrochées dans les branches (1 à 3 rangées, le sapin s'élargit vers le bas)
        const names = nameList(v.prenoms, 6);
        const plan = { 0: [], 1: [0, 1, 0], 2: [0, 2, 0], 3: [0, 1, 2], 4: [0, 2, 2], 5: [1, 2, 2], 6: [1, 2, 3] }[names.length];
        const rowsF = [0.36, 0.54, 0.72];
        const tagH = Math.min(h * 0.055, r.h * 0.075);
        let k = 0;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        plan.forEach((count, row) => {
          if (!count) return;
          const y = r.y + r.h * rowsF[row];
          const half = (r.w / 2) * Math.min(0.92, 0.2 + rowsF[row] * 0.95);
          const cell = (2 * half) / count;
          for (let j = 0; j < count; j++) {
            const x = cx - half + cell * (j + 0.5);
            const name = names[k++].toUpperCase();
            ctx.save();
            ctx.letterSpacing = `${tagH * 0.1}px`;
            let z = tagH * 0.52;
            ctx.font = `600 ${z}px 'Geist'`;
            while (z > 4 && ctx.measureText(name).width > cell * 0.78) {
              z *= 0.94;
              ctx.font = `600 ${z}px 'Geist'`;
            }
            const tw = ctx.measureText(name).width + tagH * 0.9;
            ctx.fillStyle = 'rgba(251, 246, 239, 0.94)';
            ctx.strokeStyle = GOLD;
            ctx.lineWidth = Math.max(1, tagH * 0.05);
            ctx.beginPath();
            ctx.roundRect(x - tw / 2, y - tagH / 2, tw, tagH, tagH / 2);
            ctx.fill();
            ctx.stroke();
            ctx.fillStyle = INK;
            ctx.fillText(name, x, y + tagH * 0.03);
            ctx.restore();
          }
        });
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.titre, cx, h * 0.87, w * 0.9, h * 0.1, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        caps(ctx, v.famille, cx, h * 0.945, w * 0.86, h * 0.034, INK, 600);
      },
    },

    /* Famille de bonshommes de neige, un par prénom */
    'noel-bonhommes': {
      art: ['bonhomme-1', 'bonhomme-2', 'bonhomme-3', 'bonhomme-4', 'bonhomme-5'],
      fields: [
        { key: 'titre', label: 'Titre', max: 24, default: 'Noël en famille' },
        { key: 'prenoms', label: 'Prénoms (5 max., du plus grand au plus petit)', max: 60, default: 'Papa, Maman, Léa, Tom', hero: true, hint: 'Séparez les prénoms par des virgules' },
        { key: 'annee', label: 'Année', max: 10, default: '2026' },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.titre, cx, h * 0.15, w * 0.92, h * 0.11, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        const names = nameList(v.prenoms, 5);
        const n = Math.max(names.length, 1), slot = (w * 0.96) / n;
        const scale = [1, 0.9, 0.8, 0.72, 0.62];
        const imgs = names.map((_, i) => artImage(`bonhomme-${i + 1}`));
        // hauteur du plus grand : place entre le titre et les prénoms ; les bonhommes peuvent se chevaucher un peu (un groupe)
        const zoneTop = h * 0.21, zoneBottom = h * 0.8;
        let top = zoneBottom - zoneTop;
        imgs.forEach((img, i) => {
          if (img) top = Math.min(top, (slot * 1.6 * img.height) / img.width / scale[i]);
        });
        // groupe posé un peu sous le centre de la zone libre
        const ground = zoneTop + top + (zoneBottom - zoneTop - top) * 0.6;
        names.forEach((name, i) => {
          const x = w * 0.02 + slot * (i + 0.5);
          const img = imgs[i];
          if (img) {
            const bh = top * scale[i], bw = (bh * img.width) / img.height;
            ctx.drawImage(img, x - bw / 2, ground - bh, bw, bh);
          }
          fitText(ctx, name, x, ground + h * 0.08, slot * 0.92, h * 0.065, (z) => `italic ${z}px 'Instrument Serif'`, INK);
        });
        caps(ctx, v.annee, cx, Math.min(ground + h * 0.155, h * 0.96), w * 0.5, h * 0.034, GOLD, 600);
      },
    },

    /* « Cher Père Noël, cette année j'ai été… » : enveloppe aquarelle en tête, cases à cocher */
    'noel-lettre': {
      art: ['enveloppe'],
      fields: [
        { key: 'titre', label: 'Titre', max: 22, default: 'Cher Père Noël,' },
        { key: 'phrase', label: 'Phrase', max: 30, default: 'cette année, j’ai été :' },
        { key: 'o1', label: 'Case 1', max: 22, default: 'Sage' },
        { key: 'o2', label: 'Case 2', max: 22, default: 'Très sage' },
        { key: 'o3', label: 'Case 3 (cochée)', max: 26, default: 'Je peux tout expliquer' },
        { key: 'prenom', label: 'Prénom', max: 16, default: 'Julien', hero: true },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        drawArt(ctx, artImage('enveloppe'), w * 0.3, h * 0.01, w * 0.4, h * 0.15);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.titre, cx, h * 0.28, w * 0.92, h * 0.115, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        fitText(ctx, v.phrase, cx, h * 0.375, w * 0.88, h * 0.065, (z) => `italic ${z}px 'Instrument Serif'`, INK);
        const size = h * 0.07, box = size * 0.6, font = (z) => `${z}px 'Caveat'`;
        ctx.font = font(size);
        const opts = [v.o1, v.o2, v.o3];
        const tw = Math.min(w * 0.7, Math.max(...opts.map((o) => ctx.measureText(o).width)));
        const x0 = cx - (tw + box * 1.7) / 2;
        opts.forEach((o, i) => {
          const y = h * (0.5 + i * 0.12);
          ctx.save();
          ctx.strokeStyle = INK;
          ctx.lineWidth = Math.max(2, size * 0.06);
          ctx.strokeRect(x0, y - box, box, box);
          if (i === 2) {
            ctx.strokeStyle = ACCENT;
            ctx.lineWidth = Math.max(3, size * 0.1);
            ctx.lineCap = 'round';
            ctx.beginPath();
            ctx.moveTo(x0 + box * 0.15, y - box * 0.55);
            ctx.lineTo(x0 + box * 0.45, y - box * 0.15);
            ctx.lineTo(x0 + box * 1.2, y - box * 1.35);
            ctx.stroke();
          }
          ctx.restore();
          ctx.textAlign = 'left';
          fitText(ctx, o, x0 + box * 1.7, y, w * 0.7, size, font, i === 2 ? ACCENT : INK);
        });
        ctx.textAlign = 'center';
        fitText(ctx, `— ${v.prenom}`, cx, h * 0.92, w * 0.8, h * 0.08, font, MUTED);
      },
    },

    /* « Le chocolat chaud de… » : tasse aquarelle (guimauves, sucre d'orge, houx) */
    'noel-chocolat': {
      art: ['chocolat'],
      fields: [
        { key: 'ligne', label: 'Phrase', max: 26, default: 'Le chocolat chaud de' },
        { key: 'prenom', label: 'Prénom', max: 12, default: 'Jules', hero: true },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.ligne, cx, h * 0.11, w * 0.9, h * 0.075, (z) => `italic ${z}px 'Instrument Serif'`, INK);
        drawArt(ctx, artImage('chocolat'), w * 0.08, h * 0.14, w * 0.84, h * 0.58);
        fitText(ctx, v.prenom, cx, h * 0.9, w * 0.9, h * 0.2, (z) => `${z}px 'Caveat'`, ACCENT);
      },
    },

    /* Noël en amoureux : brin de gui aquarelle, prénoms du couple */
    'noel-couple': {
      art: ['gui'],
      fields: [
        { key: 'titre', label: 'Titre', max: 24, default: 'Notre premier Noël' },
        { key: 'prenoms', label: 'Vos prénoms', max: 28, default: 'Léa & Tom', hero: true },
        { key: 'annee', label: 'Année', max: 10, default: '2026' },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        drawArt(ctx, artImage('gui'), w * 0.1, h * 0.01, w * 0.8, h * 0.47);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.titre, cx, h * 0.55, w * 0.9, h * 0.075, (z) => `italic ${z}px 'Instrument Serif'`, INK);
        fitText(ctx, v.prenoms, cx, h * 0.74, w * 0.92, h * 0.19, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        heart(ctx, cx, h * 0.805, h * 0.016, ACCENT);
        caps(ctx, v.annee, cx, h * 0.9, w * 0.5, h * 0.045, GOLD, 700);
      },
    },

    /* Photo de Noël dans une couronne : animal, famille, souvenir */
    'noel-photo': {
      art: ['couronne-sapin'],
      fields: [
        { key: 'photo', label: 'Votre photo', type: 'image', default: '' },
        { key: 'titre', label: 'Titre', max: 18, default: 'Joyeux Noël' },
        { key: 'nom', label: 'Prénom ou nom', max: 18, default: 'Rocky', hero: true },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.titre, cx, h * 0.13, w * 0.92, h * 0.11, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        // couronne aquarelle carrée ; la photo ronde passe SOUS les branches (vide central : centre 0,515 / 0,47)
        const S = Math.min(w * 0.98, h * 0.72);
        const x0 = cx - S / 2, y0 = h * 0.155;
        const pcx = x0 + S * 0.515, pcy = y0 + S * 0.47, R = S * 0.34;
        ctx.save();
        ctx.beginPath();
        ctx.arc(pcx, pcy, R, 0, Math.PI * 2);
        ctx.clip();
        drawPhoto(ctx, v._image, pcx - R, pcy - R, 2 * R, 2 * R);
        ctx.restore();
        drawArt(ctx, artImage('couronne-sapin'), x0, y0, S, S);
        fitText(ctx, v.nom, cx, Math.min(h * 0.955, y0 + S + h * 0.085), w * 0.9, h * 0.085, (z) => `italic ${z}px 'Instrument Serif'`, INK);
      },
    },

    /* ---------- Vague catalogue : collage, classe, naissance, noces, animal, humour ---------- */

    /* Collage de 4 photos (grille 2 × 2) + titre */
    'collage-4': {
      fields: [
        { key: 'photos', label: 'Vos 4 photos', type: 'images', count: 4, labels: ['Photo 1', 'Photo 2', 'Photo 3', 'Photo 4'], default: '' },
        { key: 'titre', label: 'Titre', max: 26, default: 'Nos plus beaux souvenirs', hero: true },
        { key: 'sous_titre', label: 'Sous-titre (facultatif)', max: 30, default: 'Été 2026', optional: true },
      ],
      draw(ctx, w, h, v) {
        drawCollage(ctx, w, h, v, 2, 2);
      },
    },

    /* Collage de 6 photos (grille 2 × 3) + titre */
    'collage-6': {
      fields: [
        { key: 'photos', label: 'Vos 6 photos', type: 'images', count: 6, labels: ['Photo 1', 'Photo 2', 'Photo 3', 'Photo 4', 'Photo 5', 'Photo 6'], default: '' },
        { key: 'titre', label: 'Titre', max: 26, default: 'Notre famille', hero: true },
        { key: 'sous_titre', label: 'Sous-titre (facultatif)', max: 30, default: 'depuis 2009', optional: true },
      ],
      draw(ctx, w, h, v) {
        drawCollage(ctx, w, h, v, 2, 3);
      },
    },

    /* Fin d'année scolaire : les prénoms de toute la classe en nuage */
    classe: {
      fields: [
        { key: 'titre', label: 'Titre', max: 14, default: 'Merci' },
        { key: 'sous_titre', label: 'Sous-titre', max: 30, default: 'pour cette belle année' },
        { key: 'nom', label: 'Nom du professeur', max: 24, default: 'Madame Martin', hero: true },
        { key: 'prenoms', label: 'Prénoms des élèves (30 max.)', max: 320, default: 'Léa, Tom, Jules, Chloé, Emma, Hugo, Inès, Noah, Lina, Adam, Rose, Gabin, Zoé, Louis, Jade, Nathan, Alice, Sacha, Mila, Paul, Anna, Léo, Iris, Malo', hint: 'Séparez les prénoms par des virgules' },
        { key: 'classe', label: 'Classe et année', max: 26, default: 'CE1 · 2025-2026' },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.titre, cx, h * 0.17, w * 0.9, h * 0.16, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        fitText(ctx, v.sous_titre, cx, h * 0.25, w * 0.88, h * 0.055, (z) => `italic ${z}px 'Instrument Serif'`, INK);
        caps(ctx, v.nom, cx, h * 0.32, w * 0.88, h * 0.045, INK, 600);
        // nuage de prénoms : lignes centrées, couleurs alternées, taille réduite jusqu'à ce que tout tienne
        const names = nameList(v.prenoms, 30);
        const top = h * 0.37, bottom = h * 0.86, mw = w * 0.9;
        let size = h * 0.06, lines;
        const layout = (z) => {
          const out = [[]];
          let lw = 0;
          ctx.font = `${z}px 'Caveat'`;
          const gap = z * 0.55;
          names.forEach((n) => {
            const nw = ctx.measureText(n).width;
            if (out[out.length - 1].length && lw + gap + nw > mw) {
              out.push([]);
              lw = 0;
            }
            lw += (out[out.length - 1].length ? gap : 0) + nw;
            out[out.length - 1].push(n);
          });
          return out;
        };
        do {
          lines = layout(size);
          size *= 0.95;
        } while (size > 6 && lines.length * size * 1.25 > bottom - top);
        size /= 0.95;
        const lh = size * 1.25, y0 = top + (bottom - top - lines.length * lh) / 2 + size;
        let k = 0;
        lines.forEach((line, li) => {
          ctx.font = `${size}px 'Caveat'`;
          const gap = size * 0.55;
          const total = line.reduce((a, n) => a + ctx.measureText(n).width, 0) + gap * (line.length - 1);
          let x = cx - total / 2;
          ctx.textAlign = 'left';
          line.forEach((n) => {
            ctx.fillStyle = KIDS[k++ % KIDS.length];
            ctx.fillText(n, x, y0 + li * lh);
            x += ctx.measureText(n).width + gap;
          });
        });
        ctx.textAlign = 'center';
        caps(ctx, v.classe, cx, h * 0.94, w * 0.7, h * 0.035, MUTED, 600);
      },
    },

    /* Naissance « lune et étoiles » : prénom, date, heure, poids, taille */
    'naissance-lune': {
      fields: [
        { key: 'prenom', label: 'Prénom', max: 14, default: 'Gabriel', hero: true },
        { key: 'date', label: 'Date de naissance', max: 22, default: '3 janvier 2026' },
        { key: 'heure', label: 'Heure', max: 8, default: '6 h 12' },
        { key: 'poids', label: 'Poids', max: 8, default: '3,4 kg' },
        { key: 'taille', label: 'Taille', max: 8, default: '51 cm' },
        { key: 'ville', label: 'Ville (facultatif)', max: 24, default: 'Lyon', optional: true },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2, my = h * 0.2, r = Math.min(w * 0.14, h * 0.11);
        // croissant de lune doré et étoiles
        ctx.save();
        ctx.fillStyle = GOLD;
        ctx.beginPath();
        ctx.arc(cx, my, r, 0, Math.PI * 2);
        ctx.arc(cx + r * 0.45, my - r * 0.25, r * 0.85, 0, Math.PI * 2, true);
        ctx.fill('evenodd');
        ctx.restore();
        [[-0.3, 0.1, 0.03], [0.28, 0.06, 0.022], [0.34, 0.24, 0.016], [-0.22, 0.3, 0.018], [0.18, 0.33, 0.014]].forEach(([dx, y, s]) =>
          star(ctx, cx + dx * w, h * y, h * s, GOLD)
        );
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.prenom, cx, h * 0.5, w * 0.9, h * 0.17, (z) => `${z}px 'Pinyon Script'`, INK);
        fitText(ctx, v.date, cx, h * 0.58, w * 0.8, h * 0.05, (z) => `italic ${z}px 'Instrument Serif'`, MUTED);
        const stats = [['Heure', v.heure], ['Poids', v.poids], ['Taille', v.taille]];
        stats.forEach(([k, val], i) => {
          const x = w * (0.2 + i * 0.3);
          caps(ctx, k, x, h * 0.69, w * 0.26, h * 0.025, MUTED, 600);
          fitText(ctx, val, x, h * 0.76, w * 0.26, h * 0.06, (z) => `${z}px 'Instrument Serif'`, INK);
        });
        if (v.ville) caps(ctx, v.ville, cx, h * 0.9, w * 0.7, h * 0.035, GOLD, 600);
      },
    },

    /* « Mon premier anniversaire » : grand 1, ballons, prénom */
    'premier-anniversaire': {
      fields: [
        { key: 'prenom', label: 'Prénom', max: 12, default: 'Lou', hero: true },
        { key: 'age', label: 'Âge', max: 2, default: '1' },
        { key: 'titre', label: 'Titre', max: 26, default: 'Mon premier anniversaire' },
        { key: 'date', label: 'Date (facultatif)', max: 20, default: '12 mars 2027', optional: true },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        // ballons
        [[-0.28, 0.2, KIDS[0]], [0.26, 0.16, KIDS[1]], [0.33, 0.33, KIDS[2]], [-0.34, 0.36, KIDS[3]]].forEach(([dx, y, col]) => {
          const bx = cx + dx * w, by = h * y, br = Math.min(w, h) * 0.07;
          ctx.save();
          ctx.strokeStyle = MUTED;
          ctx.lineWidth = Math.max(1, br * 0.05);
          ctx.beginPath();
          ctx.moveTo(bx, by + br * 1.15);
          ctx.quadraticCurveTo(bx - br * 0.3, by + br * 2, bx, by + br * 2.8);
          ctx.stroke();
          ctx.fillStyle = col;
          ctx.beginPath();
          ctx.ellipse(bx, by, br * 0.85, br, 0, 0, Math.PI * 2);
          ctx.fill();
          ctx.globalAlpha = 0.35;
          ctx.fillStyle = '#fff';
          ctx.beginPath();
          ctx.ellipse(bx - br * 0.3, by - br * 0.35, br * 0.18, br * 0.28, -0.5, 0, Math.PI * 2);
          ctx.fill();
          ctx.restore();
        });
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.age, cx, h * 0.52, w * 0.5, h * 0.42, (z) => `${z}px 'Instrument Serif'`, ACCENT);
        fitText(ctx, v.titre, cx, h * 0.63, w * 0.9, h * 0.055, (z) => `italic ${z}px 'Instrument Serif'`, INK);
        fitText(ctx, v.prenom, cx, h * 0.82, w * 0.9, h * 0.17, (z) => `${z}px 'Caveat'`, KIDS[3]);
        if (v.date) caps(ctx, v.date, cx, h * 0.93, w * 0.7, h * 0.035, MUTED, 600);
      },
    },

    /* Anniversaire de mariage : « 10 ans », noces, prénoms */
    noces: {
      fields: [
        { key: 'annees', label: "Nombre d'années", max: 3, default: '10' },
        { key: 'noces', label: 'Noces', max: 22, default: "Noces d'étain" },
        { key: 'prenoms', label: 'Vos prénoms', max: 28, default: 'Clara & Hugo', hero: true },
        { key: 'date', label: 'Ligne du bas', max: 30, default: 'mariés le 14 juin 2016' },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2, cy = h * 0.3, R = Math.min(w * 0.3, h * 0.2);
        // lauriers
        [-1, 1].forEach((side) => {
          for (let i = 0; i < 9; i++) {
            const t = Math.PI / 2 + side * (0.35 + i * 0.25);
            leaf(ctx, cx + Math.cos(t) * R, cy + Math.sin(t) * R, R * 0.3, t + side * Math.PI / 2 - side * 0.5, i % 2 ? GOLD : '#c9a45f');
          }
        });
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        fitText(ctx, v.annees, cx, cy + R * 0.28, R * 1.2, R * 0.9, (z) => `${z}px 'Instrument Serif'`, INK);
        caps(ctx, Number(v.annees) > 1 ? 'ans' : 'an', cx, cy + R * 0.6, R, R * 0.14, GOLD, 700);
        fitText(ctx, v.noces, cx, h * 0.62, w * 0.9, h * 0.075, (z) => `italic ${z}px 'Instrument Serif'`, INK);
        fitText(ctx, v.prenoms, cx, h * 0.8, w * 0.92, h * 0.15, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        caps(ctx, v.date, cx, h * 0.92, w * 0.85, h * 0.032, MUTED, 600);
      },
    },

    /* « Maman de chat », « Papa du chien » : silhouette + nom de l'animal */
    'parent-animal': {
      fields: [
        { key: 'titre', label: 'Titre', max: 20, default: 'Maman de chat' },
        { key: 'nom', label: "Nom de l'animal", max: 16, default: 'Minou', hero: true },
        { key: 'espece', label: 'Silhouette', type: 'select', options: ['Chat', 'Chien'], default: 'Chat' },
        { key: 'ligne', label: 'Petite phrase (facultatif)', max: 28, default: 'et fière de l’être', optional: true },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2, s = Math.min(w * 0.3, h * 0.22), base = h * 0.46;
        ctx.save();
        ctx.fillStyle = INK;
        if (v.espece === 'Chien') {
          // chien : grande empreinte de patte, plus lisible qu'une silhouette
          paw(ctx, cx, base - s * 0.62, s * 0.8, INK, 0);
        } else {
          // chat assis : corps, tête, oreilles pointues, queue enroulée
          ctx.beginPath();
          ctx.ellipse(cx, base - s * 0.38, s * 0.38, s * 0.45, 0, 0, Math.PI * 2);
          ctx.arc(cx, base - s * 0.98, s * 0.25, 0, Math.PI * 2);
          ctx.fill();
          ctx.beginPath();
          ctx.moveTo(cx - s * 0.23, base - s * 1.08);
          ctx.lineTo(cx - s * 0.2, base - s * 1.36);
          ctx.lineTo(cx - s * 0.05, base - s * 1.18);
          ctx.moveTo(cx + s * 0.23, base - s * 1.08);
          ctx.lineTo(cx + s * 0.2, base - s * 1.36);
          ctx.lineTo(cx + s * 0.05, base - s * 1.18);
          ctx.fill();
          ctx.lineWidth = s * 0.08;
          ctx.lineCap = 'round';
          ctx.strokeStyle = INK;
          ctx.beginPath();
          ctx.moveTo(cx + s * 0.3, base - s * 0.08);
          ctx.quadraticCurveTo(cx + s * 0.75, base - s * 0.05, cx + s * 0.62, base - s * 0.5);
          ctx.stroke();
        }
        ctx.restore();
        heart(ctx, cx + s * 0.55, base - s * 1.2, s * 0.09, ACCENT);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        caps(ctx, v.titre, cx, h * 0.6, w * 0.9, h * 0.06, INK, 700);
        fitText(ctx, v.nom, cx, h * 0.8, w * 0.9, h * 0.17, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        if (v.ligne) fitText(ctx, v.ligne, cx, h * 0.92, w * 0.85, h * 0.05, (z) => `italic ${z}px 'Instrument Serif'`, MUTED);
      },
    },

    /* « Je peux pas, j'ai pétanque » */
    'je-peux-pas': {
      fields: [
        { key: 'haut', label: 'Première ligne', max: 18, default: 'Je peux pas' },
        { key: 'jai', label: 'Deuxième ligne', max: 10, default: 'j’ai' },
        { key: 'activite', label: 'Activité', max: 16, default: 'pétanque', hero: true },
        { key: 'prenom', label: 'Prénom (facultatif)', max: 16, default: '', optional: true },
      ],
      draw(ctx, w, h, v) {
        const cx = w / 2;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        ctx.save();
        ctx.letterSpacing = `${h * 0.004}px`;
        fitText(ctx, v.haut.toUpperCase(), cx, h * 0.3, w * 0.92, h * 0.15, (z) => `800 ${z}px 'Geist'`, INK);
        ctx.restore();
        fitText(ctx, v.jai, cx, h * 0.44, w * 0.6, h * 0.09, (z) => `italic ${z}px 'Instrument Serif'`, MUTED);
        const size = fitText(ctx, v.activite, cx, h * 0.66, w * 0.94, h * 0.22, (z) => `${z}px 'Pinyon Script'`, ACCENT);
        // soulignement tracé à la main
        ctx.font = `${size}px 'Pinyon Script'`;
        const tw = Math.min(w * 0.8, ctx.measureText(v.activite).width);
        ctx.save();
        ctx.strokeStyle = GOLD;
        ctx.lineWidth = Math.max(2, h * 0.008);
        ctx.lineCap = 'round';
        ctx.beginPath();
        ctx.moveTo(cx - tw * 0.45, h * 0.73);
        ctx.quadraticCurveTo(cx, h * 0.705, cx + tw * 0.45, h * 0.725);
        ctx.stroke();
        ctx.restore();
        if (v.prenom) fitText(ctx, v.prenom, cx, h * 0.88, w * 0.7, h * 0.08, (z) => `${z}px 'Caveat'`, INK);
      },
    },

    /* Calendrier photo : couverture + 12 mois + page de fin (dessin page par page, sur le fichier complet) */
    calendrier: {
      pages: 14,
      fields: [
        { key: 'titre', label: 'Titre de la couverture', max: 22, default: 'Famille Martin', hero: true },
        { key: 'annee', label: 'Année', type: 'select', options: ['2027', '2026'], default: '2027' },
        { key: 'photos', label: 'Vos photos (couverture + 12 mois)', type: 'images', count: 13, default: '' },
      ],
      /* aperçu « une face » (collections, cartes) : la couverture */
      draw(ctx, w, h, v) {
        drawCalendarPage(ctx, w, h, v, 0, { top: h * 0.05, side: w * 0.04, bottom: h * 0.03 });
      },
      drawPage(ctx, W, H, v, page, safe) {
        drawCalendarPage(ctx, W, H, v, page, safe);
      },
    },

    /* Affiche de naissance */
    naissance: {
      fields: [
        { key: 'prenom', label: 'Prénom', max: 14, default: 'Léa', hero: true },
        { key: 'genre', label: 'Accord', type: 'select', options: ['Née le', 'Né le'], default: 'Née le' },
        { key: 'date', label: 'Date de naissance', max: 20, default: '12 mars 2026' },
        { key: 'heure', label: 'Heure', max: 10, default: '8 h 42' },
        { key: 'poids', label: 'Poids', max: 10, default: '3,2 kg' },
        { key: 'taille', label: 'Taille', max: 10, default: '49 cm' },
        { key: 'ville', label: 'Ville', max: 24, default: 'Nantes' },
      ],
      draw(ctx, w, h, v) {
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        const cx = w / 2;
        const bienvenue = 'BIENVENUE À';
        ctx.fillStyle = MUTED;
        ctx.font = `500 ${w * 0.032}px 'Geist'`;
        ctx.letterSpacing = `${w * 0.009}px`;
        ctx.fillText(bienvenue, cx, h * 0.17);
        ctx.letterSpacing = '0px';
        fitText(ctx, v.prenom, cx, h * 0.33, w * 0.86, w * 0.22, (s) => `${s}px 'Pinyon Script'`, ACCENT);
        // double arc
        const r = w * 0.26;
        ctx.lineWidth = w * 0.005;
        ctx.strokeStyle = '#e8b9a6';
        ctx.beginPath();
        ctx.arc(cx, h * 0.55, r, Math.PI, 0);
        ctx.stroke();
        ctx.strokeStyle = '#efcc83';
        ctx.lineWidth = w * 0.004;
        ctx.beginPath();
        ctx.arc(cx, h * 0.55, r - w * 0.03, Math.PI, 0);
        ctx.stroke();
        // informations sur 2 colonnes
        const cells = [
          [v.genre.toUpperCase(), v.date],
          ['À', v.heure],
          ['POIDS', v.poids],
          ['TAILLE', v.taille],
        ];
        cells.forEach(([k, val], i) => {
          const x = cx + (i % 2 === 0 ? -1 : 1) * w * 0.21;
          const y = h * 0.64 + Math.floor(i / 2) * h * 0.11;
          ctx.fillStyle = MUTED;
          ctx.font = `${w * 0.027}px 'Geist'`;
          ctx.letterSpacing = `${w * 0.005}px`;
          ctx.fillText(k, x, y);
          ctx.letterSpacing = '0px';
          fitText(ctx, val, x, y + w * 0.075, w * 0.4, w * 0.068, (s) => `${s}px 'Instrument Serif'`, INK);
        });
        fitText(ctx, v.ville, cx, h * 0.9, w * 0.7, w * 0.06, (s) => `italic ${s}px 'Instrument Serif'`, MUTED);
      },
    },

    /* ---------- Tableaux photo (toile, cadre, plexi ; portrait ou paysage) ----------
       « bleed » : le fond du design (back) déborde en miroir sur le fond perdu et les retours de la toile (paintBleed),
       le texte reste sur la face. Mises en page valables dans les deux orientations. */

    /* Photo plein cadre + texte facultatif en bas */
    'tableau-photo': {
      bleed: true,
      fields: [
        { key: 'photo', label: 'Votre photo', type: 'image', default: '' },
        { key: 'texte', label: 'Texte sur la photo (facultatif)', max: 36, default: '', optional: true, hero: true },
      ],
      back(ctx, w, h, v) {
        drawPhoto(ctx, v._image, 0, 0, w, h);
      },
      draw(ctx, w, h, v) {
        drawPhoto(ctx, v._image, 0, 0, w, h);
        if (!(v.texte && String(v.texte).trim())) return;
        const m = Math.min(w, h);
        const g = ctx.createLinearGradient(0, h - m * 0.34, 0, h);
        g.addColorStop(0, 'rgba(24,14,10,0)');
        g.addColorStop(1, 'rgba(24,14,10,0.5)');
        ctx.fillStyle = g;
        ctx.fillRect(0, h - m * 0.34, w, m * 0.34);
        ctx.save();
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        ctx.shadowColor = 'rgba(0,0,0,.35)';
        ctx.shadowBlur = m * 0.012;
        fitText(ctx, v.texte, w / 2, h - m * 0.085, w * 0.82, m * 0.12, (z) => `${z}px 'Pinyon Script'`, '#fffaf2');
        ctx.restore();
      },
    },

    /* Photo + bandeau crème : titre manuscrit et sous-titre */
    'tableau-souvenir': {
      bleed: true,
      fields: [
        { key: 'photo', label: 'Votre photo', type: 'image', default: '' },
        { key: 'titre', label: 'Titre', max: 28, default: 'Nos plus beaux souvenirs', hero: true },
        { key: 'sous_titre', label: 'Sous-titre (facultatif)', max: 36, default: 'Été 2026', optional: true },
      ],
      back(ctx, w, h, v) {
        photoBand(ctx, w, h, v);
      },
      draw(ctx, w, h, v) {
        const [y0, bh] = photoBand(ctx, w, h, v);
        bandText(ctx, w, y0, bh, v.titre, v.sous_titre, (z) => `${z}px 'Pinyon Script'`, ACCENT);
      },
    },

    /* Photo de famille + « Famille Martin » et les prénoms */
    'tableau-famille': {
      bleed: true,
      fields: [
        { key: 'photo', label: 'Votre photo', type: 'image', default: '' },
        { key: 'nom', label: 'Nom de la famille', max: 24, default: 'Famille Martin', hero: true },
        { key: 'prenoms', label: 'Prénoms (facultatif)', max: 48, default: 'Paul · Julie · Léo · Emma', optional: true },
      ],
      back(ctx, w, h, v) {
        photoBand(ctx, w, h, v);
      },
      draw(ctx, w, h, v) {
        const [y0, bh] = photoBand(ctx, w, h, v);
        bandText(ctx, w, y0, bh, v.nom, v.prenoms, (z) => `italic ${z}px 'Instrument Serif'`, INK);
      },
    },

    /* Photo de couple + « Léa & Tom » et une date */
    'tableau-couple': {
      bleed: true,
      fields: [
        { key: 'photo', label: 'Votre photo', type: 'image', default: '' },
        { key: 'prenom1', label: 'Premier prénom', max: 14, default: 'Léa', hero: true },
        { key: 'prenom2', label: 'Second prénom', max: 14, default: 'Tom' },
        { key: 'date', label: 'Date ou phrase (facultatif)', max: 36, default: 'Depuis le 14 juillet 2019', optional: true },
      ],
      back(ctx, w, h, v) {
        photoBand(ctx, w, h, v);
      },
      draw(ctx, w, h, v) {
        const [y0, bh] = photoBand(ctx, w, h, v);
        bandText(ctx, w, y0, bh, `${v.prenom1} & ${v.prenom2}`, v.date, (z) => `${z}px 'Pinyon Script'`, ACCENT);
      },
    },

    /* Naissance : photo + prénom et infos de naissance */
    'tableau-naissance': {
      bleed: true,
      fields: [
        { key: 'photo', label: 'Votre photo', type: 'image', default: '' },
        { key: 'prenom', label: 'Prénom', max: 16, default: 'Léon', hero: true },
        { key: 'infos', label: 'Date, poids, taille (facultatif)', max: 44, default: '12 mars 2026 · 3,2 kg · 50 cm', optional: true },
      ],
      back(ctx, w, h, v) {
        photoBand(ctx, w, h, v);
      },
      draw(ctx, w, h, v) {
        const [y0, bh] = photoBand(ctx, w, h, v);
        bandText(ctx, w, y0, bh, v.prenom, v.infos, (z) => `${z}px 'Pinyon Script'`, ACCENT);
      },
    },

    /* Animal : photo + nom et une phrase */
    'tableau-animal': {
      bleed: true,
      fields: [
        { key: 'photo', label: 'Votre photo', type: 'image', default: '' },
        { key: 'nom', label: 'Son nom', max: 16, default: 'Rocky', hero: true },
        { key: 'ligne', label: 'Phrase (facultatif)', max: 36, default: 'Le meilleur chien du monde', optional: true },
      ],
      back(ctx, w, h, v) {
        photoBand(ctx, w, h, v);
      },
      draw(ctx, w, h, v) {
        const [y0, bh] = photoBand(ctx, w, h, v);
        bandText(ctx, w, y0, bh, v.nom, v.ligne, (z) => `italic ${z}px 'Instrument Serif'`, ACCENT);
      },
    },

    /* Mosaïque de 6 photos (3 × 2 en paysage, 2 × 3 en portrait) + titre facultatif */
    'tableau-mosaique': {
      bleed: true,
      fields: [
        { key: 'photos', label: 'Vos 6 photos', type: 'images', count: 6, labels: ['Photo 1', 'Photo 2', 'Photo 3', 'Photo 4', 'Photo 5', 'Photo 6'], default: '' },
        { key: 'titre', label: 'Titre (facultatif)', max: 28, default: 'Nos plus beaux souvenirs', optional: true, hero: true },
      ],
      back(ctx, w, h, v) {
        mosaic(ctx, w, h, v);
      },
      draw(ctx, w, h, v) {
        const band = mosaic(ctx, w, h, v);
        if (band) bandText(ctx, w, h - band, band, v.titre, '', (z) => `${z}px 'Pinyon Script'`, ACCENT);
      },
    },
  };

  /** Message intérieur d'une carte : texte centré, retour à la ligne automatique, signature en dessous. */
  function drawCardInside(ctx, x, y, w, h, v) {
    ctx.save();
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';
    const cx = x + w / 2;
    let size = h * 0.085, lines;
    do {
      ctx.font = `${size}px 'Caveat'`;
      lines = String(v.message || '').split(/\n/).flatMap((para) => wrapLines(ctx, para, w * 0.86));
      size *= 0.95;
    } while (size > 6 && lines.length * size * 1.3 > h * 0.6);
    size /= 0.95;
    const lh = size * 1.3;
    const y0 = y + h * 0.42 - (lines.length * lh) / 2 + size;
    ctx.fillStyle = INK;
    lines.forEach((l, i) => ctx.fillText(l, cx, y0 + i * lh));
    if (v.signature) fitText(ctx, v.signature, cx, y + h * 0.84, w * 0.86, h * 0.11, (z) => `${z}px 'Pinyon Script'`, ACCENT);
    ctx.restore();
  }

  /** Transforme un design (recto) en carte pliée : mêmes champs + message intérieur + signature. */
  function cardOf(baseKey, message, signature) {
    const base = DESIGNS[baseKey];
    return {
      pages: 2,
      card: true,
      base: baseKey,
      fields: [
        ...base.fields,
        { key: 'message', label: 'Message à l’intérieur', type: 'textarea', max: 200, default: message },
        { key: 'signature', label: 'Signature', max: 30, default: signature },
      ],
      draw(ctx, w, h, v) {
        base.draw(ctx, w, h, v);
      },
      drawPage(ctx, W, H, v, page, safe) {
        const half = W / 2, mx = half * 0.09, my = H * 0.08;
        if (page === 0) {
          // recto (moitié droite) : le design ; verso (moitié gauche) : discret
          ctx.save();
          ctx.translate(half + mx, my);
          base.draw(ctx, half - 2 * mx, H - 2 * my, v);
          ctx.restore();
          ctx.save();
          ctx.textAlign = 'center';
          caps(ctx, 'Idéocadeaux', half / 2, H - my, half * 0.5, H * 0.022, MUTED, 600);
          ctx.restore();
        } else {
          drawCardInside(ctx, half + mx, my, half - 2 * mx, H - 2 * my, v);
        }
      },
    };
  }

  function values(designKey, input) {
    const d = DESIGNS[designKey];
    const out = {};
    // champ vide : valeur par défaut, sauf pour un champ facultatif que le client a volontairement vidé
    d.fields.forEach((f) => (out[f.key] = input && input[f.key] !== undefined && (input[f.key] !== '' || f.optional) ? input[f.key] : f.default));
    if (input && input._image) out._image = input._image;
    if (input && input._images) out._images = input._images;
    if (input && input._samples) out._samples = input._samples;
    if (input && input._page) out._page = input._page;
    if (input && input._dark) out._dark = true;
    return out;
  }

  /** Dessine une face du design dans un contexte (aperçu). */
  function drawFace(ctx, designKey, w, h, input) {
    ctx.save();
    // textile foncé : palette claire le temps du dessin (aperçu ET fichier d'impression passent par ici)
    if (input && input._dark) setPalette(LIGHT_PALETTE);
    try {
      DESIGNS[designKey].draw(ctx, w, h, values(designKey, input));
    } finally {
      setPalette(DEFAULT_PALETTE);
      ctx.restore();
    }
  }

  /** Produit le fichier d'impression HD (canvas) pour un format donné. */
  const MAX_PRINT_PIXELS = 16e6;

  /**
   * Tableaux photo : le fond du design (back : photos, bandeau) est recopié en miroir autour de la face, sur le fond perdu
   * et sur les retours de la toile (tranches du châssis) ; le texte n'est dessiné que sur la face.
   */
  function paintBleed(ctx, designKey, fmt, input) {
    const d = DESIGNS[designKey], f = fmt.face, v = values(designKey, input);
    for (let dy = -1; dy <= 1; dy++) {
      for (let dx = -1; dx <= 1; dx++) {
        if (!dx && !dy) continue;
        const x0 = Math.max(0, f.x + dx * f.w), y0 = Math.max(0, f.y + dy * f.h);
        const x1 = Math.min(fmt.width, f.x + (dx + 1) * f.w), y1 = Math.min(fmt.height, f.y + (dy + 1) * f.h);
        if (x1 <= x0 || y1 <= y0) continue;
        ctx.save();
        ctx.beginPath();
        ctx.rect(x0, y0, x1 - x0, y1 - y0);
        ctx.clip();
        // symétrie par rapport au bord de la face (gauche, droit, haut ou bas)
        ctx.translate(dx ? 2 * (dx < 0 ? f.x : f.x + f.w) : 0, dy ? 2 * (dy < 0 ? f.y : f.y + f.h) : 0);
        ctx.scale(dx ? -1 : 1, dy ? -1 : 1);
        ctx.translate(f.x, f.y);
        d.back(ctx, f.w, f.h, v);
        ctx.restore();
      }
    }
  }

  function renderPrint(designKey, formatKey, input) {
    const fmt = FORMATS[formatKey];
    // Safari (iPhone) refuse les canvas de plus de 16,7 millions de pixels : au-delà de 16 millions, on réduit
    // la définition (≈ 290 dpi pour l'affiche 30 × 40, ≈ 230 dpi pour la toile, ≈ 146 dpi pour le 60 × 80) en gardant la même mise en page.
    const k = Math.min(1, Math.sqrt(MAX_PRINT_PIXELS / (fmt.width * fmt.height)));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(fmt.width * k);
    canvas.height = Math.round(fmt.height * k);
    const ctx = canvas.getContext('2d');
    ctx.scale(k, k);
    if (fmt.background) {
      // le fond couvre tout le fichier, fond perdu et retours de châssis compris
      ctx.fillStyle = fmt.background;
      ctx.fillRect(0, 0, fmt.width, fmt.height);
    }
    const bleed = DESIGNS[designKey].bleed && fmt.faces === 1;
    if (bleed) paintBleed(ctx, designKey, fmt, input);
    const [fx, fy] = bleed ? [0, 0] : fmt.margin;
    const faces = fmt.faces === 1
      ? [fmt.face]
      : fmt.centers.map((c) => {
          const w = fmt.width * fmt.faceWidth;
          return { x: fmt.width * c - w / 2, y: 0, w, h: fmt.height };
        });
    faces.forEach((f) => {
      ctx.save();
      const mx = f.w * fx;
      const my = f.h * fy;
      ctx.translate(f.x + mx, f.y + my);
      drawFace(ctx, designKey, f.w - 2 * mx, f.h - 2 * my, input);
      ctx.restore();
    });
    // broderie : fichier ramené aux fils Gelato ; les fils utilisés partent avec la commande (threadColors)
    if (fmt.emb) canvas.threads = threadify(canvas);
    return canvas;
  }

  /** Rend une page d'un design multi-pages au format d'impression (canvas plein fichier). */
  function renderPage(designKey, formatKey, input, page) {
    const fmt = FORMATS[formatKey];
    const c = document.createElement('canvas');
    c.width = fmt.width;
    c.height = fmt.height;
    const ctx = c.getContext('2d');
    ctx.fillStyle = fmt.background;
    ctx.fillRect(0, 0, c.width, c.height);
    const d = DESIGNS[designKey];
    d.drawPage(ctx, c.width, c.height, values(designKey, input), page, { top: fmt.safeTop, side: fmt.safeSide, bottom: fmt.safeSide });
    return c;
  }

  /**
   * PDF multi-pages : chaque page est une image JPEG pleine page (fond perdu compris).
   * Les pages sont produites une par une pour limiter la mémoire (important sur mobile).
   */
  /** Octets JPEG d'un canvas : asynchrone (site) ou synchrone (tests automatisés). */
  async function jpegBytes(canvas, sync) {
    if (sync) {
      const bin = atob(canvas.toDataURL('image/jpeg', 0.92).split(',')[1]);
      const out = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
      return out;
    }
    return new Uint8Array(await (await new Promise((r) => canvas.toBlob(r, 'image/jpeg', 0.92))).arrayBuffer());
  }

  async function renderPdf(designKey, formatKey, input, onProgress, sync) {
    const fmt = FORMATS[formatKey];
    const dpi = fmt.dpi || 300;
    const wPt = (fmt.width / dpi) * 72, hPt = (fmt.height / dpi) * 72;
    const enc = new TextEncoder();
    const chunks = [];
    const offsets = [];
    let size = 0;
    const push = (part) => {
      const b = typeof part === 'string' ? enc.encode(part) : part;
      chunks.push(b);
      size += b.length;
    };
    const obj = (n, body) => {
      offsets[n] = size;
      push(`${n} 0 obj\n`);
      body();
      push('\nendobj\n');
    };
    const pages = DESIGNS[designKey].pages;
    const pageIds = [];
    push('%PDF-1.4\n%\xE2\xE3\xCF\xD3\n');
    let next = 3;
    for (let p = 0; p < pages; p++) {
      const canvas = renderPage(designKey, formatKey, input, p);
      const jpg = await jpegBytes(canvas, sync);
      canvas.width = canvas.height = 0; // libère la mémoire tout de suite
      const [img, content, pg] = [next, next + 1, next + 2];
      next += 3;
      obj(img, () => {
        push(`<< /Type /XObject /Subtype /Image /Width ${fmt.width} /Height ${fmt.height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${jpg.length} >>\nstream\n`);
        push(jpg);
        push('\nendstream');
      });
      const draw = `q ${wPt.toFixed(2)} 0 0 ${hPt.toFixed(2)} 0 0 cm /Im0 Do Q`;
      obj(content, () => push(`<< /Length ${draw.length} >>\nstream\n${draw}\nendstream`));
      obj(pg, () => push(`<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${wPt.toFixed(2)} ${hPt.toFixed(2)}] /Resources << /XObject << /Im0 ${img} 0 R >> >> /Contents ${content} 0 R >>`));
      pageIds.push(pg);
      if (onProgress) onProgress(p + 1, pages);
    }
    obj(1, () => push('<< /Type /Catalog /Pages 2 0 R >>'));
    obj(2, () => push(`<< /Type /Pages /Kids [${pageIds.map((i) => `${i} 0 R`).join(' ')}] /Count ${pageIds.length} >>`));
    const xref = size;
    const count = next;
    let table = `xref\n0 ${count}\n0000000000 65535 f \n`;
    for (let i = 1; i < count; i++) table += `${String(offsets[i]).padStart(10, '0')} 00000 n \n`;
    push(table);
    push(`trailer\n<< /Size ${count} /Root 1 0 R >>\nstartxref\n${xref}\n%%EOF\n`);
    if (sync) {
      const all = new Uint8Array(size);
      let o = 0;
      chunks.forEach((c) => {
        all.set(c, o);
        o += c.length;
      });
      return all;
    }
    return new Blob(chunks, { type: 'application/pdf' });
  }

  /*
   * Illustrations aquarelle (designs/art_aquarelle.py) : ideo-art-<nom>.webp (aperçu) et ideo-art-<nom>-hd.png
   * (impression), dans le même dossier que ce script. Un design les déclare dans « art » ; prepare(design, hd) les
   * charge et chaque arrivée émet « ideo:art » sur window (la fiche produit redessine l'aperçu). En dessin, la version
   * HD est prise si elle est chargée, sinon l'aperçu ; le fichier d'impression attend toujours la HD (prepare(…, true)).
   */
  const ART_SRC = (document.currentScript && document.currentScript.src) || '';
  const ART = {};
  function artUrl(name, hd) {
    return ART_SRC.replace(/ideo-designs\.js/, `ideo-art-${name}${hd ? '-hd.png' : '.webp'}`);
  }
  function artImage(name) {
    const a = ART[name];
    return (a && (a.hd || a.lo)) || null;
  }
  function loadArt(name, hd) {
    const slot = ART[name] || (ART[name] = {});
    const key = hd ? 'hdLoad' : 'loLoad';
    if (!slot[key]) {
      slot[key] = new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          slot[hd ? 'hd' : 'lo'] = img;
          window.dispatchEvent(new CustomEvent('ideo:art', { detail: name }));
          resolve(img);
        };
        img.onerror = () => resolve(null);
        img.src = artUrl(name, hd);
      });
    }
    return slot[key];
  }
  function artNames(designKey) {
    const d = DESIGNS[designKey];
    if (!d) return [];
    return d.art || (d.base && DESIGNS[d.base] && DESIGNS[d.base].art) || [];
  }
  /** Charge les illustrations d'un design : aperçu (hd = false) ou impression (hd = true). */
  function prepare(designKey, hd) {
    return Promise.all(artNames(designKey).map((n) => loadArt(n, hd)));
  }
  /** Dessine une illustration entière dans la boîte (x, y, w, h), centrée (ou posée en bas : align = 'bottom'). */
  function drawArt(ctx, img, x, y, w, h, align) {
    if (!img) return null;
    const k = Math.min(w / img.width, h / img.height);
    const dw = img.width * k, dh = img.height * k;
    const dx = x + (w - dw) / 2, dy = align === 'bottom' ? y + h - dh : y + (h - dh) / 2;
    ctx.drawImage(img, dx, dy, dw, dh);
    return { x: dx, y: dy, w: dw, h: dh };
  }

  async function fontsReady(designKey) {
    const fams = ["16px 'Pinyon Script'", "16px 'Instrument Serif'", "italic 16px 'Instrument Serif'", "500 16px 'Geist'", "16px 'Caveat'"];
    if (!designKey || location.protocol === 'file:' || (DESIGNS[designKey] && DESIGNS[designKey].emb)) fams.push("600 16px 'Geist'", "700 16px 'Lora'", "16px 'Pacifico'");
    await Promise.all(fams.map((f) => document.fonts.load(f).catch(() => null)));
    // scripts locaux (photos des fiches, fichiers de test, en file://) : toutes les illustrations en HD avant de dessiner
    if (location.protocol === 'file:') await Promise.all(Object.keys(DESIGNS).map((k) => prepare(k, true)));
  }

  /* Zone d'impression visible sur la photo du produit (en fraction de l'image 1088×896). */
  /* Cartes pliées : coins du recto (fond perdu compris) sur le rendu Gelato 1500 × 1071 (designs/cardwrap.py). */
  const CARD_QUAD = {
    a6: [[299, 194], [871, 83.5], [1216.5, 774], [516, 959]],
    a5: [[259, 101.5], [900, 10], [1261, 800], [480, 989]],
  };

  /** Plaque une image dans un quadrilatère (perspective approchée par un maillage de triangles affines). */
  function warpQuad(ctx, img, pts, n, persp, src) {
    const [p0, p1, p2, p3] = pts;
    // position bilinéaire dans le quadrilatère (u, v ∈ [0, 1]) — suffisant pour une perspective douce
    let at = (u, v) => [
      (1 - u) * (1 - v) * p0[0] + u * (1 - v) * p1[0] + u * v * p2[0] + (1 - u) * v * p3[0],
      (1 - u) * (1 - v) * p0[1] + u * (1 - v) * p1[1] + u * v * p2[1] + (1 - u) * v * p3[1],
    ];
    if (persp) {
      // vraie perspective (homographie carré → quadrilatère), pour les rendus 3D (toile vue de trois quarts)
      const [x0, y0] = p0, [x1, y1] = p1, [x2, y2] = p2, [x3, y3] = p3;
      const sx = x0 - x1 + x2 - x3, sy = y0 - y1 + y2 - y3;
      const dx1 = x1 - x2, dx2 = x3 - x2, dy1 = y1 - y2, dy2 = y3 - y2;
      const den = dx1 * dy2 - dx2 * dy1;
      const g = (sx * dy2 - dx2 * sy) / den, h = (dx1 * sy - sx * dy1) / den;
      const a = x1 - x0 + g * x1, b2 = x3 - x0 + h * x3, d = y1 - y0 + g * y1, e = y3 - y0 + h * y3;
      at = (u, v) => {
        const z = g * u + h * v + 1;
        return [(a * u + b2 * v + x0) / z, (d * u + e * v + y0) / z];
      };
    }
    const [sx0, sy0, W, H] = src || [0, 0, img.width, img.height];
    const tri = (s0, s1, s2, d0, d1, d2) => {
      ctx.save();
      ctx.beginPath();
      // léger débord pour éviter les liserés entre triangles
      const cx = (d0[0] + d1[0] + d2[0]) / 3, cy = (d0[1] + d1[1] + d2[1]) / 3;
      const g = (p) => [p[0] + (p[0] - cx) * 0.02, p[1] + (p[1] - cy) * 0.02];
      const [a, b, c] = [g(d0), g(d1), g(d2)];
      ctx.moveTo(a[0], a[1]);
      ctx.lineTo(b[0], b[1]);
      ctx.lineTo(c[0], c[1]);
      ctx.closePath();
      ctx.clip();
      const den = s0[0] * (s1[1] - s2[1]) + s1[0] * (s2[1] - s0[1]) + s2[0] * (s0[1] - s1[1]);
      const m11 = (d0[0] * (s1[1] - s2[1]) + d1[0] * (s2[1] - s0[1]) + d2[0] * (s0[1] - s1[1])) / den;
      const m12 = (d0[1] * (s1[1] - s2[1]) + d1[1] * (s2[1] - s0[1]) + d2[1] * (s0[1] - s1[1])) / den;
      const m21 = (d0[0] * (s2[0] - s1[0]) + d1[0] * (s0[0] - s2[0]) + d2[0] * (s1[0] - s0[0])) / den;
      const m22 = (d0[1] * (s2[0] - s1[0]) + d1[1] * (s0[0] - s2[0]) + d2[1] * (s1[0] - s0[0])) / den;
      const dx = (d0[0] * (s1[0] * s2[1] - s2[0] * s1[1]) + d1[0] * (s2[0] * s0[1] - s0[0] * s2[1]) + d2[0] * (s0[0] * s1[1] - s1[0] * s0[1])) / den;
      const dy = (d0[1] * (s1[0] * s2[1] - s2[0] * s1[1]) + d1[1] * (s2[0] * s0[1] - s0[0] * s2[1]) + d2[1] * (s0[0] * s1[1] - s1[0] * s0[1])) / den;
      ctx.setTransform(m11, m12, m21, m22, dx, dy);
      ctx.drawImage(img, 0, 0);
      ctx.restore();
    };
    for (let i = 0; i < n; i++) {
      for (let j = 0; j < n; j++) {
        const u0 = i / n, u1 = (i + 1) / n, v0 = j / n, v1 = (j + 1) / n;
        const s00 = [sx0 + u0 * W, sy0 + v0 * H], s10 = [sx0 + u1 * W, sy0 + v0 * H], s11 = [sx0 + u1 * W, sy0 + v1 * H], s01 = [sx0 + u0 * W, sy0 + v1 * H];
        const d00 = at(u0, v0), d10 = at(u1, v0), d11 = at(u1, v1), d01 = at(u0, v1);
        tri(s00, s10, s11, d00, d10, d11);
        tri(s00, s11, s01, d00, d11, d01);
      }
    }
  }

  /* Calendrier A4 : page complète dans le rendu Gelato du calendrier vierge (ideo-img-cal-a4-gelato.png, 1049 × 1500). */
  const CAL_RECT = { x0: -6, y0: 28, x1: 1058, y1: 1516.74 };
  const MUG_ZONE = { x: 0.39, y: 0.475, w: 0.225, h: 0.335 };
  /* Mug 11 oz sur le rendu Gelato du mug vierge (ideo-img-mockup-mug-gelato.jpg, 1088×896) : corps du mug relevé
     sur les côtés (x0, y0, x1, y1), flèches de l'ellipse en haut et en bas (st, sb), rotation (phi, radians), échelle et
     décalage vertical du design, calés sur l'aperçu de fabrication Gelato du même fichier. Même calcul que
     designs/decors.py (wrap_on_cylinder). */
  /* Mug 11 oz sur le rendu Gelato du mug vierge (ideo-img-mockup-mug-gelato*.jpg, 1088×896) : on enroule le VRAI
     fichier d'impression (200 × 96 mm, 2 faces) comme Gelato. Colonne x (depuis l'axe, rayon R) → θ = asin(x / R) →
     abscisse du fichier 37,2 mm + (θ - φ) · rmm. Calé par superposition sur l'aperçu de fabrication Gelato ;
     même calcul que designs/mugwrap.py. */
  const MUG_BODY = { x0: 280.2, x1: 848.9, top: 110.4, bottom: 766.6, st: 23.9, sb: 64.3, phi: -0.24, rmm: 36.0, fmt: 'mug' };
  /* Grand mug 15 oz (ideo-img-mockup-mug-gelato-grand.jpg : rendu Gelato 1500 px recadré (21, 110)-(1478, 1310) puis réduit à
     1088 × 896) : même calcul, fichier 240 × 117 mm (format « mug15 »), calé sur l'aperçu Gelato d'un vrai fichier. */
  /* Gourde (ideo-img-gourde-gelato.jpg : rendu Gelato 1500 px centré sur 1821 × 1500 puis réduit à 1088 × 896) : cylindre
     Ø 70 mm, zone 0 → 130 mm de y 708 à 1231 (rendu 1500) ; phi 0 = milieu du fichier face à l'objectif (une gourde n'a pas
     de face avant). Calé sur la mire Gelato (écart 1 à 3 px), designs/mugwrap.py GELATO_GOURDE. */
  const GOURDE_BODY = { x0: 465.8, x1: 644.7, top: 400.6, bottom: 712.8, st: 22.7, sb: 22.7, phi: 0, rmm: 36.11, fmt: 'gourde' };
  const MUG15_BODY = { x0: 326.3, x1: 869.9, top: 58.4, bottom: 790.5, st: 22.4, sb: 59.7, phi: 0.0342, rmm: 40.93, fmt: 'mug15' };

  /** Fichier d'impression du mug à définition réduite (même mise en page que renderPrint). */
  function mugPrintSmall(design, input, width, fmtKey) {
    const fmt = FORMATS[fmtKey || 'mug'];
    if (fmt.faces === 1) return printSmall(design, fmtKey, input, width);
    const s = width / fmt.width;
    const c = document.createElement('canvas');
    c.width = Math.round(fmt.width * s);
    c.height = Math.round(fmt.height * s);
    const ctx = c.getContext('2d');
    ctx.scale(s, s);
    const [fx, fy] = fmt.margin;
    fmt.centers.forEach((cc) => {
      const w = fmt.width * fmt.faceWidth;
      const f = { x: fmt.width * cc - w / 2, y: 0, w, h: fmt.height };
      ctx.save();
      ctx.translate(f.x + f.w * fx, f.y + f.h * fy);
      drawFace(ctx, design, f.w - 2 * f.w * fx, f.h - 2 * f.h * fy, input);
      ctx.restore();
    });
    return c;
  }

  /** Dessine le fichier d'impression enroulé sur le cylindre du mug (face gauche du fichier vers l'objectif). */
  function drawMugWrap(ctx, design, input, k, B = MUG_BODY) {
    const W_ = 1088, H_ = 896;
    const R = (B.x1 - B.x0) / 2, cx = (B.x0 + B.x1) / 2;
    const fmt = FORMATS[B.fmt];
    const wmm = fmt.width / MM;
    const pr = mugPrintSmall(design, input, Math.round(1400 * (wmm / 200) * Math.min(k, 1.5)), B.fmt);
    const mm = pr.width / wmm;
    const faceC = fmt.centers[0] * wmm;
    const layer = document.createElement('canvas');
    layer.width = Math.ceil(W_ * k);
    layer.height = Math.ceil(H_ * k);
    const lctx = layer.getContext('2d');
    lctx.scale(k, k);
    lctx.fillStyle = '#fff';
    lctx.fillRect(0, 0, W_, H_);
    lctx.imageSmoothingQuality = 'high';
    const step = 1 / k;
    for (let x = -R; x < R; x += step) {
      const theta = Math.asin(Math.max(-1, Math.min(1, (x + step / 2) / R)));
      const fx = (faceC + (theta - B.phi) * B.rmm) * mm;
      if (fx < 0 || fx >= pr.width - 1) continue;
      const c = Math.cos(theta);
      const top = B.top + B.st * c;
      const h = (B.bottom - B.top) + (B.sb - B.st) * c;
      const dfx = Math.max(1, ((B.rmm * mm) / Math.max(0.05, c) / R) * step);
      lctx.drawImage(pr, fx, 0, Math.min(dfx, pr.width - fx), pr.height, cx + x, top, step + 0.5, h);
    }
    ctx.save();
    ctx.globalCompositeOperation = 'multiply';
    ctx.drawImage(layer, 0, 0, W_, H_);
    ctx.restore();
    pr.width = pr.height = 0;
    layer.width = layer.height = 0;
  }
  /* T-shirt sur le rendu Gelato du t-shirt vierge (ideo-img-tshirt-gelato-<couleur>.jpg, 1500 × 1500) : le fichier
     d'impression 3:4 couvre exactement cette zone (mire puis vrai fichier en commande brouillon, sur 3 couleurs) ; Gelato
     pose l'encre telle quelle (même calcul que designs/tshirtwrap.py). */
  const TSHIRT_BOX = { x0: 519, y0: 389, x1: 990, y1: 1017, size: 1500 };
  /* T-shirt coupe femme (ideo-img-tshirt-gelato-femme-<couleur>.jpg, Gildan 64000L) : Gelato ne garde que 300 × 360 mm
     → fichier « tshirt-kids », posé dans cette zone (mire puis vrai fichier en brouillon, designs/tshirtwrap.py). */
  const TSHIRT_FEMME_BOX = { x0: 552, y0: 305, x1: 955, y1: 789, size: 1500, fmt: 'tshirt-kids' };
  /* Body bébé (ideo-img-body-gelato-<style>.jpg) : manches longues « ml-* » et manches courtes « mc-* » n'ont pas la même
     échelle de rendu chez Gelato (mire puis vrai fichier, designs/bodywrap.py). */
  const BODY_BOX = {
    ml: { x0: 574, y0: 294, x1: 925, y1: 762, size: 1500 },
    mc: { x0: 467, y0: 286, x1: 1001, y1: 998, size: 1500 },
  };
  /* Sweats (ideo-img-sweat-gelato-<style>.jpg) : col rond « col-* » (fichier 3:4 entier) et capuche « cap-* » (fichier
     carré, zone 30 × 30 cm au-dessus de la poche) ; mesurés par mire en commande brouillon (designs/sweatwrap.py). */
  /* Tote bag naturel (ideo-img-tote-gelato-naturel.jpg, 892 × 1500) : le fichier carré (format « tote ») couvre exactement
     cette zone (vrai fichier en commande brouillon, erreur 2/255 ; designs/totewrap.py). */
  const TOTE_BOX = { x0: 217, y0: 727, x1: 706, y1: 1216, iw: 892, ih: 1500, fmt: 'tote', zf: 0.46 };
  /* Textile enfant (ideo-img-enfant-gelato-<style>.jpg) : t-shirt « tee-* » (fichier 300 × 360 mm) et sweat à capuche
     « cap-* » (fichier carré « hoodie »), mesurés par mire puis vrais fichiers en brouillon (designs/kidswrap.py). */
  const KIDS_BOX = {
    tee: { x0: 525, y0: 385, x1: 982, y1: 933, size: 1500, fmt: 'tshirt-kids' },
    cap: { x0: 622, y0: 419, x1: 886, y1: 683, size: 1500, fmt: 'hoodie' },
  };
  /* Coques (ideo-img-coque-gelato-<fine|renforcee>-<modèle>.jpg, rendus Gelato 1500 px) : centre de la face avant et px par
     mm du fichier 100 × 170 mm, mesurés sur une mire par modèle (designs/coquewrap.py → data/probe/coque-geo.json). */
  /* Tableaux photo (ideo-img-tab-gelato-<support>-<taille>-<ver|hor>.jpg, rendus Gelato ; coordonnées dans le rendu d'origine
     « size ») : cadre et plexi = rectangle du fichier entier (« rect ») et ouverture du cadre (« open ») ; toile en 3D = face
     avant et tranche gauche (« front », « side »). Mesuré sur les mires en brouillon (designs/tableauwrap.py, build_geo). */
  const TAB_GEO = {"toile-30-ver":{"front":[[116.0,114.7],[763.5,241.2],[763.5,1257.7],[116.0,1384.5]],"side":[[71.5,126.9],[116.0,113.6],[116.0,1385.7],[71.5,1372.4]],"size":[949,1500]},"toile-30-hor":{"front":[[145.0,142.6],[1237.5,261.1],[1237.5,1210.8],[145.0,1329.5]],"side":[[89.5,154.0],[145.0,141.7],[145.0,1330.5],[89.5,1318.0]],"size":[1500,1473]},"toile-45-ver":{"front":[[83.0,81.7],[777.5,215.1],[777.5,1283.9],[83.0,1417.4]],"side":[[52.5,94.7],[83.0,81.0],[83.0,1417.9],[52.5,1404.2]],"size":[936,1500]},"toile-45-hor":{"front":[[104.0,101.7],[1269.5,226.5],[1269.5,1225.4],[104.0,1350.5]],"side":[[65.5,113.9],[104.0,101.0],[104.0,1350.9],[65.5,1337.9]],"size":[1500,1453]},"toile-60-ver":{"front":[[65.0,64.6],[784.5,201.5],[784.5,1297.4],[65.0,1434.5]],"side":[[41.5,78.4],[65.0,64.5],[65.0,1435.8],[41.5,1421.7]],"size":[929,1500]},"toile-60-hor":{"front":[[81.0,80.6],[1286.5,208.5],[1286.5,1232.4],[81.0,1360.6]],"side":[[52.5,93.3],[81.0,80.4],[81.0,1360.5],[52.5,1347.9]],"size":[1500,1442]},"cadre-naturel-30-ver":{"rect":[38.0,38.1,1113.0,1460.0],"open":[52,52,1099,1446],"size":[1153,1500]},"cadre-naturel-30-hor":{"rect":[38.1,38.0,1460.0,1113.0],"open":[52,52,1446,1099],"size":[1500,1153]},"cadre-naturel-45-ver":{"rect":[29.7,29.8,1112.0,1467.8],"open":[40,40,1102,1458],"size":[1144,1500]},"cadre-naturel-45-hor":{"rect":[29.8,29.7,1467.8,1112.0],"open":[40,40,1458,1102],"size":[1500,1144]},"cadre-naturel-60-ver":{"rect":[24.4,24.5,1115.0,1473.0],"open":[33,33,1107,1465],"size":[1142,1500]},"cadre-naturel-60-hor":{"rect":[24.5,24.2,1472.9,1115.0],"open":[33,33,1465,1107],"size":[1500,1142]},"cadre-noir-30-ver":{"rect":[38.0,38.1,1113.0,1460.0],"open":[52,52,1099,1446],"size":[1153,1500]},"cadre-noir-30-hor":{"rect":[38.1,38.0,1460.0,1113.0],"open":[52,52,1446,1099],"size":[1500,1153]},"cadre-noir-45-ver":{"rect":[29.7,29.8,1112.0,1467.8],"open":[40,40,1102,1458],"size":[1144,1500]},"cadre-noir-45-hor":{"rect":[29.8,29.7,1467.8,1112.0],"open":[40,40,1458,1102],"size":[1500,1144]},"cadre-noir-60-ver":{"rect":[24.4,24.5,1115.0,1473.0],"open":[33,33,1107,1465],"size":[1142,1500]},"cadre-noir-60-hor":{"rect":[24.5,24.2,1472.9,1115.0],"open":[33,33,1465,1107],"size":[1500,1142]},"cadre-blanc-30-ver":{"rect":[38.0,38.1,1113.0,1460.0],"open":[52,52,1099,1446],"size":[1153,1500]},"cadre-blanc-30-hor":{"rect":[38.1,38.0,1460.0,1113.0],"open":[52,52,1446,1099],"size":[1500,1153]},"cadre-blanc-45-ver":{"rect":[29.7,29.8,1112.0,1467.8],"open":[40,40,1102,1458],"size":[1144,1500]},"cadre-blanc-45-hor":{"rect":[29.8,29.7,1467.8,1112.0],"open":[40,40,1458,1102],"size":[1500,1144]},"cadre-blanc-60-ver":{"rect":[24.4,24.5,1115.0,1473.0],"open":[33,33,1107,1465],"size":[1142,1500]},"cadre-blanc-60-hor":{"rect":[24.5,24.2,1472.9,1115.0],"open":[33,33,1465,1107],"size":[1500,1142]},"plexi-30-ver":{"rect":[-1.2,0.1,1130.0,1498.0],"size":[1131,1500]},"plexi-30-hor":{"rect":[-0.0,-1.2,1498.2,1130.0],"size":[1500,1131]},"plexi-45-ver":{"rect":[3.2,3.9,1125.5,1493.7],"size":[1131,1500]},"plexi-45-hor":{"rect":[3.8,3.2,1493.8,1125.5],"size":[1500,1131]},"plexi-60-ver":{"rect":[5.7,5.9,1122.6,1491.5],"size":[1131,1500]},"plexi-60-hor":{"rect":[6.0,5.3,1491.4,1122.5],"size":[1500,1131]}};
  const COQUE_GEO = {"fine-iphone-16promax":[869.5,749.0,8.79],"renforcee-iphone-16promax":[869.5,749.0,8.79],"fine-iphone-16pro":[866.5,748.5,8.12],"renforcee-iphone-16pro":[859.5,748.5,8.12],"fine-iphone-16plus":[857.5,748.5,8.8],"renforcee-iphone-16plus":[852.5,748.5,8.8],"fine-iphone-16":[866.5,748.5,8.12],"renforcee-iphone-16":[864.5,748.5,8.12],"fine-iphone-15promax":[877.5,751.0,8.2],"renforcee-iphone-15promax":[876.0,751.0,8.29],"fine-iphone-15pro":[876.5,750.0,8.25],"renforcee-iphone-15pro":[876.5,751.0,8.34],"fine-iphone-15plus":[876.5,751.0,8.21],"renforcee-iphone-15plus":[876.5,750.5,8.24],"fine-iphone-15":[874.5,751.0,8.19],"renforcee-iphone-15":[875.5,750.5,8.31],"fine-iphone-14promax":[906.5,748.5,7.67],"renforcee-iphone-14promax":[888.0,750.5,8.24],"fine-iphone-14pro":[926.5,748.5,7.84],"renforcee-iphone-14pro":[874.0,749.0,8.43],"fine-iphone-14plus":[906.5,748.5,7.67],"renforcee-iphone-14plus":[884.0,752.5,8.47],"fine-iphone-14":[929.5,748.5,7.84],"renforcee-iphone-14":[874.0,749.0,8.43],"fine-iphone-13promax":[906.5,748.5,7.67],"renforcee-iphone-13promax":[888.0,750.5,8.24],"fine-iphone-13pro":[926.5,748.5,7.84],"renforcee-iphone-13pro":[884.0,752.0,8.58],"fine-iphone-13":[929.5,748.5,7.84],"renforcee-iphone-13":[874.0,749.0,8.43],"fine-iphone-13mini":[955.0,749.0,8.18],"renforcee-iphone-13mini":[914.0,750.0,8.75],"fine-iphone-12promax":[925.0,749.0,7.61],"renforcee-iphone-12promax":[875.0,748.0,8.2],"fine-iphone-12pro":[923.0,748.5,7.71],"renforcee-iphone-12pro":[894.5,748.0,8.53],"fine-iphone-12":[923.0,748.5,7.71],"renforcee-iphone-12":[904.5,748.0,8.54],"fine-iphone-12mini":[960.0,748.5,8.0],"renforcee-iphone-12mini":[890.5,750.0,8.66],"fine-iphone-11promax":[944.5,750.0,7.63],"renforcee-iphone-11promax":[865.0,748.5,8.26],"fine-iphone-11pro":[900.5,744.5,7.87],"renforcee-iphone-11pro":[894.5,750.0,8.88],"fine-iphone-11":[907.5,749.5,8.04],"renforcee-iphone-11":[896.5,751.5,8.61],"fine-iphone-xsmax":[927.5,749.0,7.66],"renforcee-iphone-xsmax":[883.0,749.5,8.47],"fine-iphone-xs":[926.5,748.5,7.4],"renforcee-iphone-xs":[889.0,749.5,8.6],"fine-iphone-xr":[931.0,749.0,7.35],"renforcee-iphone-xr":[909.5,749.0,9.2333],"fine-iphone-x":[926.5,748.5,7.4],"renforcee-iphone-x":[889.0,749.5,8.6],"fine-galaxy-s23ultra":[875.0,749.5,6.84],"renforcee-galaxy-s23ultra":[874.0,750.0,8.54],"fine-galaxy-s23plus":[874.5,749.5,6.84],"renforcee-galaxy-s23plus":[875.5,749.5,8.64],"fine-galaxy-s23":[875.0,749.5,6.84],"renforcee-galaxy-s23":[881.5,752.0,8.78],"fine-galaxy-s22ultra":[875.0,749.5,6.84],"renforcee-galaxy-s22ultra":[873.5,751.0,8.56],"fine-galaxy-s22plus":[874.5,749.5,6.84],"renforcee-galaxy-s22plus":[877.5,779.0,8.5],"fine-galaxy-s22":[874.5,749.0,6.84],"renforcee-galaxy-s22":[877.0,752.0,8.76],"fine-galaxy-s21ultra":[912.0,747.5,7.95],"renforcee-galaxy-s21ultra":[859.0,749.0,8.5],"fine-galaxy-s21plus":[950.0,750.0,8.42],"renforcee-galaxy-s21plus":[865.5,750.0,8.48],"fine-galaxy-s21":[912.5,749.5,8.32],"renforcee-galaxy-s21":[859.0,750.0,8.9],"fine-galaxy-s20ultra":[871.0,755.0,7.24],"renforcee-galaxy-s20ultra":[864.0,749.5,8.29],"fine-galaxy-s20plus":[924.5,749.5,8.0],"renforcee-galaxy-s20plus":[857.5,750.5,8.07],"fine-galaxy-s20":[911.0,747.5,8.05],"renforcee-galaxy-s20":[859.0,749.5,8.09]};
  const SWEAT_BOX = {
    col: { x0: 526, y0: 485, x1: 993, y1: 1108, size: 1500, fmt: 'sweat' },
    cap: { x0: 559, y0: 500, x1: 956, y1: 896, size: 1500, fmt: 'hoodie' },
  };

  /* Broderie : les 14 fils de Gelato (relevés par brouillon, data/emb_palette.py) et zones brodées sur les rendus des
     produits vierges (ideo-img-emb-<produit>-<couleur>.jpg, 1500 px ; 4 points aux coins du fichier, data/emb_blank2.py). */
  const THREADS = [['#ffffff', 'Blanc'], ['#95a0a7', 'Gris'], ['#000000', 'Noir'], ['#a57742', 'Camel doré'], ['#ffcd01', 'Jaune'],
    ['#da5f3d', 'Corail'], ['#cb333b', 'Rouge'], ['#670101', 'Bordeaux'], ['#cb3265', 'Framboise'], ['#6c5395', 'Violet'],
    ['#349aff', 'Bleu ciel'], ['#343467', 'Marine'], ['#41894b', 'Vert'], ['#7ca45b', 'Vert tendre']];
  const THREAD_RGB = THREADS.map(([hx]) => [1, 3, 5].map((i) => parseInt(hx.slice(i, i + 2), 16)));
  const EMB_BOX = {
    casquette: { x0: 415, y0: 474, x1: 1090, y1: 804, size: 1500, fmt: 'brode-casquette', zf: 0.46 },
    bonnet: { x0: 491, y0: 1062, x1: 1027, y1: 1292, size: 1500, fmt: 'brode-bonnet', zf: 0.34 },
    sweat: { x0: 841, y0: 511, x1: 994, y1: 586, size: 1500, fmt: 'brode-poitrine', zf: 0.32 },
    capuche: { x0: 827, y0: 581, x1: 955, y1: 644, size: 1500, fmt: 'brode-poitrine', zf: 0.32 },
    polo: { x0: 863, y0: 439, x1: 1007, y1: 509, size: 1500, fmt: 'brode-polo', zf: 0.32 },
  };

  /** Ramène un dessin aux fils de broderie : bords nets (pas de demi-transparence), chaque couleur au fil le plus proche,
   *  au plus `max` fils (les moins utilisés prennent le fil retenu le plus proche). Renvoie les fils utilisés (hex). */
  function threadify(canvas, max = 6) {
    const ctx = canvas.getContext('2d');
    const img = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const d = img.data;
    const idx = new Int8Array(d.length / 4).fill(-1);
    const count = new Array(THREADS.length).fill(0);
    const near = (r, g, b, allowed) => {
      let best = -1, bd = Infinity;
      for (const t of allowed) {
        const [tr, tg, tb] = THREAD_RGB[t];
        // distance pondérée (l'œil est plus sensible au vert)
        const dd = 2 * (r - tr) ** 2 + 4 * (g - tg) ** 2 + 3 * (b - tb) ** 2;
        if (dd < bd) { bd = dd; best = t; }
      }
      return best;
    };
    const all = THREADS.map((_, i) => i);
    for (let i = 0, p = 0; i < d.length; i += 4, p++) {
      if (d[i + 3] < 110) continue;
      const t = near(d[i], d[i + 1], d[i + 2], all);
      idx[p] = t;
      count[t]++;
    }
    const total = count.reduce((a, b) => a + b, 0);
    let kept = all.filter((t) => count[t] > 0).sort((a, b) => count[b] - count[a]);
    const remap = all.slice();
    // couleur à moins de 0,3 % des points : mélange de bord entre deux formes, pas un vrai fil
    const minor = kept.filter((t) => count[t] < total * 0.003);
    if (minor.length && minor.length < kept.length) {
      kept = kept.filter((t) => !minor.includes(t));
      minor.forEach((t) => (remap[t] = near(...THREAD_RGB[t], kept)));
    }
    if (kept.length > max) {
      const keep = kept.slice(0, max);
      kept.slice(max).forEach((t) => (remap[t] = near(...THREAD_RGB[t], keep)));
      kept = keep;
    }
    for (let i = 0, p = 0; i < d.length; i += 4, p++) {
      if (idx[p] < 0) {
        d[i + 3] = 0;
        continue;
      }
      const [r, g, b] = THREAD_RGB[remap[idx[p]]];
      d[i] = r; d[i + 1] = g; d[i + 2] = b; d[i + 3] = 255;
    }
    ctx.putImageData(img, 0, 0);
    return kept.map((t) => THREADS[t][0]);
  }

  /** Aperçu seulement : rendu « point satin ». Fils parallèles en diagonale (chaque fil plus clair au centre, plus sombre
   *  dans le creux entre deux fils), points de piqûre décalés d'un fil à l'autre, relief en bordure (lumière en haut à
   *  gauche) et reflet soyeux, visible même sur un fil noir. `ppm` = pixels par millimètre du canvas. */
  function stitchify(canvas, ppm) {
    const ctx = canvas.getContext('2d');
    const W = canvas.width, H = canvas.height;
    const img = ctx.getImageData(0, 0, W, H);
    const d = img.data;
    const n = W * H;
    // masque flouté (flou de boîte séparable) → relief des bords
    const r = Math.max(1, Math.round(ppm * 0.45));
    const m = new Float32Array(n), t = new Float32Array(n), b = new Float32Array(n);
    for (let p = 0; p < n; p++) m[p] = d[p * 4 + 3] ? 1 : 0;
    for (let y = 0; y < H; y++) {
      let acc = 0;
      for (let x = -r; x <= r; x++) acc += x >= 0 && x < W ? m[y * W + x] : 0;
      for (let x = 0; x < W; x++) {
        t[y * W + x] = acc / (2 * r + 1);
        const a = x - r, c = x + r + 1;
        if (a >= 0) acc -= m[y * W + a];
        if (c < W) acc += m[y * W + c];
      }
    }
    for (let x = 0; x < W; x++) {
      let acc = 0;
      for (let y = -r; y <= r; y++) acc += y >= 0 && y < H ? t[y * W + x] : 0;
      for (let y = 0; y < H; y++) {
        b[y * W + x] = acc / (2 * r + 1);
        const a = y - r, c = y + r + 1;
        if (a >= 0) acc -= t[a * W + x];
        if (c < H) acc += t[c * W + x];
      }
    }
    const period = Math.max(2.4, ppm * 0.65); // largeur apparente d'un fil
    const L = Math.max(8, ppm * 4); // longueur d'un point
    const hash = (i) => {
      const v = Math.sin(i * 127.1) * 43758.5453;
      return v - Math.floor(v);
    };
    for (let y = 0; y < H; y++) {
      for (let x = 0; x < W; x++) {
        const p = y * W + x;
        if (!m[p]) continue;
        const i = p * 4;
        const u = (x + y) / (period * 1.414);
        const k = Math.floor(u), f = u - k;
        let shade = 0.66 + 0.36 * Math.sin(Math.PI * f);
        const g = (((x - y) / 1.414 + hash(k) * L) % L + L) % L / L;
        if (g < 0.08) shade *= 0.8;
        const gx = (x < W - 1 ? b[p + 1] : 0) - (x > 0 ? b[p - 1] : 0);
        const gy = (y < H - 1 ? b[p + W] : 0) - (y > 0 ? b[p - W] : 0);
        shade += -(gx + gy) * 2.4 * r * 0.5;
        shade *= 0.8 + 0.2 * Math.min(1, b[p] * 1.6);
        const sheen = Math.max(0, shade - 0.95) * 70 + (d[i] + d[i + 1] + d[i + 2] < 120 ? 26 : 0);
        if (d[i] + d[i + 1] + d[i + 2] > 600) shade *= 0.9;
        d[i] = Math.max(0, Math.min(255, d[i] * shade + sheen));
        d[i + 1] = Math.max(0, Math.min(255, d[i + 1] * shade + sheen));
        d[i + 2] = Math.max(0, Math.min(255, d[i + 2] * shade + sheen));
      }
    }
    ctx.putImageData(img, 0, 0);
  }

  /** Fichier d'impression à une face (renderPrint) à définition réduite, pour l'aperçu. */
  function printSmall(design, formatKey, input, width) {
    const fmt = FORMATS[formatKey];
    const s = width / fmt.width;
    const c = document.createElement('canvas');
    c.width = Math.round(fmt.width * s);
    c.height = Math.round(fmt.height * s);
    const ctx = c.getContext('2d');
    ctx.scale(s, s);
    const f = fmt.face;
    const bleed = DESIGNS[design].bleed;
    if (bleed) {
      if (fmt.background) {
        ctx.fillStyle = fmt.background;
        ctx.fillRect(0, 0, fmt.width, fmt.height);
      }
      paintBleed(ctx, design, fmt, input);
    }
    const [fx, fy] = bleed ? [0, 0] : fmt.margin;
    ctx.translate(f.x + f.w * fx, f.y + f.h * fy);
    drawFace(ctx, design, f.w - 2 * f.w * fx, f.h - 2 * f.h * fy, input);
    if (fmt.emb) c.threads = threadify(c);
    return c;
  }

  const ZONES = { mug: MUG_ZONE, tote: { x: 0.4177, y: 0.474, w: 0.1553, h: 0.251 },
    tshirt: { x: 0.41, y: 0.31, w: 0.234, h: 0.39 }, body: { x: 0.43, y: 0.26, w: 0.17, h: 0.28 } };

  /**
   * Compose la scène produit (aperçu) dans un canvas 1088×896 :
   * mug → photo + design en « multiply » sur la face avant ; affiche → affiche encadrée sur fond crème.
   */
  function drawShot(canvas, { design, format, values: input, mockup, scale, style, zoom, view, spiral, cardMock, garmentMask, print }) {
    // calendrier « à plat » : page seule en grand, au format portrait (lisible, surtout sur mobile)
    const flatCal = format === 'calendar' && view === 'flat';
    const W = flatCal ? 860 : 1088;
    const H = flatCal ? 1100 : 896;
    // double résolution sur les écrans haute densité (Retina) pour un aperçu net
    const k = scale || Math.min(2, Math.max(1, window.devicePixelRatio || 1));
    canvas.width = W * k;
    canvas.height = H * k;
    const ctx = canvas.getContext('2d');
    ctx.scale(k, k);
    ctx.imageSmoothingQuality = 'high';
    if (format === 'card' && view !== 'inside' && cardMock && cardMock.photo && cardMock.photo.complete && cardMock.photo.naturalWidth
      && cardMock.mask && cardMock.mask.complete && cardMock.mask.naturalWidth) {
      // vraie carte Gelato (rendu de la carte pliée vierge) + recto en perspective, calé sur l'aperçu de fabrication Gelato
      const fmt = FORMATS.card;
      const Q = CARD_QUAD[cardMock.size || 'a6'];
      const sc = W / 1500, oy = (H - 1071 * sc) / 2;
      ctx.fillStyle = '#f2f2ec';
      ctx.fillRect(0, 0, W, H);
      ctx.drawImage(cardMock.photo, 0, oy, W, 1071 * sc);
      // recto = moitié droite de la page 1 (fond perdu compris)
      const d = DESIGNS[design];
      const v = values(design, input);
      const rc = document.createElement('canvas');
      rc.width = Math.round((fmt.width / 2) * 0.35);
      rc.height = Math.round(fmt.height * 0.35);
      const rctx = rc.getContext('2d');
      rctx.scale(0.35, 0.35);
      rctx.translate(-fmt.width / 2, 0);
      rctx.fillStyle = PAPER;
      rctx.fillRect(0, 0, fmt.width, fmt.height);
      d.drawPage(rctx, fmt.width, fmt.height, v, 0, {});
      const layer = document.createElement('canvas');
      layer.width = Math.round(W * k);
      layer.height = Math.round(H * k);
      const l = layer.getContext('2d');
      l.fillStyle = '#fff';
      l.fillRect(0, 0, layer.width, layer.height);
      const pts = Q.map(([x, y]) => [x * sc * k, (y * sc + oy) * k]);
      warpQuad(l, rc, pts, 14);
      l.globalCompositeOperation = 'destination-in';
      l.drawImage(cardMock.mask, 0, oy * k, W * k, 1071 * sc * k);
      ctx.save();
      ctx.globalCompositeOperation = 'multiply';
      ctx.drawImage(layer, 0, 0, W, H);
      ctx.restore();
      rc.width = rc.height = layer.width = layer.height = 0;
    } else if (format === 'card') {
      ctx.fillStyle = '#f3eadd';
      ctx.fillRect(0, 0, W, H);
      const fmt = FORMATS.card;
      const d = DESIGNS[design];
      const v = values(design, input);
      const ch = H * 0.8, cw = (ch * 105) / 148, gap = W * 0.04;
      const x1 = (W - 2 * cw - gap) / 2, y1 = (H - ch) / 2;
      // carte = moitié de page (sans le fond perdu), rendue à la bonne échelle
      [[0, x1, 'Recto'], [1, x1 + cw + gap, 'Intérieur']].forEach(([page, x]) => {
        const c = document.createElement('canvas');
        c.width = Math.round(cw * 2 * (scale || 2));
        c.height = Math.round(ch * (scale || 2));
        const cctx = c.getContext('2d');
        const k = c.height / (fmt.height - 2 * fmt.bleed);
        cctx.scale(k, k);
        cctx.translate(-fmt.bleed, -fmt.bleed);
        cctx.fillStyle = PAPER;
        cctx.fillRect(0, 0, fmt.width, fmt.height);
        d.drawPage(cctx, fmt.width, fmt.height, v, page, {});
        ctx.save();
        ctx.shadowColor = 'rgba(60,40,30,.28)';
        ctx.shadowBlur = 24;
        ctx.shadowOffsetY = 10;
        ctx.fillStyle = PAPER;
        ctx.fillRect(x, y1, cw, ch);
        ctx.restore();
        // recto : moitié droite de la page 1 ; intérieur : moitié droite de la page 2
        ctx.drawImage(c, c.width / 2, 0, c.width / 2, c.height, x, y1, cw, ch);
        c.width = c.height = 0;
      });
    } else if (flatCal && spiral && spiral.complete && spiral.naturalWidth) {
      // vrai calendrier Gelato : page complète (fond perdu compris) sous le rendu du calendrier vierge
      // (spirale, crochet, encoche) ; position calée sur l'aperçu de fabrication Gelato d'un vrai PDF (designs/calwrap.py)
      ctx.fillStyle = '#fbf8f3';
      ctx.fillRect(0, 0, W, H);
      const fmt = FORMATS.calendar;
      const page = renderPage(design, 'calendar', input, input && input._page ? input._page : 0);
      const rh = H * 0.8, s = rh / 1500, rw = 1049 * s;
      const rx = (W - rw) / 2, ry = H * 0.085;
      const R = CAL_RECT;
      const layer = document.createElement('canvas');
      layer.width = Math.round(rw * k);
      layer.height = Math.round(rh * k);
      const l = layer.getContext('2d');
      l.scale(k * s, k * s);
      l.drawImage(page, R.x0, R.y0, R.x1 - R.x0, R.y1 - R.y0);
      l.globalCompositeOperation = 'multiply';
      l.drawImage(spiral, 0, 0, 1049, 1500);
      l.globalCompositeOperation = 'destination-in';
      l.drawImage(spiral, 0, 0, 1049, 1500);
      ctx.save();
      ctx.shadowColor = 'rgba(60,40,30,.22)';
      ctx.shadowBlur = 26;
      ctx.shadowOffsetY = 10;
      ctx.drawImage(layer, rx, ry, rw, rh);
      ctx.restore();
      page.width = page.height = 0;
      layer.width = layer.height = 0;
    } else if (flatCal) {
      ctx.fillStyle = '#f3eadd';
      ctx.fillRect(0, 0, W, H);
      const fmt = FORMATS.calendar;
      const page = renderPage(design, 'calendar', input, input && input._page ? input._page : 0);
      const sw = fmt.width - 2 * fmt.bleed, sh = fmt.height - 2 * fmt.bleed;
      // marge en haut (badges) et en bas (barre de navigation posée sur l'aperçu)
      const ph = H * 0.78, pw = (ph * sw) / sh;
      const x = (W - pw) / 2, y = H * 0.075;
      ctx.save();
      ctx.shadowColor = 'rgba(60,40,30,.28)';
      ctx.shadowBlur = 30;
      ctx.shadowOffsetY = 12;
      ctx.fillStyle = '#fff';
      ctx.fillRect(x, y, pw, ph);
      ctx.restore();
      ctx.drawImage(page, fmt.bleed, fmt.bleed, sw, sh, x, y, pw, ph);
      page.width = page.height = 0;
      // reliure spirale suggérée en haut de page
      ctx.fillStyle = '#2c2522';
      const rings = 21, gap = pw / (rings + 1);
      for (let i = 1; i <= rings; i++) {
        ctx.beginPath();
        ctx.roundRect(x + gap * i - 2.5, y - 9, 5, 18, 2.5);
        ctx.fill();
      }
    } else if (format === 'calendar') {
      // zoom ×1,5 sur le calendrier accroché au mur, pour que la page soit lisible (surtout sur mobile)
      ctx.save();
      ctx.translate(W / 2, H / 2);
      ctx.scale(1.5, 1.5);
      ctx.translate(-0.51 * W, -0.52 * H);
      if (mockup && mockup.complete && mockup.naturalWidth) ctx.drawImage(mockup, 0, 0, W, H);
      const fmt = FORMATS.calendar;
      const page = renderPage(design, 'calendar', input, input && input._page ? input._page : 0);
      // zone de la page sur la photo (page vierge du calendrier), sans le fond perdu
      const zx = 0.374 * W, zy = 0.2656 * H, zw = 0.2537 * W, zh = zw * (297 / 210); // page vierge de la photo, mesurée au pixel
      ctx.globalCompositeOperation = 'multiply';
      ctx.drawImage(page, fmt.bleed, fmt.bleed, fmt.width - 2 * fmt.bleed, fmt.height - 2 * fmt.bleed, zx, zy, zw, zh);
      ctx.globalCompositeOperation = 'source-over';
      page.width = page.height = 0;
      ctx.restore();
    } else if (mockup && ((format === 'mug' && /mockup-mug-gelato/.test(mockup.src || '')) || (format === 'gourde' && /gourde-gelato/.test(mockup.src || '')))) {
      // mug, gourde : rendu Gelato du vrai produit + design enroulé sur le cylindre (même forme que le produit fabriqué)
      const MB = format === 'gourde' ? GOURDE_BODY : /gelato-grand/.test(mockup.src || '') ? MUG15_BODY : MUG_BODY;
      if (zoom && zoom > 1) {
        const zcx = (MB.x0 + MB.x1) / 2, zcy = (MB.top + MB.bottom) / 2 + 10;
        ctx.translate(W / 2, H / 2);
        ctx.scale(zoom, zoom);
        ctx.translate(-zcx, -zcy);
      }
      ctx.fillStyle = '#fbf8f3';
      ctx.fillRect(0, 0, W, H);
      if (mockup.complete && mockup.naturalWidth) ctx.drawImage(mockup, 0, 0, W, H);
      drawMugWrap(ctx, design, input, k, MB);
    } else if (format === 'livre') {
      drawLivreShot(ctx, W, H, k, design, input, style, view, (input && input._page) || 0);
    } else if (format === 'tableau' && mockup && /tab-gelato-/.test(mockup.src || '')) {
      // tableau photo : rendu Gelato du tableau vierge (toile en 3D, cadre ou plexi de face) + vrai fichier d'impression
      // (fond perdu, retours de toile en miroir), multiplié par le rendu pour garder la texture de la toile et les reflets
      const key = ((mockup.src || '').match(/tab-gelato-([a-z0-9-]+?)\.jpg/) || [])[1];
      const g = TAB_GEO[key];
      const fk = print && FORMATS[print] ? print : 'poster';
      const fmt = FORMATS[fk];
      const [rw, rh] = g ? g.size : [1131, 1500];
      // cadrage sur l'objet (les rendus de toile laissent beaucoup de vide autour)
      const pts = g ? (g.front ? g.front.concat(g.side) : [g.rect.slice(0, 2), g.rect.slice(2)]) : [[0, 0], [rw, rh]];
      const bx0 = Math.max(0, Math.min(...pts.map((q) => q[0]))), bx1 = Math.min(rw, Math.max(...pts.map((q) => q[0])));
      const by0 = Math.max(0, Math.min(...pts.map((q) => q[1]))), by1 = Math.min(rh, Math.max(...pts.map((q) => q[1])));
      const s = Math.min((W * 0.9) / (bx1 - bx0), (H * 0.9) / (by1 - by0));
      const ox = W / 2 - ((bx0 + bx1) / 2) * s, oy = H / 2 - ((by0 + by1) / 2) * s;
      ctx.fillStyle = '#fbf8f3';
      ctx.fillRect(0, 0, W, H);
      if (g && mockup.complete && mockup.naturalWidth) {
        ctx.drawImage(mockup, ox, oy, rw * s, rh * s);
        const pr = printSmall(design, fk, input, Math.min(2600, Math.round(rw * s * k * 1.3)));
        const layer = document.createElement('canvas');
        layer.width = Math.round(W * k);
        layer.height = Math.round(H * k);
        const l = layer.getContext('2d');
        const P = ([x, y]) => [(ox + x * s) * k, (oy + y * s) * k];
        const poly = (q) => {
          l.moveTo(...P(q[0]));
          q.slice(1).forEach((pt) => l.lineTo(...P(pt)));
          l.closePath();
        };
        l.beginPath();
        if (g.front) {
          poly(g.front);
          poly(g.side);
        } else {
          const [x0, y0, x1, y1] = g.open || g.rect;
          poly([[x0, y0], [x1, y0], [x1, y1], [x0, y1]]);
        }
        l.clip();
        if (g.front) {
          // toile : face avant (zone de la face) et tranche gauche (retour de 15 à 49 mm), en perspective
          const r = pr.width / fmt.width, f = fmt.face, side = (f.x * 15) / 49;
          warpQuad(l, pr, g.front.map(P), 16, true, [f.x * r, f.y * r, f.w * r, f.h * r]);
          warpQuad(l, pr, g.side.map(P), 16, true, [side * r, f.y * r, (f.x - side) * r, f.h * r]);
          l.setTransform(1, 0, 0, 1, 0, 0);
        } else {
          const [x0, y0, x1, y1] = g.rect;
          l.drawImage(pr, ...P([x0, y0]), (x1 - x0) * s * k, (y1 - y0) * s * k);
        }
        l.globalCompositeOperation = 'multiply';
        l.drawImage(mockup, ox * k, oy * k, rw * s * k, rh * s * k);
        ctx.drawImage(layer, 0, 0, W, H);
        pr.width = pr.height = layer.width = layer.height = 0;
      }
    } else if (format === 'coque' && mockup && /coque-gelato-/.test(mockup.src || '')) {
      // coque : rendu Gelato de la coque vierge du modèle + fichier 100 × 170 mm centré sur la face avant (multiply : le bloc
      // photo reste visible par-dessus l'impression, comme sur la coque fabriquée)
      const key = ((mockup.src || '').match(/coque-gelato-([a-z0-9-]+?)\.jpg/) || [])[1];
      const g = COQUE_GEO[key] || [870, 750, 8.6];
      const s = H / 1500, ox = (W - H) / 2;
      const [cx, cy, pmm] = g;
      if (zoom && zoom > 1) {
        ctx.translate(W / 2, H / 2);
        ctx.scale(zoom, zoom);
        ctx.translate(-(ox + cx * s), -(cy * s));
      }
      ctx.fillStyle = '#fbf8f3';
      ctx.fillRect(-W, -H, 3 * W, 3 * H);
      if (mockup.complete && mockup.naturalWidth) ctx.drawImage(mockup, ox, 0, H, H);
      const fmtKey = /galaxy/.test(key || '') ? 'coque-samsung' : 'coque';
      const pw = 100 * pmm * s, ph = 170 * pmm * s;
      const pr = printSmall(design, fmtKey, input, Math.round(pw * k * Math.max(1, zoom || 1) * 1.2));
      const layer = document.createElement('canvas');
      layer.width = Math.ceil(pw * k);
      layer.height = Math.ceil(ph * k);
      const lc = layer.getContext('2d');
      lc.fillStyle = '#fff';
      lc.fillRect(0, 0, layer.width, layer.height);
      lc.drawImage(pr, 0, 0, layer.width, layer.height);
      ctx.save();
      ctx.globalCompositeOperation = 'multiply';
      ctx.drawImage(layer, ox + (cx - 50 * pmm) * s, (cy - 85 * pmm) * s, pw, ph);
      ctx.restore();
      pr.width = pr.height = layer.width = layer.height = 0;
    } else if (mockup && ((format === 'tshirt' && /tshirt-gelato/.test(mockup.src || '')) || (format === 'body' && /body-gelato/.test(mockup.src || ''))
      || (format === 'sweat' && /sweat-gelato/.test(mockup.src || '')) || (format === 'tote' && /tote-gelato/.test(mockup.src || ''))
      || (format === 'enfant' && /enfant-gelato/.test(mockup.src || '')))) {
      // t-shirt, body, sweat : rendu Gelato du vêtement vierge (couleur choisie) + vrai fichier d'impression sur la zone mesurée
      const src = mockup.src || '';
      const B = format === 'tshirt' ? (/tshirt-gelato-femme-/.test(src) ? TSHIRT_FEMME_BOX : TSHIRT_BOX) : format === 'tote' ? TOTE_BOX : format === 'enfant' ? (/cap-/.test(src) ? KIDS_BOX.cap : KIDS_BOX.tee) : format === 'sweat' ? (/cap-/.test(src) ? SWEAT_BOX.cap : SWEAT_BOX.col)
        : /mc-/.test(src) ? BODY_BOX.mc : BODY_BOX.ml;
      const iw = B.iw || B.size, ih = B.ih || B.size;
      const s = H / ih, ox = (W - iw * s) / 2;
      const zx = ox + B.x0 * s, zy = B.y0 * s, zw = (B.x1 - B.x0) * s, zh = (B.y1 - B.y0) * s;
      if (zoom && zoom > 1) {
        // même cadrage quel que soit le vêtement : la zone d'impression occupe 56 % de la hauteur de l'aperçu
        const z = Math.max(1, ((B.zf || 0.56) * H) / zh);
        ctx.translate(W / 2, H / 2);
        ctx.scale(z, z);
        ctx.translate(-(zx + zw / 2), -(zy + zh / 2));
      }
      ctx.fillStyle = '#efebe4';
      ctx.fillRect(-W, -H, 3 * W, 3 * H);
      if (mockup.complete && mockup.naturalWidth) ctx.drawImage(mockup, ox, 0, iw * s, H);
      const pr = printSmall(design, B.fmt || format, input, Math.round(zw * k * Math.max(1, zoom || 1) * 1.25));
      ctx.drawImage(pr, zx, zy, zw, zh);
      pr.width = pr.height = 0;
      if (B === SWEAT_BOX.cap && garmentMask && garmentMask.complete && garmentMask.naturalWidth && mockup.complete && mockup.naturalWidth) {
        // sweat à capuche : les cordons passent devant l'impression (masque tracé sur le rendu Gelato)
        const cl = document.createElement('canvas');
        cl.width = cl.height = B.size;
        const c2 = cl.getContext('2d');
        c2.drawImage(mockup, 0, 0, B.size, B.size);
        c2.globalCompositeOperation = 'destination-in';
        c2.drawImage(garmentMask, 0, 0, B.size, B.size);
        ctx.drawImage(cl, ox, 0, H, H);
        cl.width = cl.height = 0;
      }
    } else if (format === 'brode' && mockup && /emb-/.test(mockup.src || '')) {
      // broderie : rendu Gelato du produit vierge + fichier ramené aux fils, relief des points, légère ombre portée
      const kind = (/emb-([a-z]+)-/.exec(mockup.src || '') || [])[1] || 'casquette';
      const B = EMB_BOX[kind] || EMB_BOX.casquette;
      const s = H / B.size, ox = (W - B.size * s) / 2;
      const zx = ox + B.x0 * s, zy = B.y0 * s, zw = (B.x1 - B.x0) * s, zh = (B.y1 - B.y0) * s;
      let z = 1;
      if (zoom && zoom > 1) {
        z = Math.max(1, (B.zf * W) / zw);
        ctx.translate(W / 2, H / 2);
        ctx.scale(z, z);
        ctx.translate(-(zx + zw / 2), -(zy + zh / 2));
      }
      ctx.fillStyle = '#efebe4';
      ctx.fillRect(-W, -H, 3 * W, 3 * H);
      if (mockup.complete && mockup.naturalWidth) ctx.drawImage(mockup, ox, 0, B.size * s, H);
      const pr = printSmall(design, B.fmt, input, Math.round(zw * k * z * 1.4));
      stitchify(pr, pr.width / FORMATS[B.fmt].mm[0]);
      ctx.save();
      ctx.shadowColor = 'rgba(0, 0, 0, 0.35)';
      ctx.shadowBlur = Math.max(1, zw / 120);
      ctx.shadowOffsetY = Math.max(0.5, zw / 300);
      ctx.drawImage(pr, zx, zy, zw, zh);
      ctx.restore();
      pr.width = pr.height = 0;
    } else if (ZONES[format]) {
      // mug, tote bag : photo du produit + design en « multiply » sur la zone imprimée
      const Z = ZONES[format];
      if (zoom && zoom > 1) {
        // fiche produit : zoom sur la zone imprimée pour que le texte reste lisible (surtout sur mobile)
        const zcx = (Z.x + Z.w / 2) * W, zcy = (Z.y + Z.h / 2) * H;
        ctx.translate(W / 2, H / 2);
        ctx.scale(zoom, zoom);
        ctx.translate(-zcx, -zcy);
      }
      if (mockup && mockup.complete && mockup.naturalWidth) ctx.drawImage(mockup, 0, 0, W, H);
      const zx = Z.x * W, zy = Z.y * H, zw = Z.w * W, zh = Z.h * H;
      const face = document.createElement('canvas');
      face.width = zw * 3 * k;
      face.height = zh * 3 * k;
      drawFace(face.getContext('2d'), design, face.width, face.height, input);
      ctx.globalCompositeOperation = 'multiply';
      ctx.drawImage(face, zx, zy, zw, zh);
      ctx.globalCompositeOperation = 'source-over';
    } else {
      ctx.fillStyle = '#f3eadd';
      ctx.fillRect(0, 0, W, H);
      const ph = 700, pw = (ph * FORMATS.poster.face.w) / FORMATS.poster.face.h, fw = 20;
      const x = (W - pw) / 2, y = (H - ph) / 2;
      ctx.save();
      ctx.shadowColor = 'rgba(60,40,30,.35)';
      ctx.shadowBlur = 40;
      ctx.shadowOffsetY = 18;
      if (style === 'plain') {
        // affiche seule : papier posé au mur, ombre légère
        ctx.shadowBlur = 22;
        ctx.shadowOffsetY = 8;
        ctx.fillStyle = FORMATS.poster.background;
        ctx.fillRect(x, y, pw, ph);
      } else if (style === 'canvas') {
        // toile : épaisseur du châssis sur le côté droit et en bas
        ctx.fillStyle = '#d9cbb7';
        ctx.fillRect(x + 10, y + 10, pw, ph);
      } else if (style === 'wood') {
        // tableau bois : tranche en bois clair visible à droite et en bas
        ctx.fillStyle = '#c9a26b';
        ctx.fillRect(x + 8, y + 8, pw, ph);
      } else if (style === 'acrylic') {
        // plexi : bord transparent légèrement bleuté
        ctx.fillStyle = 'rgba(200,215,220,.9)';
        ctx.fillRect(x + 5, y + 5, pw, ph);
      } else {
        ctx.fillStyle = '#c4a074';
        ctx.fillRect(x - fw, y - fw, pw + 2 * fw, ph + 2 * fw);
      }
      ctx.restore();
      // aperçu à résolution réduite (rapide), même dessin que le fichier d'impression
      const small = document.createElement('canvas');
      small.width = Math.round(pw * 2 * k);
      small.height = Math.round(ph * 2 * k);
      const sctx = small.getContext('2d');
      sctx.fillStyle = FORMATS.poster.background;
      sctx.fillRect(0, 0, small.width, small.height);
      sctx.translate(small.width * 0.06, small.height * 0.08);
      drawFace(sctx, design, small.width * 0.88, small.height * 0.84, input);
      ctx.drawImage(small, x, y, pw, ph);
      if (style === 'wood') {
        // veinage discret du bois sous l'impression
        ctx.save();
        ctx.globalCompositeOperation = 'multiply';
        ctx.globalAlpha = 0.08;
        ctx.fillStyle = '#b08450';
        ctx.fillRect(x, y, pw, ph);
        ctx.restore();
      }
      if (style === 'acrylic') {
        // reflet du plexi et quatre entretoises métalliques dans les coins
        ctx.save();
        const g = ctx.createLinearGradient(x, y, x + pw, y + ph);
        g.addColorStop(0, 'rgba(255,255,255,.35)');
        g.addColorStop(0.35, 'rgba(255,255,255,0)');
        g.addColorStop(1, 'rgba(255,255,255,.12)');
        ctx.fillStyle = g;
        ctx.fillRect(x, y, pw, ph);
        [[0.04, 0.03], [0.96, 0.03], [0.04, 0.97], [0.96, 0.97]].forEach(([fx, fy]) => {
          const cx = x + pw * fx, cy = y + ph * fy, r = pw * 0.022;
          const rg = ctx.createRadialGradient(cx - r * 0.3, cy - r * 0.3, r * 0.1, cx, cy, r);
          rg.addColorStop(0, '#f4f4f4');
          rg.addColorStop(1, '#8d9296');
          ctx.fillStyle = rg;
          ctx.beginPath();
          ctx.arc(cx, cy, r, 0, Math.PI * 2);
          ctx.fill();
        });
        ctx.restore();
      }
    }
  }

  /** Calendrier photo dans un style de mise en page donné (mêmes champs que « calendrier », plus des champs propres). */
  function calendarOf(style, titre, extra) {
    const base = DESIGNS.calendrier.fields;
    return {
      pages: 14,
      fields: [{ ...base[0], default: titre }, base[1], ...(extra || []), base[2]],
      draw(ctx, w, h, v) {
        drawCalendarPage(ctx, w, h, v, 0, { top: h * 0.05, side: w * 0.04, bottom: h * 0.03 }, style);
      },
      drawPage(ctx, W, H, v, page, safe) {
        drawCalendarPage(ctx, W, H, v, page, safe, style);
      },
    };
  }
  Object.assign(DESIGNS, {
    'calendrier-plein': calendarOf('plein', 'Notre année'),
    'calendrier-minimal': calendarOf('minimal', 'Douze mois'),
    'calendrier-anniversaires': calendarOf('anniversaires', 'Famille Martin', [
      { key: 'anniversaires', label: 'Anniversaires (prénom + jour/mois)', type: 'textarea', max: 300,
        default: 'Léa 12/03, Tom 4/07, Mamie 25/12, Papy 9/10', hint: 'Exemple : « Léa 12/03, Tom 4/07 » : un cœur et le prénom apparaissent sur le bon jour.', optional: true },
    ]),
  });

  const VOEUX = 'Toute la famille vous souhaite un joyeux Noël et une très belle année 2027 !';
  Object.assign(DESIGNS, {
    'carte-sapin': cardOf('noel-sapin', VOEUX, 'Famille Martin'),
    'carte-noel-photo': cardOf('noel-photo', VOEUX, 'Paul, Anne, Léa et Tom'),
    'carte-voeux': cardOf('noel', 'Que cette nouvelle année vous apporte joie, santé et de beaux moments partagés.', 'Famille Martin'),
    'carte-bonhommes': cardOf('noel-bonhommes', VOEUX, 'Papa, Maman, Léa et Tom'),
    'carte-premier-noel': cardOf('noel-boule', 'Pour son tout premier Noël, Léo vous embrasse bien fort et vous souhaite de joyeuses fêtes !', 'Léo et ses parents'),
    'carte-noel-couple': cardOf('noel-couple', 'Joyeux Noël et belle année à vous, avec toute notre affection.', 'Léa & Tom'),
    'carte-collage-noel': cardOf('collage-4', VOEUX, 'Famille Martin'),
    'faire-part-naissance': cardOf('naissance-lune', 'Nous avons l’immense joie de vous annoncer la naissance de notre petit garçon.', 'Claire et Julien'),
  });


  /* ---------- Livre photo 20 × 20 cm (Gelato, couverture rigide ou souple ; 30, 50 ou 70 pages) ----------
     PDF Gelato : couverture à plat (cotes de /cover-dimensions selon couverture et pages), page de garde vierge, pages
     intérieures 206 × 206 mm (200 × 200 + 3 mm de fond perdu), page de garde vierge. 200 dpi (livre de 70 pages ≈ 40 Mo).
     Mise en page automatique : 1re photo = couverture ; les suivantes remplissent les pages dans l'ordre, une ou deux par
     page (deux paysages l'une sous l'autre, sinon côte à côte), réparties régulièrement. Dédicace facultative en page 1. */
  const LIVRE_DPI = 200;
  const LIVRE_PAGE = 206;
  const LIVRE_COVERS = {"rigide-30":{"w":458.0,"h":246.0,"fx":240.0,"fy":20,"fw":198.0,"fh":206.0,"sx":226.0,"sw":6,"from":232.0,"to":226.0,"bx":20,"wrap":17},"rigide-50":{"w":458.0,"h":246.0,"fx":240.0,"fy":20,"fw":198.0,"fh":206.0,"sx":226.0,"sw":6,"from":232.0,"to":226.0,"bx":20,"wrap":17},"rigide-70":{"w":461.0,"h":246.0,"fx":243.0,"fy":20,"fw":198.0,"fh":206.0,"sx":226.0,"sw":9,"from":235.0,"to":226.0,"bx":20,"wrap":17},"souple-30":{"w":408.88,"h":206.0,"fx":205.88,"fy":3,"fw":200.0,"fh":200.0,"sx":203.0,"sw":2.88,"from":205.88,"to":203.0,"bx":3,"wrap":3},"souple-50":{"w":410.43,"h":206.0,"fx":207.43,"fy":3,"fw":200.0,"fh":200.0,"sx":203.0,"sw":4.43,"from":207.43,"to":203.0,"bx":3,"wrap":3},"souple-70":{"w":411.98,"h":206.0,"fx":208.98,"fy":3,"fw":200.0,"fh":200.0,"sx":203.0,"sw":5.98,"from":208.98,"to":203.0,"bx":3,"wrap":3}};
  const lpx = (mm) => Math.round((mm * LIVRE_DPI) / 25.4);

  /** Nombre de photos nécessaire : [minimum, maximum] (couverture comprise). */
  function livreRange(v, pages) {
    const P = pages - (v.dedicace && String(v.dedicace).trim() ? 1 : 0);
    return [P + 1, 2 * P + 1];
  }

  /** Plan du livre : photo de couverture et contenu de chaque page ({ i } = photo du client, { s } = photo d'exemple). */
  function livrePlan(v, pages) {
    const imgs = v._images || [];
    const idx = [];
    imgs.forEach((im, i) => im && idx.push(i));
    const ded = !!(v.dedicace && String(v.dedicace).trim());
    const P = pages - (ded ? 1 : 0);
    const refs = idx.map((i) => ({ i }));
    // aperçu : photos d'exemple pour compléter (jamais imprimées : l'ajout au panier exige toutes les photos)
    for (let k = 0; refs.length < P + 1 && (v._samples || []).length; k++) refs.push({ s: k % v._samples.length });
    const cover = refs[0] || null;
    const rest = refs.slice(1, 2 * P + 1);
    const doubles = Math.max(0, Math.min(P, rest.length - P));
    const out = ded ? [{ dedicace: true }] : [];
    let r = 0;
    for (let j = 0; j < P; j++) {
      const two = Math.floor(((j + 1) * doubles) / P) - Math.floor((j * doubles) / P) > 0;
      const items = rest.slice(r, r + (two ? 2 : 1));
      r += items.length;
      out.push({ items });
    }
    return { cover, pages: out };
  }

  function livreImg(v, ref) {
    if (!ref) return null;
    return ref.s !== undefined ? (v._samples || [])[ref.s] : (v._images || [])[ref.i];
  }

  /** Photo entière (sans recadrage) centrée dans une case. */
  function drawContain(ctx, img, x, y, w, h) {
    if (!img) {
      ctx.fillStyle = '#efe6da';
      ctx.fillRect(x, y, w, h);
      return;
    }
    const k = Math.min(w / img.width, h / img.height);
    const dw = img.width * k, dh = img.height * k;
    ctx.drawImage(img, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
  }

  /** Page intérieure (unités : mm, page 206 × 206 fond perdu compris). imgs = 1 ou 2 images, ou null pour la dédicace. */
  function drawLivrePage(ctx, page, imgs, v, d) {
    ctx.fillStyle = d.paper || '#fffdf9';
    ctx.fillRect(0, 0, LIVRE_PAGE, LIVRE_PAGE);
    const m = 3 + 15, box = LIVRE_PAGE - 2 * m, gap = 6;
    if (page.dedicace) {
      ctx.save();
      ctx.textAlign = 'center';
      ctx.textBaseline = 'alphabetic';
      let size = 12, lines;
      do {
        ctx.font = `italic ${size}px 'Instrument Serif'`;
        lines = String(v.dedicace).split(/\n/).flatMap((para) => wrapLines(ctx, para, box * 0.8));
        size *= 0.95;
      } while (size > 3 && lines.length * size * 1.35 > box * 0.7);
      size /= 0.95;
      const lh = size * 1.35, y0 = LIVRE_PAGE / 2 - (lines.length * lh) / 2 + size * 0.8;
      ctx.fillStyle = INK;
      lines.forEach((l, i) => ctx.fillText(l, LIVRE_PAGE / 2, y0 + i * lh));
      ctx.restore();
      return;
    }
    const [a, b] = imgs;
    if (!b) return drawContain(ctx, a, m, m, box, box);
    const land = (im) => !im || im.width >= im.height;
    if (land(a) && land(b)) {
      const hh = (box - gap) / 2;
      drawContain(ctx, a, m, m, box, hh);
      drawContain(ctx, b, m, m + hh + gap, box, hh);
    } else {
      const ww = (box - gap) / 2;
      drawContain(ctx, a, m, m, ww, box);
      drawContain(ctx, b, m + ww + gap, m, ww, box);
    }
  }

  /** Couverture à plat (unités : mm) : photo en haut de la face avant, bandeau avec titre et sous-titre, dos et tranche. */
  function drawLivreCover(ctx, C, img, v, d) {
    ctx.fillStyle = d.band || PAPER;
    ctx.fillRect(0, 0, C.w, C.h);
    // tranche (et charnières pour la couverture rigide)
    ctx.fillStyle = d.spine || ACCENT;
    ctx.fillRect(C.to, 0, C.from - C.to, C.h);
    const photoH = C.fy + C.fh * 0.74;
    ctx.save();
    ctx.beginPath();
    ctx.rect(C.from, 0, C.w - C.from, photoH);
    ctx.clip();
    drawPhoto(ctx, img, C.from, 0, C.w - C.from, photoH);
    ctx.restore();
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';
    const cx = C.fx + C.fw / 2, bandTop = photoH, bh = C.fy + C.fh - bandTop;
    const two = !!(v.sous_titre && String(v.sous_titre).trim());
    fitText(ctx, v.titre, cx, bandTop + bh * (two ? 0.56 : 0.66), C.fw * 0.84, bh * (two ? 0.42 : 0.5), d.font || ((z) => `${z}px 'Pinyon Script'`), d.color || ACCENT);
    if (two) caps(ctx, v.sous_titre, cx, bandTop + bh * 0.84, C.fw * 0.78, bh * 0.1, MUTED, 600);
  }

  /** Face avant seule (carré), pour les aperçus et les vignettes : même dessin que la couverture imprimée. */
  function drawLivreFront(ctx, w, h, v, d, img) {
    const C = { w: 206, h: 206, fx: 3, fy: 3, fw: 200, fh: 200, from: 0, to: 0 };
    ctx.save();
    ctx.scale(w / 206, h / 206);
    drawLivreCover(ctx, C, img, v, d);
    ctx.restore();
  }

  function livreOf(o) {
    return {
      livre: true,
      band: o.band, spine: o.spine, font: o.font, color: o.color, paper: o.paper,
      fields: [
        { key: 'titre', label: 'Titre de la couverture', max: 28, default: o.titre, hero: true },
        { key: 'sous_titre', label: 'Sous-titre (facultatif)', max: 40, default: o.sous_titre, optional: true },
        { key: 'photos', label: 'Vos photos', type: 'images', count: 141, default: '' },
        { key: 'dedicace', label: 'Dédicace en première page (facultatif)', type: 'textarea', max: 260, default: '', optional: true,
          hint: 'Un petit mot imprimé seul sur la première page, avant les photos.' },
      ],
      draw(ctx, w, h, v) {
        const plan = livrePlan(v, 30);
        drawLivreFront(ctx, w, h, v, this, livreImg(v, plan.cover));
      },
    };
  }

  /** PDF simple : une image JPEG pleine page par page, tailles de page libres (mm). */
  function pdfDoc() {
    const enc = new TextEncoder();
    const chunks = [], offsets = [], kids = [];
    let size = 0, next = 3;
    const push = (part) => {
      const b = typeof part === 'string' ? enc.encode(part) : part;
      chunks.push(b);
      size += b.length;
    };
    const obj = (n, body) => {
      offsets[n] = size;
      push(`${n} 0 obj\n`);
      body();
      push('\nendobj\n');
    };
    push('%PDF-1.4\n%\xE2\xE3\xCF\xD3\n');
    return {
      add(jpg, wPx, hPx, wMm, hMm) {
        const wPt = (wMm / 25.4) * 72, hPt = (hMm / 25.4) * 72;
        const [img, content, pg] = [next, next + 1, next + 2];
        next += 3;
        obj(img, () => {
          push(`<< /Type /XObject /Subtype /Image /Width ${wPx} /Height ${hPx} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${jpg.length} >>\nstream\n`);
          push(jpg);
          push('\nendstream');
        });
        const draw = `q ${wPt.toFixed(2)} 0 0 ${hPt.toFixed(2)} 0 0 cm /Im0 Do Q`;
        obj(content, () => push(`<< /Length ${draw.length} >>\nstream\n${draw}\nendstream`));
        obj(pg, () => push(`<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${wPt.toFixed(2)} ${hPt.toFixed(2)}] /Resources << /XObject << /Im0 ${img} 0 R >> >> /Contents ${content} 0 R >>`));
        kids.push(pg);
      },
      finish(sync) {
        obj(1, () => push('<< /Type /Catalog /Pages 2 0 R >>'));
        obj(2, () => push(`<< /Type /Pages /Kids [${kids.map((i) => `${i} 0 R`).join(' ')}] /Count ${kids.length} >>`));
        const xref = size;
        let table = `xref\n0 ${next}\n0000000000 65535 f \n`;
        for (let i = 1; i < next; i++) table += `${String(offsets[i]).padStart(10, '0')} 00000 n \n`;
        push(table);
        push(`trailer\n<< /Size ${next} /Root 1 0 R >>\nstartxref\n${xref}\n%%EOF\n`);
        if (sync) {
          const all = new Uint8Array(size);
          let o = 0;
          chunks.forEach((c) => {
            all.set(c, o);
            o += c.length;
          });
          return all;
        }
        return new Blob(chunks, { type: 'application/pdf' });
      },
    };
  }

  /**
   * Fichier d'impression du livre (PDF Gelato). key = « rigide-30 »… ; input._hires(i, px) (fiche produit) renvoie la photo i
   * décodée à la bonne définition depuis le fichier d'origine (libérée après usage) ; sinon on imprime input._images.
   */
  async function renderLivrePdf(designKey, input, key, onProgress, sync) {
    const C = LIVRE_COVERS[key];
    const pages = parseInt(key.split('-')[1], 10);
    const d = DESIGNS[designKey];
    const v = values(designKey, input);
    const plan = livrePlan(v, pages);
    const pdf = pdfDoc();
    const total = pages + 3;
    let done = 0;
    const get = async (ref, mm) => (ref && ref.i !== undefined && input._hires ? input._hires(ref.i, lpx(mm)) : livreImg(v, ref));
    const free = (im) => {
      if (input._hires && im && im.close) im.close();
    };
    const sheet = async (wMm, hMm, paint) => {
      const c = document.createElement('canvas');
      c.width = lpx(wMm);
      c.height = lpx(hMm);
      const ctx = c.getContext('2d');
      ctx.scale(c.width / wMm, c.height / hMm);
      ctx.imageSmoothingQuality = 'high';
      await paint(ctx);
      pdf.add(await jpegBytes(c, sync), c.width, c.height, wMm, hMm);
      c.width = c.height = 0;
      done += 1;
      if (onProgress) onProgress(done, total);
    };
    await sheet(C.w, C.h, async (ctx) => {
      const img = await get(plan.cover, C.w - C.from);
      drawLivreCover(ctx, C, img, v, d);
      free(img);
    });
    const blank = (ctx) => {
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, LIVRE_PAGE, LIVRE_PAGE);
    };
    await sheet(LIVRE_PAGE, LIVRE_PAGE, blank);
    for (const page of plan.pages) {
      await sheet(LIVRE_PAGE, LIVRE_PAGE, async (ctx) => {
        const imgs = page.items ? await Promise.all(page.items.map((r) => get(r, page.items.length > 1 ? 90 : 172))) : [];
        drawLivrePage(ctx, page, imgs, v, d);
        imgs.forEach(free);
      });
    }
    await sheet(LIVRE_PAGE, LIVRE_PAGE, blank);
    return pdf.finish(sync);
  }

  /** Aperçu du livre : couverture (face avant, livre posé) ou double page ouverte (spread = 0 : garde + page 1). */
  function drawLivreShot(ctx, W, H, k, design, input, key, view, spread) {
    const d = DESIGNS[design];
    const v = values(design, input);
    const pages = parseInt((key || 'rigide-30').split('-')[1], 10) || 30;
    const plan = livrePlan(v, pages);
    const rigid = /^rigide/.test(key || 'rigide');
    ctx.fillStyle = '#f3eadd';
    ctx.fillRect(0, 0, W, H);
    if (view !== 'pages') {
      const s = H * 0.8, x = (W - s) / 2, y = (H - s) / 2;
      ctx.save();
      ctx.shadowColor = 'rgba(60,40,30,.32)';
      ctx.shadowBlur = 34;
      ctx.shadowOffsetY = 16;
      ctx.fillStyle = rigid ? '#e9e1d6' : '#f6f1ea';
      ctx.fillRect(x + (rigid ? 6 : 3), y + (rigid ? 6 : 3), s, s); // épaisseur du bloc de pages
      ctx.restore();
      const c = document.createElement('canvas');
      c.width = c.height = Math.round(s * k);
      drawLivreFront(c.getContext('2d'), c.width, c.height, v, d, livreImg(v, plan.cover));
      ctx.drawImage(c, x, y, s, s);
      // charnière de la couverture rigide, reflet du pelliculage mat
      const g = ctx.createLinearGradient(x, 0, x + s * 0.06, 0);
      g.addColorStop(0, 'rgba(0,0,0,.18)');
      g.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = g;
      ctx.fillRect(x, y, s * 0.06, s);
      c.width = c.height = 0;
      return;
    }
    // double page : [garde | 1], [2 | 3]… [dernière | garde]
    const list = [null, ...plan.pages, null];
    const left = list[spread * 2], right = list[spread * 2 + 1];
    const ps = Math.min(H * 0.82, (W * 0.9) / 2), x0 = W / 2 - ps, y0 = (H - ps) / 2;
    ctx.save();
    ctx.shadowColor = 'rgba(60,40,30,.28)';
    ctx.shadowBlur = 30;
    ctx.shadowOffsetY = 14;
    ctx.fillStyle = '#fffdf9';
    ctx.fillRect(x0, y0, ps * 2, ps);
    ctx.restore();
    [[left, x0], [right, W / 2]].forEach(([page, x]) => {
      const c = document.createElement('canvas');
      c.width = c.height = Math.round(ps * k);
      const cx = c.getContext('2d');
      cx.scale(c.width / 200, c.height / 200);
      cx.translate(-3, -3); // page rognée (sans le fond perdu)
      if (page) drawLivrePage(cx, page, page.items ? page.items.map((r) => livreImg(v, r)) : [], v, d);
      else {
        cx.fillStyle = '#ffffff';
        cx.fillRect(0, 0, LIVRE_PAGE, LIVRE_PAGE);
      }
      ctx.drawImage(c, x, y0, ps, ps);
      c.width = c.height = 0;
    });
    // pli central
    const g = ctx.createLinearGradient(W / 2 - ps * 0.08, 0, W / 2 + ps * 0.08, 0);
    g.addColorStop(0, 'rgba(0,0,0,0)');
    g.addColorStop(0.5, 'rgba(0,0,0,.16)');
    g.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = g;
    ctx.fillRect(W / 2 - ps * 0.08, y0, ps * 0.16, ps);
  }

  /** Couverture à plat (dos, tranche, face) dans un canvas de largeur donnée : photos des fiches produit. */
  function drawLivreFlat(canvas, design, input, key, width) {
    const C = LIVRE_COVERS[key];
    const v = values(design, input);
    const plan = livrePlan(v, parseInt(key.split('-')[1], 10));
    canvas.width = width;
    canvas.height = Math.round((width * C.h) / C.w);
    const ctx = canvas.getContext('2d');
    ctx.scale(width / C.w, width / C.w);
    drawLivreCover(ctx, C, livreImg(v, plan.cover), v, DESIGNS[design]);
  }

  Object.assign(DESIGNS, {
    'livre-souvenirs': livreOf({ titre: 'Nos plus beaux souvenirs', sous_titre: '2026' }),
    'livre-annee': livreOf({ titre: 'Notre année 2026', sous_titre: 'Famille Martin', font: (z) => `italic ${z}px 'Instrument Serif'`, color: INK, spine: PINE }),
    'livre-bebe': livreOf({ titre: 'Léon', sous_titre: 'Ma première année', spine: '#c9a58f' }),
    'livre-mariage': livreOf({ titre: 'Léa & Tom', sous_titre: '14 juillet 2026', spine: GOLD }),
    'livre-voyage': livreOf({ titre: 'Italie', sous_titre: 'Été 2026', font: (z) => `italic ${z}px 'Instrument Serif'`, color: INK, spine: '#4a6fa5' }),
    'livre-couple': livreOf({ titre: 'Notre histoire', sous_titre: 'Léa & Tom · depuis 2019' }),
  });

  /* ---------- Broderie : designs pensés pour le fil (formes pleines, texte ≥ 6,4 mm, ≤ 6 fils) ---------- */
  // champ « fil » : une couleur de THREADS ou « auto » (fil foncé sur tissu clair, blanc sur tissu foncé)
  const filOf = (v, key, light, dark) => (v[key] && v[key] !== 'auto' ? v[key] : v._dark ? dark : light);
  // polices sans délié fin (un trait de moins de 1 mm ne se brode pas) : Geist 600, Lora 700, Pacifico
  const EMB_FONT = {
    Bâton: (z) => `600 ${z}px 'Geist'`,
    Classique: (z) => `700 ${z}px 'Lora'`,
    Manuscrite: (z) => `${z * 0.8}px 'Pacifico'`,
  };
  // autoLabel : libellé de « auto » quand il ne veut pas dire « assorti au tissu » (2e ligne = même fil que la 1re)
  const FIL = (key, label, def, autoLabel) => ({ key, label, type: 'fil', default: def || 'auto', ...(autoLabel ? { autoLabel } : {}) });
  /** Texte centré qui remplit (w, h) au mieux : renvoie la taille retenue. */
  function fillText(ctx, text, cx, cy, w, h, font, color) {
    let z = h;
    ctx.font = font(z);
    while (z > 4 && ctx.measureText(text).width > w) {
      z *= 0.96;
      ctx.font = font(z);
    }
    ctx.fillStyle = color;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(text, cx, cy);
    return z;
  }
  function embTree(ctx, cx, top, hgt, green, gold) {
    const w = hgt * 0.72;
    ctx.fillStyle = green;
    [[0, 0.42, 0.55], [0.22, 0.7, 0.8], [0.45, 1, 1]].forEach(([y0, y1, ww]) => {
      ctx.beginPath();
      ctx.moveTo(cx, top + hgt * (y0 * 0.9 + 0.08));
      ctx.lineTo(cx + (w * ww) / 2, top + hgt * y1 * 0.86);
      ctx.lineTo(cx - (w * ww) / 2, top + hgt * y1 * 0.86);
      ctx.closePath();
      ctx.fill();
    });
    ctx.fillRect(cx - hgt * 0.07, top + hgt * 0.84, hgt * 0.14, hgt * 0.16);
    star(ctx, cx, top + hgt * 0.07, hgt * 0.09, gold);
  }
  Object.assign(DESIGNS, {
    /* Création libre : 1 ou 2 lignes de texte, police et fils au choix */
    'brode-texte': {
      emb: true,
      fields: [
        { key: 'ligne1', label: 'Votre texte', max: 14, default: 'Léa', hero: true },
        { key: 'ligne2', label: 'Deuxième ligne (facultatif)', max: 20, default: '', optional: true },
        { key: 'police', label: 'Police', type: 'select', options: ['Bâton', 'Classique', 'Manuscrite'], default: 'Classique' },
        FIL('fil', 'Couleur du fil'),
        FIL('fil2', 'Fil de la 2e ligne', 'auto', 'Comme la 1re ligne'),
      ],
      draw(ctx, w, h, v) {
        const font = EMB_FONT[v.police] || EMB_FONT.Classique;
        const c1 = filOf(v, 'fil', '#000000', '#ffffff');
        const c2 = v.fil2 && v.fil2 !== 'auto' ? v.fil2 : c1;
        const l1 = v.police === 'Bâton' ? v.ligne1.toUpperCase() : v.ligne1;
        if (!v.ligne2) {
          fillText(ctx, l1, w / 2, h * 0.52, w * 0.98, h * 0.86, font, c1);
        } else {
          fillText(ctx, l1, w / 2, h * 0.36, w * 0.98, h * 0.62, font, c1);
          // 2e ligne toujours en capitales bâton : une petite écriture manuscrite ne se brode pas lisiblement
          fillText(ctx, v.ligne2.toUpperCase(), w / 2, h * 0.84, w * 0.9, h * 0.25, EMB_FONT.Bâton, c2);
        }
      },
    },
    /* Initiales (1 à 3 lettres), séparées ou non par un point ou un cœur */
    'brode-initiales': {
      emb: true,
      fields: [
        { key: 'initiales', label: 'Initiales', max: 3, default: 'LT', hero: true },
        { key: 'separateur', label: 'Entre les lettres', type: 'select', options: ['Rien', 'Point', 'Cœur'], default: 'Point' },
        { key: 'police', label: 'Police', type: 'select', options: ['Classique', 'Bâton'], default: 'Classique' },
        FIL('fil', 'Couleur du fil'),
        FIL('fil2', 'Fil du séparateur', '#cb333b'),
      ],
      draw(ctx, w, h, v) {
        const font = EMB_FONT[v.police] || EMB_FONT.Classique;
        const c1 = filOf(v, 'fil', '#000000', '#ffffff');
        const c2 = filOf(v, 'fil2', '#cb333b', '#cb333b');
        const letters = [...v.initiales.toUpperCase().replace(/\s+/g, '')].slice(0, 3);
        if (v.separateur === 'Rien' || letters.length < 2) {
          fillText(ctx, letters.join(''), w / 2, h * 0.54, w * 0.9, h * 0.9, font, c1);
          return;
        }
        const n = letters.length, gap = h * 0.24, cell = Math.min(h * 0.8, (w * 0.9 - gap * (n - 1)) / n);
        const x0 = w / 2 - (cell * n + gap * (n - 1)) / 2;
        letters.forEach((l, i) => {
          const cx = x0 + cell / 2 + i * (cell + gap);
          fillText(ctx, l, cx, h * 0.54, cell, h * 0.9, font, c1);
          if (i < n - 1) {
            const sx = cx + cell / 2 + gap / 2;
            if (v.separateur === 'Cœur') heart(ctx, sx, h * 0.56, h * 0.11, c2);
            else {
              ctx.fillStyle = c2;
              ctx.beginPath();
              ctx.arc(sx, h * 0.72, h * 0.06, 0, Math.PI * 2);
              ctx.fill();
            }
          }
        });
      },
    },
    /* Cœur + prénom */
    'brode-coeur': {
      emb: true,
      fields: [
        { key: 'prenom', label: 'Prénom', max: 12, default: 'Léa', hero: true },
        { key: 'police', label: 'Police', type: 'select', options: ['Classique', 'Bâton', 'Manuscrite'], default: 'Manuscrite' },
        FIL('fil', 'Fil du prénom'),
        FIL('fil2', 'Fil du cœur', '#cb333b'),
      ],
      draw(ctx, w, h, v) {
        const font = EMB_FONT[v.police] || EMB_FONT.Manuscrite;
        const c1 = filOf(v, 'fil', '#000000', '#ffffff');
        const c2 = filOf(v, 'fil2', '#cb333b', '#cb333b');
        heart(ctx, h * 0.34, h * 0.52, h * 0.3, c2);
        const txt = v.police === 'Bâton' ? v.prenom.toUpperCase() : v.prenom;
        fillText(ctx, txt, h * 0.72 + (w - h * 0.72) / 2, h * 0.54, w - h * 0.78, h * 0.82, font, c1);
      },
    },
    /* « Papa » / « Papy » / « Mamie »… + une ligne (depuis 2019, 2026…) */
    'brode-titre': {
      emb: true,
      fields: [
        { key: 'titre', label: 'Titre', max: 10, default: 'Papa', hero: true },
        { key: 'ligne', label: 'Ligne du dessous', max: 16, default: 'depuis 2019', optional: true },
        { key: 'police', label: 'Police', type: 'select', options: ['Manuscrite', 'Classique', 'Bâton'], default: 'Manuscrite' },
        FIL('fil', 'Fil du titre'),
        FIL('fil2', 'Fil de la ligne', '#cb333b'),
      ],
      draw(ctx, w, h, v) {
        const font = EMB_FONT[v.police] || EMB_FONT.Manuscrite;
        const c1 = filOf(v, 'fil', '#000000', '#ffffff');
        const c2 = filOf(v, 'fil2', '#cb333b', '#ffffff'); // « assorti » : rouge sur tissu clair, blanc sur foncé
        const titre = v.police === 'Bâton' ? v.titre.toUpperCase() : v.titre;
        if (!v.ligne) {
          fillText(ctx, titre, w / 2, h * 0.52, w * 0.96, h * 0.9, font, c1);
          return;
        }
        fillText(ctx, titre, w / 2, h * 0.34, w * 0.96, h * 0.64, font, c1);
        // ligne du dessous : capitales d'au moins 6,4 mm (25 % de la hauteur)
        fillText(ctx, v.ligne.toUpperCase(), w / 2, h * 0.85, w * 0.9, h * 0.25, EMB_FONT.Bâton, c2);
      },
    },
    /* Petit sapin + prénom (Noël) */
    'brode-sapin': {
      emb: true,
      fields: [
        { key: 'prenom', label: 'Prénom', max: 12, default: 'Léo', hero: true },
        { key: 'police', label: 'Police', type: 'select', options: ['Manuscrite', 'Classique', 'Bâton'], default: 'Manuscrite' },
        FIL('fil', 'Fil du prénom'),
        FIL('fil2', 'Fil du sapin', '#41894b'),
      ],
      draw(ctx, w, h, v) {
        const font = EMB_FONT[v.police] || EMB_FONT.Manuscrite;
        const c1 = filOf(v, 'fil', '#000000', '#ffffff');
        const c2 = filOf(v, 'fil2', '#41894b', '#7ca45b');
        embTree(ctx, h * 0.38, h * 0.04, h * 0.92, c2, '#ffcd01');
        const txt = v.police === 'Bâton' ? v.prenom.toUpperCase() : v.prenom;
        fillText(ctx, txt, h * 0.8 + (w - h * 0.8) / 2, h * 0.56, w - h * 0.86, h * 0.8, font, c1);
      },
    },
    /* Animal : patte + « Maman de » + nom */
    'brode-animal': {
      emb: true,
      fields: [
        { key: 'nom', label: 'Nom de l’animal', max: 12, default: 'Rocky', hero: true },
        { key: 'ligne', label: 'Au-dessus du nom', max: 14, default: 'Maman de', optional: true },
        { key: 'police', label: 'Police du nom', type: 'select', options: ['Manuscrite', 'Classique', 'Bâton'], default: 'Manuscrite' },
        FIL('fil', 'Fil du texte'),
        FIL('fil2', 'Fil de la patte', '#a57742'),
      ],
      draw(ctx, w, h, v) {
        const font = EMB_FONT[v.police] || EMB_FONT.Manuscrite;
        const c1 = filOf(v, 'fil', '#000000', '#ffffff');
        const c2 = filOf(v, 'fil2', '#a57742', '#a57742');
        paw(ctx, h * 0.36, h * 0.48, h * 0.62, c2, -0.25);
        const x0 = h * 0.8, cw = w - x0, cx = x0 + cw / 2;
        const nom = v.police === 'Bâton' ? v.nom.toUpperCase() : v.nom;
        if (!v.ligne) {
          fillText(ctx, nom, cx, h * 0.54, cw * 0.98, h * 0.82, font, c1);
          return;
        }
        fillText(ctx, v.ligne.toUpperCase(), cx, h * 0.16, cw * 0.94, h * 0.25, EMB_FONT.Bâton, c1);
        fillText(ctx, nom, cx, h * 0.64, cw * 0.98, h * 0.62, font, c1);
      },
    },
    /* Votre logo ou votre dessin : couleurs ramenées aux fils (6 au plus) */
    'brode-logo': {
      emb: true,
      fields: [
        { key: 'photo', label: 'Votre logo ou dessin', type: 'image', default: '', hint: 'PNG à fond transparent de préférence ; les couleurs sont ramenées aux fils disponibles (6 au plus).' },
      ],
      draw(ctx, w, h, v) {
        if (v._image) {
          drawArt(ctx, v._image, 0, 0, w, h);
        } else {
          ctx.fillStyle = v._dark ? '#ffffff' : '#000000';
          fillText(ctx, 'VOTRE LOGO', w / 2, h * 0.52, w * 0.9, h * 0.5, EMB_FONT.Bâton, v._dark ? '#ffffff' : '#000000');
        }
      },
    },
  });

  window.IdeoDesigns = { THREADS, threadify, DESIGNS, FORMATS, values, drawFace, drawShot, renderPrint, renderPage, renderPdf, fontsReady, prepare,
    renderLivrePdf, livrePlan, livreRange, drawLivreFlat, LIVRE_COVERS };
})();
